/**
 *  ===========================================================================
 * @tencent/aegis-web-sdk@1.43.51 (c) 2026 TencentCloud Real User Monitoring.
 * Author pumpkincai.
 * Last Release Time Fri Feb 06 2026 16:12:03 GMT+0800 (GMT+08:00).
 * Released under the MIT License.
 * Thanks for supporting RUM & Aegis!
 * ===========================================================================
 **/ ((A, e)=>{
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (A = "undefined" != typeof globalThis ? globalThis : A || self).Aegis = e();
})(this, function() {
    var K, x;
    function D(A) {
        this.name = "__st" + (1e9 * Math.random() >>> 0) + K + "__", null != A && A.forEach(this.add, this), K += 1;
    }
    Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
        configurable: !0,
        writable: !0,
        value: function(A) {
            if (null === this) throw new TypeError('"this" is null or not defined');
            var e = Object(this), t = e.length >>> 0;
            if ("function" != typeof A) throw new TypeError("predicate must be a function");
            for(var n = arguments[1], r = 0; r < t;){
                var o = e[r];
                if (A.call(n, o, r, e)) return o;
                r += 1;
            }
        }
    }), window.WeakSet || (K = Date.now() % 1e9, D.prototype.add = function(A) {
        var e = this.name;
        return A[e] || Object.defineProperty(A, e, {
            value: !0,
            writable: !0
        }), this;
    }, D.prototype.delete = function(A) {
        return !!A[this.name] && (A[this.name] = void 0, true);
    }, D.prototype.has = function(A) {
        return !!A[this.name];
    }, x = D, Object.defineProperty(window, "WeakSet", {
        value: function(A) {
            return new x(A);
        }
    })), Object.assign || Object.defineProperty(Object, "assign", {
        enumerable: !1,
        configurable: !0,
        writable: !0,
        value: function(A) {
            if (null == A) throw new TypeError("Cannot convert first argument to object");
            for(var e = Object(A), t = 1; t < arguments.length; t++)if (null != (n = arguments[t])) for(var n = Object(n), r = Object.keys(Object(n)), o = 0, i = r.length; o < i; o++){
                var s = r[o], a = Object.getOwnPropertyDescriptor(n, s);
                null != a && a.enumerable && (e[s] = n[s]);
            }
            return e;
        }
    });
    var R = function(A, e) {
        return (R = Object.setPrototypeOf || (({
            __proto__: []
        }) instanceof Array ? function(A, e) {
            A.__proto__ = e;
        } : function(A, e) {
            for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
        }))(A, e);
    }, q = function() {
        return (q = Object.assign || function(A) {
            for(var e, t = 1, n = arguments.length; t < n; t++)for(var r in e = arguments[t])Object.prototype.hasOwnProperty.call(e, r) && (A[r] = e[r]);
            return A;
        }).apply(this, arguments);
    };
    function z(A, i, s, a) {
        return new (s = s || Promise)(function(t, e) {
            function n(A) {
                try {
                    o(a.next(A));
                } catch (A) {
                    e(A);
                }
            }
            function r(A) {
                try {
                    o(a.throw(A));
                } catch (A) {
                    e(A);
                }
            }
            function o(A) {
                var e;
                A.done ? t(A.value) : ((e = A.value) instanceof s ? e : new s(function(A) {
                    A(e);
                })).then(n, r);
            }
            o((a = a.apply(A, i || [])).next());
        });
    }
    function $(n, r) {
        var o, i, s, a = {
            label: 0,
            sent: function() {
                if (1 & s[0]) throw s[1];
                return s[1];
            },
            trys: [],
            ops: []
        }, A = {
            next: e(0),
            throw: e(1),
            return: e(2)
        };
        return "function" == typeof Symbol && (A[Symbol.iterator] = function() {
            return this;
        }), A;
        function e(t) {
            return function(A) {
                var e = [
                    t,
                    A
                ];
                if (o) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (o = 1, i && (s = 2 & e[0] ? i.return : e[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, e[1])).done) return s;
                    switch(i = 0, (e = s ? [
                        2 & e[0],
                        s.value
                    ] : e)[0]){
                        case 0:
                        case 1:
                            s = e;
                            break;
                        case 4:
                            return a.label++, {
                                value: e[1],
                                done: !1
                            };
                        case 5:
                            a.label++, i = e[1], e = [
                                0
                            ];
                            continue;
                        case 7:
                            e = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!((s = 0 < (s = a.trys).length && s[s.length - 1]) || 6 !== e[0] && 2 !== e[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === e[0] && (!s || e[1] > s[0] && e[1] < s[3])) a.label = e[1];
                            else if (6 === e[0] && a.label < s[1]) a.label = s[1], s = e;
                            else {
                                if (!(s && a.label < s[2])) {
                                    s[2] && a.ops.pop(), a.trys.pop();
                                    continue;
                                }
                                a.label = s[2], a.ops.push(e);
                            }
                    }
                    e = r.call(n, a);
                } catch (A) {
                    e = [
                        6,
                        A
                    ], i = 0;
                } finally{
                    o = s = 0;
                }
                if (5 & e[0]) throw e[1];
                return {
                    value: e[0] ? e[1] : void 0,
                    done: !0
                };
            };
        }
    }
    function M() {
        for(var A = 0, e = 0, t = arguments.length; e < t; e++)A += arguments[e].length;
        for(var n = Array(A), r = 0, e = 0; e < t; e++)for(var o = arguments[e], i = 0, s = o.length; i < s; i++, r++)n[r] = o[i];
        return n;
    }
    var j, d, B, P = /_?t(\d)?(imestamp)?=\d+&?/g, k = [
        "aegis.qq.com",
        "tamaegis.com",
        "/aegis-sdk",
        "rumt-",
        "/flog.core.min.js",
        "pingfore.qq.com",
        "pingfore.tencent.com",
        "zhiyan.tencent-cloud.net",
        "h.trace.qq.com",
        "btrace.qq.com",
        "beacon.qq.com",
        "dmplog.qq.com",
        "qq.com/report",
        "svibeacon.onezapp.com",
        "cube.weixinbridge.com",
        "doubleclick.net",
        "pcmgrmonitor.3g.qq.com",
        "tdm.qq.com",
        "report.qqweb.qq.com",
        "tpstelemetry.tencent.com",
        "galileotelemetry.tencent.com",
        "insight.cloud.tencent.com",
        "facebook.com",
        "facebook.net",
        "google",
        "yahoo.com",
        "twitter.com",
        "ga-audiences",
        "report.idqqimg.com",
        "arms-retcode.aliyuncs.com",
        "px.effirst.com",
        "sentry",
        "baidu.com",
        "hot-update.json",
        "u.c.b.r.o.w.s.e.r",
        "report.url.cn",
        "sockjs-node",
        "m3u8",
        "flv"
    ], G = [
        "ResizeObserver loop limit exceeded",
        "ResizeObserver loop completed",
        "Failed to execute 'transaction'",
        "window.indexedDB.deleteDatabase is not a function"
    ], N = [
        "ext1",
        "ext2",
        "ext3",
        "ext4",
        "ext5",
        "ext6",
        "ext7",
        "ext8",
        "ext9",
        "ext10",
        "level",
        "trace",
        "tag",
        "seq",
        "code"
    ], V = [
        "static",
        "fetch"
    ], m = "unknown";
    (A = j = j || {}).INFO_ALL = "-1", A.API_RESPONSE = "1", A.INFO = "2", A.ERROR = "4", A.PROMISE_ERROR = "8", A.AJAX_ERROR = "16", A.SCRIPT_ERROR = "32", A.IMAGE_ERROR = "64", A.CSS_ERROR = "128", A.CONSOLE_ERROR = "256", A.MEDIA_ERROR = "512", A.RET_ERROR = "1024", A.PAGE_LOAD = "1025", A.SLOW_PAGE_LOAD = "1026", A.SLOW_NET_REQUEST = "1027", A.ASSERT_REQUEST = "1028", A.SLOW_ASSET_REQUEST = "1029", A.CLICK_EVENT = "1030", A.CONSOLE_LOG = "1031", A.BLANK_SCREEN = "1032", A.MEMORY_OOM = "1033", A.LAG_MONITOR = "1034", A.NORESPONSE_LOG = "1035", A.REPORT = "2048", A.PV = "4096", A.EVENT = "8192", A.SPEED_EVENT = "8193", A.PAGE_NOT_FOUND_ERROR = "16384", A.WEBSOCKET_ERROR = "32768", A.BRIDGE_ERROR = "65536", A.LAZY_LOAD_ERROR = "131072", (A = d = d || {}).LOG = "log", A.SPEED = "speed", A.PERFORMANCE = "performance", A.OFFLINE = "offline", A.WHITE_LIST = "whiteList", A.VITALS = "vitals", A.PV = "pv", A.CUSTOM_PV = "customPV", A.EVENT = "event", A.CUSTOM = "custom", A.SDK_ERROR = "sdkError", A.SET_DATA = "setData", A.LOAD_PACKAGE = "loadPackage", A.MEMORY = "memory", (A = B = B || {}).production = "production", A.development = "development", A.gray = "gray", A.pre = "pre", A.daily = "daily", A.local = "local", A.test = "test", A.others = "others";
    _.prototype.indexOf = function(A, e) {
        for(var t = 0; t < A.length; t++)if (A[t].callback === e) return t;
        return -1;
    }, _.prototype.on = function(A, e, t) {
        var n;
        if (void 0 === t && (t = 0), this) return (n = this.eventsList[A]) || (this.eventsList[A] = [], n = this.eventsList[A]), -1 === this.indexOf(n, e) && n.push({
            name: A,
            type: t || 0,
            callback: e
        }), this;
    }, _.prototype.one = function(A, e) {
        this.on(A, e, 1);
    }, _.prototype.remove = function(A, e) {
        if (this) {
            var t = this.eventsList[A];
            if (t) {
                if (e) return t.length && (e = this.indexOf(t, e), t.splice(e, 1)), this;
                try {
                    delete this.eventsList[A];
                } catch (A) {}
            }
            return null;
        }
    }, _.prototype.clear = function() {
        this.eventsList = {};
    };
    var X, J = _, W = function(A) {
        if (!A || 0 === A.length) return "{}";
        A = Array.isArray(A) ? A : [
            A
        ];
        var e = Array.from(new Set(A.flatMap(function(A) {
            return Object.keys(A);
        }))), t = {};
        return e.forEach(function(e) {
            t[e] = A.map(function(A) {
                return A[e] || "";
            });
        }), t.count = A.length, fA(t);
    };
    function _() {
        var i = this;
        this.emit = function(A, e) {
            if (i) {
                var t;
                if (null != (n = i.eventsList[A]) && n.length) for(var n = n.slice(), r = 0; r < n.length; r++){
                    t = n[r];
                    try {
                        var o = t.callback.apply(i, [
                            e
                        ]);
                        if (1 === t.type && i.remove(A, t.callback), !1 === o) break;
                    } catch (A) {
                        throw A;
                    }
                }
                return i;
            }
        }, this.eventsList = {};
    }
    (A = X = X || {})[A.number = -1] = "number", A.string = "";
    function Y(A, e) {
        return "number" == typeof A || "string" == typeof A ? A : e ? X.string : X.number;
    }
    function Z(A, e) {
        return "string" == typeof A ? A.split("?")[e ? 1 : 0] || "" : A;
    }
    function AA(A, e) {
        return void 0 === e && (e = 2048), String(A).replace(P, "").slice(0, e);
    }
    function eA(A) {
        return "string" == typeof A && /^\//.test(A) ? "https:" === (null == location ? void 0 : location.protocol) : /^https/.test(A);
    }
    function tA(A, e, t) {
        var n, r, o;
        try {
            if ("function" == typeof (null == e ? void 0 : e.retCodeHandler)) return {
                code: void 0 === (o = (r = e.retCodeHandler(A, null == t ? void 0 : t.url, null == t ? void 0 : t.ctx, null == t ? void 0 : t.payload) || {}).code) ? m : o,
                isErr: r.isErr
            };
            if (!(A = "string" == typeof A ? JSON.parse(A) : A)) return {
                code: m,
                isErr: !1
            };
            "function" == typeof (null == (n = null == e ? void 0 : e.ret) ? void 0 : n.join) && (wA = [].concat(e.ret.map(function(A) {
                return A.toLowerCase();
            })));
            var i = Object.getOwnPropertyNames(A).filter(function(A) {
                return -1 !== wA.indexOf(A.toLowerCase());
            });
            return i.length ? {
                code: "" + (o = "\u672A\u77E5" !== (o = A[i[0]]) && "" !== o ? o : m),
                isErr: 0 !== o && "0" !== o && o !== m
            } : {
                code: m,
                isErr: !1
            };
        } catch (A) {
            return {
                code: m,
                isErr: !1
            };
        }
    }
    function nA(A, e, t) {
        try {
            var n = "function" == typeof e ? e(A, null == t ? void 0 : t.url, null == t ? void 0 : t.ctx) || "" : A;
            return QA(n).slice(0, 10240);
        } catch (A) {
            return "";
        }
    }
    function rA(A, e) {
        var t, n = {
            fetch: [],
            static: [],
            bridge: []
        }, r = new FormData;
        return Array.isArray(A) ? A.forEach(function(A) {
            var e = UA(A);
            n[A.type].push(e);
        }) : (t = UA(A), n[A.type].push(t)), r.append("payload", fA(q({
            duration: n
        }, e))), r;
    }
    function oA(e, A) {
        return "string" != typeof e || !e || A && -1 < e.indexOf(A) || FA.test(e) || k.some(function(A) {
            return -1 < e.indexOf(A);
        });
    }
    function iA(t, n) {
        var r, o = [], i = t.config;
        return t.lifeCycle.on("destroy", function() {
            o.length = 0;
        }), function(A, e) {
            Array.isArray(A) ? o = o.concat(A) : o.push(A), n && o.length >= n || t.sendNow && 0 < o.length ? (o = mA(o), 0 < (o = Array.isArray(o) ? o : []).length && e(o.splice(0, o.length)), r && clearTimeout(r)) : (r && clearTimeout(r), r = setTimeout(function() {
                r = null, o = mA(o), 0 < (o = Array.isArray(o) ? o : []).length && e(o.splice(0, o.length));
            }, i.delay));
        };
    }
    function sA(A, e) {
        return Array.isArray(A) ? e(A.map(function(A) {
            var e;
            return e = q(q({}, A), {
                msg: "string" == typeof A.msg ? A.msg : [].concat(A.msg).map(hA).join(" ")
            }), N.forEach(function(A) {
                e[A] || delete e[A];
            }), e;
        })) : e([
            q(q({}, A), {
                msg: "string" == typeof A.msg ? A.msg : hA(A.msg)
            })
        ]);
    }
    function aA(a, c) {
        return function(r, o) {
            var n, i, s, A, e, t;
            null != r && r.log && null != r && r.type ? (n = function(A, e) {
                var t, n, e = q(q({}, a.bean), {
                    from: e
                }), r = q({}, a.bean);
                return (()=>{
                    try {
                        return "undefined" != typeof FormData && "function" == typeof FormData.prototype.append;
                    } catch (A) {}
                })() ? rA(A, e) : (e = A, A = r, n = {
                    fetch: [],
                    static: [],
                    bridge: []
                }, r = {}, Array.isArray(e) ? e.forEach(function(A) {
                    var e;
                    null != (e = n[A.type]) && e.push(A);
                }) : null != (t = n[e.type]) && t.push(e), r.payload = JSON.stringify(q({
                    duration: n
                }, A)), r);
            }, i = function(A, e, t) {
                switch(e){
                    case d.LOG:
                        return W(IA(A));
                    case d.SPEED:
                        return n(A, t);
                    case d.EVENT:
                        return fA({
                            payload: fA(A)
                        });
                    case d.CUSTOM:
                        return fA({
                            payload: fA({
                                custom: A
                            })
                        });
                    default:
                        return {};
                }
            }, 1 !== (A = Array.isArray(r.log) ? r.log : [
                r.log
            ]).length ? (s = {}, A.forEach(function(A) {
                var e = A.from || "undefined";
                delete A.from, s[e] || (s[e] = []), s[e].push(A);
            }), Object.keys(s).forEach(function(A) {
                var e, t = s[A], n = null != (n = r.url) && n.includes("?") ? "&" : "?";
                "undefined" === A ? (e = "" + r.url, o(q(q({}, r), {
                    url: e,
                    log: 1 === t.length ? t[0] : t,
                    data: i(t, c, A)
                }))) : (e = r.url + n + "from=" + A, o(q(q({}, r), {
                    url: e,
                    log: 1 === t.length ? t[0] : t,
                    beanFilter: M(r.beanFilter || [], [
                        "from"
                    ]),
                    data: i(t, c, A)
                })));
            })) : (e = (A = A[0]).from, delete A.from, t = null != (t = r.url) && t.includes("?") ? "&" : "?", e ? (t = r.url + t + "from=" + e, o(q(q({}, r), {
                url: t,
                log: A,
                beanFilter: M(r.beanFilter || [], [
                    "from"
                ]),
                data: i(A, c, e)
            }))) : (t = "" + r.url, o(q(q({}, r), {
                url: t,
                log: A
            }))))) : o(r);
        };
    }
    function cA(a, c) {
        return function(A, e) {
            var t, n, r, o = Array.isArray(A), i = o ? A : [
                A
            ], s = (a.lifeCycle.emit("beforeRequest", A), a.config.beforeRequest);
            (i = "function" == typeof s ? i.map(function(e) {
                try {
                    var A = s({
                        logs: e,
                        logType: c
                    });
                    return (null == A ? void 0 : A.logType) === c && null != A && A.logs ? A.logs : !1 !== A && e;
                } catch (A) {
                    return e;
                }
            }).filter(function(A) {
                return !1 !== A;
            }) : i).length && (t = i, A = N, !Array.isArray(t) || t.length <= 1 || (n = [], r = [], !(r = "string" == typeof A ? [
                A
            ] : A)) || r.length <= 0 || (r.forEach(function(e) {
                t.forEach(function(A) {
                    null != A && A[e] && n.push(e);
                });
            }), 0 < n.length && (t = t.map(function(A) {
                var e = {};
                return n.forEach(function(A) {
                    e[A] = "";
                }), q(q({}, e), A);
            }))), i = t, e(o ? i : i[0]));
        };
    }
    function BA(r) {
        return function(A, e) {
            r.lifeCycle.emit("modifyRequest", A);
            var t = r.config.modifyRequest;
            if ("function" == typeof t) try {
                var n = t(A);
                "object" == typeof n && "url" in n && (A = n);
            } catch (A) {
                console.error(A);
            }
            e(A);
        };
    }
    function lA(n) {
        return function(A, e) {
            null != (t = n.lifeCycle) && t.emit("afterRequest", A);
            var t = (n.config || {}).afterRequest;
            "function" == typeof t && !1 === t(A) || e(A);
        };
    }
    var uA = [
        "application/xhtml+xml",
        "application/xml",
        "application/pdf",
        "application/pkcs12",
        "application/javascript",
        "application/x-javascript",
        "application/ecmascript",
        "application/vnd.mspowerpoint",
        "application/vnd.apple.mpegurl",
        "application/ogg",
        "text/css",
        "text/javascript",
        "image",
        "audio",
        "video",
        "video/mp2t"
    ], gA = /\.(json|js|css|jpg|jpeg|png|svg|apng|webp|gif|bmp|mp4|mp3|ts|mpeg|wav|webm|ogg|flv|m3u8|ttf|woff2|otf|eot|woff|html|htm|shtml|shtm|)$/i, wA = [
        "ret",
        "retcode",
        "code",
        "errcode"
    ], dA = function() {
        var t = new WeakSet;
        return function(A, e) {
            if (e instanceof Error) return "Error.message: " + e.message + " \n  Error.stack: " + e.stack;
            if ("object" == typeof e && null !== e) {
                if (t.has(e)) return "[Circular " + (A || "root") + "]";
                t.add(e);
            }
            return e;
        };
    }, hA = function(A) {
        if ("string" == typeof A) return A;
        try {
            return A instanceof Error ? (JSON.stringify(A, dA(), 2) || "undefined").replace(/"/gim, "") : JSON.stringify(A, dA(), 2) || "undefined";
        } catch (A) {
            return "error happen when aegis stringify: \n " + A.message + " \n " + A.stack;
        }
    }, fA = function(A) {
        if ("string" == typeof A) return A;
        try {
            return JSON.stringify(A, dA()) || "undefined";
        } catch (A) {
            return "error happen when aegis stringify: \n " + A.message + " \n " + A.stack;
        }
    }, QA = function(t, n) {
        void 0 === n && (n = 3);
        var r, o, i, s = "";
        return Array.isArray(t) ? (s += "[", r = t.length, t.forEach(function(A, e) {
            s = (s += "object" == typeof A && 1 < n ? QA(A, n - 1) : CA(A)) + (e === r - 1 ? "" : ",");
        }), s += "]") : t instanceof Object || "object" == typeof t ? (s = "{", o = Object.keys(t), i = o.length, o.forEach(function(A, e) {
            "object" == typeof t[A] && 1 < n ? s += '"' + A + '":' + QA(t[A], n - 1) : s += pA(A, t[A]), s += e === i - 1 || e < i - 1 && void 0 === t[o[e + 1]] ? "" : ",";
        }), s += "}") : s += t, s;
    }, pA = function(A, e) {
        var t = typeof e, n = "";
        return "string" == t || "object" == t ? n += '"' + A + '":"' + e + '"' : "function" == typeof e ? n += '"' + A + '":"function ' + e.name + '"' : "symbol" == typeof e ? n += '"' + A + '":"symbol"' : "number" != typeof e && "boolean" != t || (n += '"' + A + '": ' + e), n;
    }, CA = function(A) {
        var e = typeof A;
        return "" + ("undefined" == e || "symbol" == e || "function" == e ? "null" : "string" == e || "object" == e ? '"' + A + '"' : A);
    }, UA = function(e) {
        var t;
        return e.payload ? (t = {}, Object.keys(e).forEach(function(A) {
            "payload" !== A && (t[A] = e[A]);
        }), t) : e;
    }, FA = /data:(image|text|application|font)\/.*;base64/, mA = function(A) {
        return A.filter(function(t, n) {
            return "static" !== t.type || !A.find(function(A, e) {
                return t.url === A.url && 200 === t.status && n < e;
            });
        });
    }, yA = function(A) {
        A.level === j.INFO_ALL && (A.level = j.INFO);
    }, EA = {}, HA = {}, vA = function(A) {
        return EA[A] || (EA[A] = setTimeout(function() {
            HA[A] = {}, EA[A] = null;
        }, 6e4)), EA[A];
    }, IA = function(A) {
        return (Array.isArray(A) ? A : [
            A
        ]).map(function(t) {
            return Object.getOwnPropertyNames(t).reduce(function(A, e) {
                return "ctx" !== e && (A[e] = t[e]), A;
            }, {
                level: j.INFO,
                msg: ""
            });
        });
    }, bA = function(n) {
        return function(A) {
            return n.sendPipeline([
                function(A, t) {
                    return t({
                        url: n.config.url || "",
                        data: W(IA(A)),
                        method: "post",
                        contentType: "application/json",
                        type: d.LOG,
                        log: A,
                        requestConfig: {
                            timeout: 5e3
                        },
                        success: function() {
                            var e = n.config.onReport;
                            "function" == typeof e && A.forEach(function(A) {
                                e(A);
                            }), "function" == typeof t && t([]);
                        }
                    });
                }
            ], d.LOG)(A);
        };
    }, LA = {
        generateTraceId: SA(16),
        generateSpanId: SA(8)
    }, KA = Array(32);
    function SA(e) {
        return function() {
            for(var A = 0; A < 2 * e; A++)KA[A] = Math.floor(16 * Math.random()) + 48, 58 <= KA[A] && (KA[A] += 39);
            return String.fromCharCode.apply(null, KA.slice(0, 2 * e));
        };
    }
    function TA() {
        return "10000000100040008000100000000000".replace(/[018]/g, function(A) {
            return (A ^ (16 * Math.random() & 15) >> A / 4).toString(16);
        });
    }
    function OA() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(A) {
            var e = 16 * Math.random() | 0;
            return ("x" === A ? e : 3 & e | 8).toString(16);
        });
    }
    function xA(A) {
        for(var e, t, n, r = "", o = 0, i = (A = String(A)).length % 3; o < A.length;){
            if (255 < (e = A.charCodeAt(o++)) || 255 < (t = A.charCodeAt(o++)) || 255 < (n = A.charCodeAt(o++))) throw new TypeError("Failed to execute 'btoa': The string to be encoded contains characters outside of the Latin1 range.");
            r += NA.charAt((e = e << 16 | t << 8 | n) >> 18 & 63) + NA.charAt(e >> 12 & 63) + NA.charAt(e >> 6 & 63) + NA.charAt(63 & e);
        }
        return i ? r.slice(0, i - 3) + "===".substring(i) : r;
    }
    function DA(A) {
        if (A = String(A).replace(/[\t\n\f\r ]+/g, ""), !VA.test(A)) throw new TypeError("Failed to execute 'atob': The string to be decoded is not correctly encoded.");
        var e;
        A += "==".slice(2 - (3 & A.length));
        for(var t, n, r = "", o = 0; o < A.length;)e = NA.indexOf(A.charAt(o++)) << 18 | NA.indexOf(A.charAt(o++)) << 12 | (t = NA.indexOf(A.charAt(o++))) << 6 | (n = NA.indexOf(A.charAt(o++))), r += 64 === t ? String.fromCharCode(e >> 16 & 255) : 64 === n ? String.fromCharCode(e >> 16 & 255, e >> 8 & 255) : String.fromCharCode(e >> 16 & 255, e >> 8 & 255, 255 & e);
        return r;
    }
    function RA(A) {
        var e, t = "";
        return t = "object" == typeof A && (e = (A = ((A, e)=>{
            for(var t = 0; t < e.length; t++){
                var n = e[t], r = A[n] || "function" == typeof A.get && A.get(n);
                if (r) return [
                    n,
                    r
                ];
            }
            return [
                "",
                ""
            ];
        })(A, Object.keys(JA)))[0]) ? JA[e](A[1]) : t;
    }
    function MA(t) {
        if (t && t.reduce && t.length) return 1 === t.length ? function(A, e) {
            t[0](A, e || WA);
        } : t.reduce(function(t, n) {
            return function(A, e) {
                return void 0 === e && (e = WA), t(A, function(A) {
                    return null == n ? void 0 : n(A, e);
                });
            };
        });
        throw new TypeError("createPipeline need at least one function param");
    }
    function PA(e, t) {
        Object.getOwnPropertyNames(e).forEach(function(A) {
            "function" == typeof e[A] && "constructor" !== A && (t ? t[A] = "sendPipeline" === A ? function() {
                return function() {};
            } : function() {} : e[A] = function() {});
        });
    }
    function kA() {
        return void 0 !== window.performance && "function" == typeof performance.getEntriesByType && "function" == typeof performance.now;
    }
    function GA(A) {
        var e;
        return -1 < (null == (e = null == (e = window.PerformanceObserver) ? void 0 : e.supportedEntryTypes) ? void 0 : e.indexOf(A));
    }
    function e(A) {
        return -1 !== qA.indexOf(A);
    }
    var NA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", VA = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, XA = (zA.prototype.generate = function(A, e, t) {
        if (void 0 === e && (e = {}), this.url = A, !this.isUrlIgnored() && this.isUrlInTraceUrls() && this.traceType) {
            switch(this.traceType){
                case "traceparent":
                    this.traceId = this.createTraceparent();
                    break;
                case "b3":
                    this.traceId = this.createB3();
                    break;
                case "sw8":
                    this.traceId = this.createSw8(t);
                    break;
                case "sentry-trace":
                    this.traceId = this.createSentryTrace();
                    break;
                default:
                    return console.warn("this trace key " + this.traceType + " is not supported"), void (this.traceId = "");
            }
            return e[this.traceType] && (this.traceId = e[this.traceType]), {
                name: this.traceType,
                value: this.traceId
            };
        }
    }, zA.prototype.createTraceparent = function() {
        var A = LA.generateSpanId();
        return "00-" + LA.generateTraceId() + "-" + A + "-0" + this.traceFlag.toString(16);
    }, zA.prototype.createB3 = function() {
        var A = LA.generateSpanId();
        return LA.generateTraceId() + "-" + A + "-" + this.traceFlag;
    }, zA.prototype.createSw8 = function(A) {
        var e = "function" == typeof btoa ? btoa : xA, A = A || {}, t = A.host, t = void 0 === t ? "" : t, A = A.pathname, A = void 0 === A ? "" : A, n = OA(), r = OA();
        return "1-" + String(e(r)) + "-" + String(e(n)) + "-1-" + String(e("aegis")) + "-" + String(e("1.43.51")) + "-" + String(e(encodeURI(A))) + "-" + String(e(t));
    }, zA.prototype.createSentryTrace = function() {
        var A = TA().substring(16);
        return TA() + "-" + A + "-" + this.traceFlag;
    }, zA.prototype.isUrlIgnored = function() {
        if (Array.isArray(this.ignoreUrls) && 0 !== this.ignoreUrls.length) for(var A = 0, e = this.ignoreUrls; A < e.length; A++){
            var t = e[A];
            if (this.urlMatches(this.url, t)) return !0;
        }
        return !1;
    }, zA.prototype.isUrlInTraceUrls = function() {
        if (!this.urls) return !0;
        if (Array.isArray(this.urls)) {
            if (0 === this.urls.length) return !1;
            for(var A = 0, e = this.urls; A < e.length; A++){
                var t = e[A];
                if (this.urlMatches(this.url, t)) return !0;
            }
        }
        return !1;
    }, zA.prototype.urlMatches = function(A, e) {
        return "string" == typeof e ? A === e : !!A.match(e);
    }, zA), JA = {
        sw8: function(A) {
            var e = "function" == typeof atob ? atob : DA, A = A.split("-")[1];
            return A ? e(A) : "";
        },
        traceparent: function(A) {
            return A.split("-")[1];
        },
        b3: function(A) {
            return A.split("-")[0];
        },
        "sentry-trace": function(A) {
            return A.split("-")[0];
        }
    }, WA = function() {}, A = (h.use = function(A) {
        -1 === h.installedPlugins.indexOf(A) && A.aegisPlugin && h.installedPlugins.push(A);
    }, h.unuse = function(A) {
        A = h.installedPlugins.indexOf(A);
        -1 !== A && h.installedPlugins.splice(A, 1);
    }, h.prototype.init = function(A) {
        var e;
        this.setConfig(A), this.config = (e = this.config, A = A.hostUrl, e.url = (A = "string" != typeof (A = void 0 === A ? "https://rumt-zh.com" : A) ? "https://rumt-zh.com" : A) + "/collect", e.offlineUrl = A + "/offline", e.whiteListUrl = A + "/collect/whitelist", e.pvUrl = A + "/collect/pv", e.eventUrl = A + "/collect/events", e.speedUrl = A + "/speed", e.customTimeUrl = A + "/speed/custom", e.performanceUrl = A + "/speed/performance", e.performanceUrlForHippy = A + "/speed/hippyPerformance", e.webVitalsUrl = A + "/speed/webvitals", e.setDataReportUrl = A + "/speed/miniProgramData", e.memoryUrl = A + "/memory", e);
        for(var t = 0; t < h.installedPlugins.length; t++)try {
            h.installedPlugins[t].patch(this);
        } catch (A) {
            this.sendSDKError(A);
        }
        this.lifeCycle.emit("onInited");
    }, h.prototype.destroy = function(A) {
        void 0 === A && (A = !1);
        var e, t, n = h.instances.indexOf(this);
        -1 !== n && h.instances.splice(n, 1);
        for(var r = h.installedPlugins.length - 1; 0 <= r; r--)try {
            h.installedPlugins[r].unpatch(this);
        } catch (A) {
            this.sendSDKError(A);
        }
        if (this.lifeCycle.emit("destroy"), this.lifeCycle.clear(), A) e = this, t = Object.getOwnPropertyDescriptors(e), Object.keys(t).forEach(function(A) {
            t[A].writable && (e[A] = null);
        }), Object.setPrototypeOf(this, null);
        else {
            for(var o = this; o.constructor !== Object && PA(o, this), o = Object.getPrototypeOf(o););
            0 === h.instances.length && (n = Object.getPrototypeOf(this).constructor, PA(n), PA(h));
        }
    }, h.prototype.setConfig = function(A) {
        Object.assign(this.config, A);
        var A = this.config, e = A.id, t = A.uin, n = A.version, r = A.ext1, o = A.ext2, i = A.ext3, s = A.aid, a = A.env, c = void 0 === a ? "production" : a, a = A.pageUrl, A = this.bean.id !== e || this.bean.uin !== t || this.bean.aid !== s;
        return this.bean.id = e || "", this.bean.uin = t || "", this.bean.version = n || "1.43.51", this.bean.aid = s || "", this.bean.env = (()=>{
            switch(c){
                case B.production:
                case B.development:
                case B.gray:
                case B.pre:
                case B.daily:
                case B.local:
                case B.test:
                case B.others:
                    return 1;
                default:
                    return;
            }
        })() ? c : B.others, a && this.extendBean("from", encodeURIComponent(a.slice(0, 2048))), r && this.extendBean("ext1", encodeURIComponent(r)), o && this.extendBean("ext2", encodeURIComponent(o)), i && this.extendBean("ext3", encodeURIComponent(i)), A && this.lifeCycle.emit("onConfigChange", this.config), this.config;
    }, h.prototype.extendBean = function(A, e) {
        this.bean[A] = e;
    }, h.prototype.send = function(A, r, o) {
        var e = this;
        return MA([
            BA(this),
            aA(this, null == A ? void 0 : A.type),
            function(t, n) {
                e.request(t, function() {
                    for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
                    n({
                        isErr: !1,
                        result: A,
                        logType: t.type,
                        logs: t.log
                    }), null != r && r.apply(void 0, A);
                }, function() {
                    for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
                    n({
                        isErr: !0,
                        result: A,
                        logType: t.type,
                        logs: t.log
                    }), null != o && o.apply(void 0, A);
                });
            },
            lA(this)
        ])(A);
    }, h.prototype.sendSDKError = function(A) {
        var t = this;
        this.sendPipeline([
            function(A, e) {
                e({
                    url: t.config.url + "?id=1085&msg[0]=" + encodeURIComponent(hA(A)) + "&level[0]=2&from=" + t.config.id + "&count=1&version=" + t.config.id + "(1.43.51)",
                    addBean: !1,
                    method: "get",
                    type: d.SDK_ERROR,
                    log: A
                });
            }
        ], d.SDK_ERROR)(A);
    }, h.prototype.sendPipeline = function(A, e) {
        var t, o = this;
        return MA(M([
            function(A, e) {
                if ("number" != typeof t.config.random && (console.warn("random must in [0, 1], default is 1."), t.config.random = 1), !t.isHidden || !t.isGetSample) {
                    if (t.isGetSample) t.isHidden || e(A);
                    else {
                        if (t.isGetSample = !0, Math.random() < t.config.random) return t.isHidden = !1, e(A);
                        t.isHidden = !0;
                    }
                }
            },
            cA(t = this, e)
        ], A, [
            aA(this, e),
            BA(this),
            function(n, r) {
                o.request(n, function() {
                    for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
                    var t = !1;
                    -1 < ("" + A[o.failRequestCount = 0]).indexOf("403 forbidden") && (t = !0, o.destroy()), r({
                        isErr: t,
                        result: A,
                        logType: null == n ? void 0 : n.type,
                        logs: null == n ? void 0 : n.log
                    }), null != (t = null == n ? void 0 : n.success) && t.call.apply(t, M([
                        n
                    ], A));
                }, function() {
                    for(var A, e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                    60 <= ++o.failRequestCount && o.destroy(), -1 < ("" + e[0]).indexOf("403 forbidden") && o.destroy(), r({
                        isErr: !0,
                        result: e,
                        logType: null == n ? void 0 : n.type,
                        logs: null == n ? void 0 : n.log
                    }), null != (A = null == n ? void 0 : n.fail) && A.call.apply(A, M([
                        n
                    ], e));
                });
            },
            lA(this)
        ]));
    }, h.prototype.validateRange = function(A) {
        return 0 <= A && A <= 127 ? A : -1;
    }, h.prototype.info = function() {
        for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
        var t = {
            level: j.INFO,
            msg: A,
            originFrom: this.getOriginFrom()
        };
        1 === A.length && A[0].msg && Object.assign(t, q({}, A[0]), {
            level: j.INFO,
            originFrom: this.getOriginFrom()
        }), this.normalLogPipeline(t);
    }, h.prototype.infoAll = function() {
        for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
        var t = {
            level: j.INFO_ALL,
            msg: A,
            originFrom: this.getOriginFrom()
        };
        1 === A.length && A[0].msg && Object.assign(t, q({}, A[0]), {
            level: j.INFO_ALL,
            originFrom: this.getOriginFrom()
        }), this.normalLogPipeline(t);
    }, h.prototype.report = function() {
        for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
        var t = {
            level: j.REPORT,
            msg: A,
            originFrom: this.getOriginFrom()
        };
        1 === A.length && A[0].msg && Object.assign(t, q({}, A[0]), {
            originFrom: this.getOriginFrom()
        }), this.normalLogPipeline(t);
    }, h.prototype.error = function() {
        for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
        var t = {
            level: j.ERROR,
            msg: A,
            originFrom: this.getOriginFrom()
        };
        1 === A.length && A[0].msg && Object.assign(t, q({}, A[0]), {
            level: j.ERROR,
            originFrom: this.getOriginFrom()
        }), this.normalLogPipeline(t);
    }, h.prototype.reportEvent = function(A) {
        A && ((A = "string" == typeof A ? {
            name: A,
            ext1: this.config.ext1 || "",
            ext2: this.config.ext2 || "",
            ext3: this.config.ext3 || "",
            originFrom: this.getOriginFrom()
        } : q(q({}, A), {
            originFrom: A.originFrom || this.getOriginFrom()
        })).name ? ("string" != typeof A.name && (console.warn("reportEvent params name must be string"), A.name = String(A.name)), this.eventPipeline(A)) : console.warn("reportEvent params error"));
    }, h.prototype.reportT = function(A) {
        var e = A.name, t = A.duration, n = A.ext1, n = void 0 === n ? "" : n, r = A.ext2, r = void 0 === r ? "" : r, o = A.ext3, o = void 0 === o ? "" : o, i = A.ext4, s = A.ext5, a = A.ext6, c = A.ext7, B = A.ext8, l = A.ext9, u = A.ext10, A = A.from;
        if ("string" == typeof e && "number" == typeof t && "string" == typeof n && "string" == typeof r && "string" == typeof o) {
            if (!(t < 0 || 2147483646 < t)) return this.submitCustomTime(e, t, n, r, o, void 0 === i ? "" : i, void 0 === s ? "" : s, void 0 === a ? "" : a, void 0 === c ? "" : c, void 0 === B ? "" : B, void 0 === l ? "" : l, void 0 === u ? "" : u, void 0 === A ? "" : A);
            console.warn("reportTime: duration must between 0 and 2147483646");
        } else console.warn("reportTime: params error");
    }, h.prototype.reportTime = function(A, e) {
        if ("object" == typeof A) return this.reportT(A);
        "string" == typeof A ? "number" == typeof e ? e < 0 || 2147483646 < e ? console.warn("reportTime: duration must between 0 and 2147483646") : (this.submitCustomTime(A, e), this.normalLogPipeline({
            level: j.SPEED_EVENT,
            msg: "key:" + A + "\\n duration:" + e,
            errorMsg: "",
            originFrom: this.getOriginFrom()
        })) : console.warn("reportTime: second param must be number") : console.warn("reportTime: first param must be a string");
    }, h.prototype.time = function(A) {
        "string" == typeof A ? this.timeMap[A] ? console.warn("Timer " + A + " already exists") : this.timeMap[A] = Date.now() : console.warn("time: first param must be a string");
    }, h.prototype.timeEnd = function(A) {
        var e;
        "object" != typeof A || null === A ? "string" == typeof A ? void 0 !== (e = this.getTimeEventDuration(A)) ? (this.submitCustomTime(A, e), delete this.timeMap[A]) : console.warn("Timer " + A + " does not exist") : console.warn("timeEnd: first param must be a string") : void 0 !== (e = this.getTimeEventDuration(A.name)) ? (this.reportT(q(q({}, A), {
            duration: e
        })), delete this.timeMap[A.name]) : console.warn("Timer " + A.name + " does not exist");
    }, h.prototype.ready = function(A, e, t) {
        throw new Error('You need to override "ready" method');
    }, h.prototype.request = function(A, e, t) {
        throw new Error('You need to override "request" method');
    }, h.prototype.speedLogPipeline = function(A) {
        throw new Error('You need to override "speedLogPipeline" method');
    }, h.prototype.getOriginFrom = function() {
        throw new Error('You need to override "getOriginFrom" method');
    }, Object.defineProperty(h.prototype, "__version__", {
        get: function() {
            return "1.43.51";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(h.prototype, "LogType", {
        get: function() {
            return j;
        },
        enumerable: !1,
        configurable: !0
    }), h.prototype.reportPv = function(A) {
        A && console.warn("reportPv is deprecated, please use reportEvent");
    }, h.prototype.submitCustomTime = function(A, e, t, n, r, o, i, s, a, c, B, l, u) {
        A = {
            name: A,
            duration: e,
            ext1: String(t || this.config.ext1 || "").slice(0, 1024),
            ext2: String(n || this.config.ext2 || "").slice(0, 1024),
            ext3: String(r || this.config.ext3 || "").slice(0, 1024),
            ext4: o || this.config.ext4,
            ext5: i || this.config.ext5,
            ext6: s || this.config.ext6,
            ext7: a || this.config.ext7,
            ext8: c || this.config.ext8,
            ext9: B || this.config.ext9,
            ext10: l || this.config.ext10,
            from: u || void 0
        };
        this.customTimePipeline(A);
    }, h.prototype.getTimeEventDuration = function(A) {
        if (void 0 !== A && this.timeMap[A]) return Date.now() - this.timeMap[A];
    }, h.version = "1.43.51", h.instances = [], h.logType = j, h.environment = B, h.installedPlugins = [], h), t = (jA.prototype.patch = function(A) {
        this.canUse(A) && this.exist(A) && (this.instances.push(A), this.triggerInit(A), this.triggerOnNewAegis(A));
    }, jA.prototype.unpatch = function(A) {
        var e = this.instances.indexOf(A);
        -1 !== e && (this.instances.splice(e, 1), 0 === this.instances.length) && this.uninstall(A);
    }, jA.prototype.countInstance = function() {
        return this.instances.length;
    }, jA.prototype.uninstall = function(A) {
        var e;
        null != (e = null == (e = this.option) ? void 0 : e.destroy) && e.apply(this, [
            A
        ]);
    }, jA.prototype.walk = function(t) {
        var n = this;
        this.instances.forEach(function(A) {
            var e = n.canUse(A);
            e && t(A, e);
        });
    }, jA.prototype.canUse = function(A) {
        A = this.getConfig(A);
        return !(!A || "object" != typeof A) || !!A;
    }, jA.prototype.getConfig = function(A) {
        return null == (A = A.config) ? void 0 : A[this.name];
    }, jA.prototype.exist = function(A) {
        return -1 === this.instances.indexOf(A);
    }, jA.prototype.triggerInit = function(A) {
        var e;
        this.inited || (this.inited = !0, null == (e = null == (e = this.option) ? void 0 : e.init)) || e.call(this.option, this.getConfig(A));
    }, jA.prototype.triggerOnNewAegis = function(A) {
        var e;
        null != (e = null == (e = this.option) ? void 0 : e.onNewAegis) && e.call(this.option, A, this.getConfig(A));
    }, jA), _A = new t({
        name: "aid",
        aid: "",
        init: function(A) {
            try {
                var e = !0 !== A && A || window.localStorage.getItem("AEGIS_ID");
                e || (e = OA(), window.localStorage.setItem("AEGIS_ID", e)), this.aid = e;
            } catch (A) {}
        },
        onNewAegis: function(A) {
            A.bean.aid = this.aid, A.config.aid = this.aid;
        }
    }), YA = new t({
        name: "reportAssetSpeed"
    }), ZA = YA = new t({
        name: "reportAssetSpeed",
        collectCur: 0,
        collectEntryType: "resource",
        ASSETS_INITIATOR_TYPE: [
            "img",
            "css",
            "script",
            "link",
            "audio",
            "video"
        ],
        getFromParam: function(A) {
            return A.getCurrentPageUrl();
        },
        onNewAegis: function(A) {
            var e = this;
            kA() && (setTimeout(function() {
                e.collectSuccessLog(A), e.collectFailLog(A);
            }, 5e3), performance.onresourcetimingbufferfull = function() {
                "function" == typeof performance.clearResourceTimings && (e.collectCur = 0, performance.clearResourceTimings());
            });
        },
        processLog: function(A, e) {
            var t = e.duration || 0, n = e.transferSize || 0, r = !1, o = A.config;
            if (null != (s = null == o ? void 0 : o.api) && s.isSlowAsset && "function" == typeof (null == (s = null == o ? void 0 : o.api) ? void 0 : s.isSlowAsset)) try {
                r = null == (i = null == o ? void 0 : o.api) ? void 0 : i.isSlowAsset(e);
            } catch (A) {
                return void console.warn("[Aegis] isSlowAsset function happen error:", A, ", this data will not be reported.");
            }
            else r = null != (s = null == o ? void 0 : o.api) && s.assetSlowThreshold && "number" == typeof (null == (i = null == o ? void 0 : o.api) ? void 0 : i.assetSlowThreshold) ? t > (null == (s = null == o ? void 0 : o.api) ? void 0 : s.assetSlowThreshold) : 1e3 < t;
            var i = [
                "ASSET_REQUEST: " + e.url,
                "status: " + e.status,
                "duration: " + t + "ms",
                "type: " + e.type,
                "domainLookup: " + e.domainLookup + "ms",
                "connectTime: " + e.connectTime + "ms",
                "transferSize: " + (0 < n ? n + "bytes" : "unknown")
            ].filter(Boolean).join("\n\n"), o = A.isWhiteList && A.config.assetLog, s = A.config.slowAssetLog && r, e = {
                level: r ? A.LogType.SLOW_ASSET_REQUEST : A.LogType.ASSERT_REQUEST,
                msg: i,
                ext1: t.toString() || "",
                errorMsg: "",
                originFrom: A.getOriginFrom()
            };
            (o || s) && A.normalLogPipeline(e);
        },
        publish: function(e, t) {
            var n = this;
            this.$walk(function(A) {
                A === t && (A.speedLogPipeline(e), Array.isArray(e) ? e.forEach(n.processLog) : n.processLog(t, e));
            });
        },
        publishMany: function(A, e) {
            for(var t = e.config, n = this.getFromParam(e), r = 0, o = A.length; r < o; r++){
                var i = A[r];
                -1 === this.ASSETS_INITIATOR_TYPE.indexOf(i.initiatorType) || oA(i.name, t.hostUrl) || this.publish(this.generateLog(i, t, n), e);
            }
        },
        collectSuccessLog: function(t) {
            var A, e, n = this;
            "function" == typeof window.PerformanceObserver ? (this.publishMany(performance.getEntriesByType(this.collectEntryType), t), (A = new window.PerformanceObserver(function(A) {
                n.publishMany(A.getEntries(), t);
            })).observe({
                entryTypes: [
                    this.collectEntryType
                ]
            }), t.lifeCycle.on("destroy", function() {
                0 === YA.countInstance() && A.disconnect();
            })) : (e = setInterval(function() {
                var A = performance.getEntriesByType(n.collectEntryType), e = A.slice(n.collectCur);
                n.collectCur = A.length, n.publishMany(e, t);
            }, 3e3), t.lifeCycle.on("destroy", function() {
                0 === YA.countInstance() && clearInterval(e);
            }));
        },
        collectFailLog: function(o) {
            function A(A) {
                var e, t, n, r;
                A && (A = A.target || A.srcElement, !(e = (null == A ? void 0 : A.src) || (null == A ? void 0 : A.href)) || "string" != typeof e || -1 < window.location.href.indexOf(e) || (A = "function" == typeof (null == (A = s.api) ? void 0 : A.resourceTypeHandler) ? null == (A = s.api) ? void 0 : A.resourceTypeHandler(e) : "", t = performance.getEntriesByType(i.collectEntryType).find(function(A) {
                    return A.name === e;
                }), oA(e, s.hostUrl)) || (n = i.getFromParam(o), r = Number(null == (r = t) ? void 0 : r.responseStatus), r = Number.isFinite(r) && 0 < r ? r : 400, r = {
                    url: AA(e),
                    status: r,
                    duration: Number(((null == t ? void 0 : t.duration) || 0).toFixed(2)),
                    method: "get",
                    type: A || "static",
                    isHttps: eA(e),
                    urlQuery: Z(e, !0),
                    nextHopProtocol: "",
                    domainLookup: 0,
                    connectTime: 0,
                    from: n
                }, i.publish(r, o)));
            }
            var i = this, s = o.config;
            window.document.addEventListener("error", A, !0), o.lifeCycle.on("destroy", function() {
                0 === YA.countInstance() && window.document.removeEventListener("error", A, !0);
            });
        },
        generateLog: function(A, e, t) {
            var e = "function" == typeof (null == (n = e.api) ? void 0 : n.resourceTypeHandler) ? null == (n = e.api) ? void 0 : n.resourceTypeHandler(A.name) : "", n = A.transferSize, r = Number(A.responseStatus), r = Number.isFinite(r) && 0 < r ? r : 200;
            return {
                url: AA(A.name),
                method: "get",
                duration: Number(A.duration.toFixed(2)),
                status: r,
                type: e || "static",
                isHttps: eA(A.name),
                nextHopProtocol: A.nextHopProtocol || "",
                urlQuery: Z(A.name, !0),
                domainLookup: Y(A.domainLookupEnd - A.domainLookupStart),
                connectTime: Y(A.connectEnd - A.connectStart),
                transferSize: 0 < n ? n : -1,
                from: t
            };
        },
        collectNotReportedLog: function(A) {
            var e, t;
            kA() && (e = (t = performance.getEntriesByType(this.collectEntryType)).length, "function" != typeof window.PerformanceObserver) && this.collectCur !== e && (t = t.slice(this.collectCur), this.collectCur = e, this.publishMany(t, A));
        },
        destroy: function() {
            this.option.publish = function() {};
        }
    }), qA = window.navigator.userAgent.toLowerCase(), o = {};
    function jA(A) {
        this.aegisPlugin = !0, this.name = "", this.instances = [], this.inited = !1, A.$walk = this.walk.bind(this), A.$getConfig = this.getConfig.bind(this), this.option = A, this.name = A.name;
    }
    function h(A) {
        var t, n, r, i, e, s, a, o, c, B, l, u, g, w = this;
        this.isGetSample = !1, this.isHidden = !1, this.config = {
            version: 0,
            delay: 1e3,
            onError: !0,
            repeat: 60,
            random: 1,
            aid: !0,
            device: !0,
            pagePerformance: !0,
            webVitals: !0,
            speedSample: !0,
            onClose: !0,
            reportLoadPackageSpeed: !0,
            hostUrl: "https://rumt-zh.com",
            env: "production",
            url: "",
            offlineUrl: "",
            whiteListUrl: "",
            pvUrl: "",
            speedUrl: "",
            customTimeUrl: "",
            performanceUrl: "",
            performanceUrlForHippy: "",
            webVitalsUrl: "",
            eventUrl: "",
            setDataReportUrl: "",
            memoryUrl: "",
            reportImmediately: !0
        }, this.isWhiteList = !1, this.lifeCycle = new J, this.bean = {}, this.normalLogPipeline = MA([
            iA(this, 5),
            sA,
            function(A, e) {
                var n = t.config;
                e(A = A.map(function(A) {
                    var e, t = n.maxLength || 10240;
                    try {
                        if (!A.msg || A.msg.length <= t) return A;
                        A.msg = null == (e = A.msg) ? void 0 : e.substring(0, t);
                    } catch (e) {
                        A.msg = hA(A.msg).substring(0, n.maxLength);
                    }
                    return A;
                }));
            },
            (g = (t = this).config, function(A, e) {
                var t = "number" == typeof g.repeat ? g.repeat : 60;
                if (t <= 0) return e(A);
                var n = (null == g ? void 0 : g.id) + "_error", r = HA[n] || {};
                e(A.filter(function(A) {
                    if (A.level === j.ERROR || A.level === j.PROMISE_ERROR || A.level === j.AJAX_ERROR || A.level === j.SCRIPT_ERROR || A.level === j.IMAGE_ERROR || A.level === j.CSS_ERROR || A.level === j.MEDIA_ERROR || A.level === j.RET_ERROR || A.level === j.BRIDGE_ERROR || A.level === j.PAGE_NOT_FOUND_ERROR || A.level === j.WEBSOCKET_ERROR || A.level === j.LAZY_LOAD_ERROR) {
                        A = A.msg.slice(0, 200);
                        if (r[A] > t) return EA[n] || vA(n), !1;
                        r[A] = 1 + ~~r[A], HA[n] = r;
                    }
                    return !0;
                }));
            }),
            (l = this.lifeCycle.emit, u = this.config, function(A, e) {
                var t, n = u.logCreated;
                return "function" == typeof n ? (t = A.filter(function(A) {
                    return !1 !== n(A);
                }), l("beforeWrite", t), e(t)) : (l("beforeWrite", A), e(A));
            }),
            (B = this, setTimeout(function() {
                var A = B.config, e = A.pvUrl, r = void 0 === e ? "" : e, e = A.spa, A = -1 < [
                    "web-sdk",
                    "mp-sdk"
                ].indexOf("web-sdk");
                r && (A && !e || !A) && B.sendPipeline([
                    function(A, e) {
                        var t = B.getOriginFrom(), n = null != r && r.includes("?") ? "&" : "?";
                        e({
                            url: t ? r + n + "originFrom=" + encodeURIComponent(t) : r,
                            type: d.PV
                        });
                    }
                ], d.PV)(null);
            }, 100), function(A, e) {
                e(A);
            }),
            (o = a = s = !1, c = [], (i = this).lifeCycle.on("onConfigChange", function() {
                e && clearTimeout(e), e = setTimeout(function() {
                    var A, t;
                    !o && i.config && (o = !0, A = i.config.whiteListUrl, (t = void 0 === A ? "" : A) && i.sendPipeline([
                        function(A, e) {
                            e({
                                url: t,
                                type: d.WHITE_LIST,
                                success: function(A) {
                                    a = !0;
                                    try {
                                        var e = A.data || JSON.parse(A), t = e.retcode, n = e.result, r = void 0 === n ? {} : n, o = (0 === t && (s = r.is_in_white_list, i.isWhiteList = s, 0 <= r.rate) && r.rate <= 1 && (i.config.random = r.rate, i.isGetSample = !1), i.isWhiteList && c.length ? bA(i)(c.splice(0), function() {}) : !i.isWhiteList && c.length && (c.length = 0), i.config.onWhitelist);
                                        "function" == typeof o && o(s);
                                    } catch (A) {}
                                },
                                fail: function() {
                                    a = !0;
                                }
                            });
                        }
                    ], d.WHITE_LIST)(null), o = !1);
                }, i.config.uin ? 50 : 500);
            }), i.lifeCycle.on("destroy", function() {
                c.length = 0;
            }), function(A, e) {
                var t;
                s || null != (t = null == (t = i.config) ? void 0 : t.api) && t.reportRequest ? e(A.concat(c.splice(0)).map(function(A) {
                    return yA(A), A;
                })) : (t = A.filter(function(A) {
                    return A.level !== j.INFO && A.level !== j.API_RESPONSE ? (yA(A), !0) : (a || (c.push(A), 200 <= c.length && (c.length = 200)), !1);
                })).length && e(t);
            }),
            function(A, e) {
                try {
                    var t = A.filter(function(A) {
                        return [
                            j.ERROR,
                            j.PROMISE_ERROR,
                            j.AJAX_ERROR,
                            j.SCRIPT_ERROR,
                            j.IMAGE_ERROR,
                            j.CSS_ERROR,
                            j.MEDIA_ERROR,
                            j.WEBSOCKET_ERROR,
                            j.BRIDGE_ERROR,
                            j.BLANK_SCREEN,
                            j.RET_ERROR,
                            j.PAGE_NOT_FOUND_ERROR,
                            j.LAZY_LOAD_ERROR
                        ].includes(A.level);
                    }), n = (t.length && w.lifeCycle.emit("errorOccurred", t), A.forEach(function(e) {
                        [
                            "ext1",
                            "ext2",
                            "ext3"
                        ].forEach(function(A) {
                            e[A] && "string" == typeof e[A] && (e[A] = e[A].slice(0, 1024));
                        }), [
                            "ext4",
                            "ext5",
                            "ext6",
                            "ext7",
                            "ext8",
                            "ext9",
                            "ext10"
                        ].forEach(function(A) {
                            e[A] && "string" != typeof e[A] && (e[A] = String(e[A]));
                        });
                    }), JSON.parse(JSON.stringify(A))), r = (w.lifeCycle.emit("beforeReport", n), w.config.beforeReport);
                    (A = "function" == typeof r ? A.filter(function(A) {
                        return !1 !== r(A);
                    }) : A).length && e(A);
                } catch (A) {}
            },
            bA(this)
        ]), this.eventPipeline = MA([
            iA(this, 10),
            (r = this, function(A) {
                r.sendPipeline([
                    function(A, e) {
                        var t = A.map(function(A) {
                            return {
                                name: A.name,
                                originFrom: A.originFrom,
                                ext1: String(A.ext1 || r.config.ext1 || "").slice(0, 1024),
                                ext2: String(A.ext2 || r.config.ext2 || "").slice(0, 1024),
                                ext3: String(A.ext3 || r.config.ext3 || "").slice(0, 1024),
                                ext4: String(A.ext4 || r.config.ext4 || ""),
                                ext5: String(A.ext5 || r.config.ext5 || ""),
                                ext6: String(A.ext6 || r.config.ext6 || ""),
                                ext7: String(A.ext7 || r.config.ext7 || ""),
                                ext8: String(A.ext8 || r.config.ext8 || ""),
                                ext9: String(A.ext9 || r.config.ext9 || ""),
                                ext10: String(A.ext10 || r.config.ext10 || "")
                            };
                        });
                        e({
                            url: r.config.eventUrl,
                            method: "post",
                            contentType: "application/json",
                            data: fA({
                                payload: fA(t)
                            }),
                            type: d.EVENT,
                            log: A
                        });
                    }
                ], d.EVENT)(A);
            })
        ]), this.customTimePipeline = MA([
            iA(this, 10),
            (n = this, function(A) {
                return n.sendPipeline([
                    function(A, e) {
                        e({
                            url: n.config.customTimeUrl,
                            method: "post",
                            contentType: "application/json",
                            data: fA({
                                payload: fA({
                                    custom: A
                                })
                            }),
                            type: d.CUSTOM,
                            log: A
                        });
                    }
                ], d.CUSTOM)(A);
            })
        ]), this.timeMap = {}, this.failRequestCount = 0, h.instances.push(this);
    }
    function zA(A, e, t, n) {
        void 0 === t && (t = null), this.traceType = A, this.ignoreUrls = e, this.urls = t, this.traceFlag = null == n ? 1 : Number(!!n);
    }
    o.macos = function() {
        return e("mac");
    }, o.ios = function() {
        return o.iphone() || o.ipod() || o.ipad();
    }, o.iphone = function() {
        return !o.windows() && e("iphone");
    }, o.ipod = function() {
        return e("ipod");
    }, o.ipad = function() {
        var A = "MacIntel" === navigator.platform && 1 < navigator.maxTouchPoints;
        return e("ipad") || A;
    }, o.android = function() {
        return !o.windows() && e("android");
    }, o.androidPhone = function() {
        return o.android() && e("mobile");
    }, o.androidTablet = function() {
        return o.android() && !e("mobile");
    }, o.blackberry = function() {
        return e("blackberry") || e("bb10");
    }, o.blackberryPhone = function() {
        return o.blackberry() && !e("tablet");
    }, o.blackberryTablet = function() {
        return o.blackberry() && e("tablet");
    }, o.windows = function() {
        return e("windows");
    }, o.windowsPhone = function() {
        return o.windows() && e("phone");
    }, o.windowsTablet = function() {
        return o.windows() && e("touch") && !o.windowsPhone();
    }, o.fxos = function() {
        return (e("(mobile") || e("(tablet")) && e(" rv:");
    }, o.fxosPhone = function() {
        return o.fxos() && e("mobile");
    }, o.fxosTablet = function() {
        return o.fxos() && e("tablet");
    }, o.meego = function() {
        return e("meego");
    }, o.cordova = function() {
        return window.cordova && "file:" === location.protocol;
    }, o.nodeWebkit = function() {
        return "object" == typeof window.process;
    }, o.mobile = function() {
        return o.androidPhone() || o.iphone() || o.ipod() || o.windowsPhone() || o.blackberryPhone() || o.fxosPhone() || o.meego();
    }, o.tablet = function() {
        return o.ipad() || o.androidTablet() || o.blackberryTablet() || o.windowsTablet() || o.fxosTablet();
    }, o.desktop = function() {
        return !o.tablet() && !o.mobile();
    };
    function $A() {
        return {
            host: new URL(location.href).host,
            pathname: location.pathname
        };
    }
    function Ae(n, A, r) {
        return null != A && A.length && "object" == typeof n ? A.reduce(function(A, e) {
            var t = window.Headers && n instanceof Headers ? n.get(e) : n[e];
            return t ? A + ("" === A ? "" : "\n\n") + r + " header " + e + ": " + t : A;
        }, "") : "";
    }
    function ee(A, e) {
        return A && -1 === [
            "null",
            "undefined"
        ].indexOf(A) ? e + ": " + A : "";
    }
    function te(A, e, t) {
        void 0 === e && (e = "");
        var n, r, A = "function" == typeof (null == (r = A.api) ? void 0 : r.resourceTypeHandler) ? null == (r = A.api) ? void 0 : r.resourceTypeHandler(t) : "";
        return -1 === V.indexOf(A) && (n = void 0 === e ? "" : e, r = (void 0 === t ? "" : t).split("?")[0], A = gA.test(r) || uA.some(function(A) {
            return -1 !== String(n).indexOf(A);
        }) ? "static" : "fetch"), A;
    }
    function ne(A, e) {
        return A ? j.AJAX_ERROR : e ? j.RET_ERROR : j.API_RESPONSE;
    }
    function re(A, e, t) {
        var n, r;
        if (!A) return !1;
        if (null != (n = null == e ? void 0 : e.api) && n.isSlowApi && "function" == typeof (null == (n = null == e ? void 0 : e.api) ? void 0 : n.isSlowApi)) try {
            return null == (r = null == e ? void 0 : e.api) ? void 0 : r.isSlowApi(t || {
                duration: A
            });
        } catch (A) {
            return console.warn("[Aegis] isSlowApi function happen error:", A, ", this data will not be reported."), !1;
        }
        return null != (n = null == e ? void 0 : e.api) && n.apiSlowThreshold && "number" == typeof (null == (r = null == e ? void 0 : e.api) ? void 0 : r.apiSlowThreshold) ? A > (null == (t = null == e ? void 0 : e.api) ? void 0 : t.apiSlowThreshold) : 1e3 < A;
    }
    function oe(A, e) {
        if (null != (A = A.api) && A.usePerformanceTiming && "string" == typeof e.url) {
            A = null == (A = performance.getEntriesByName(e.url)) ? void 0 : A.pop();
            if (A) return {
                url: e.url,
                isHttps: eA(e.url),
                method: e.method,
                type: e.type,
                status: e.status,
                duration: Number(A.duration.toFixed(2)),
                nextHopProtocol: A.nextHopProtocol || "",
                domainLookup: Y(A.domainLookupEnd - A.domainLookupStart),
                connectTime: Y(A.connectEnd - A.connectStart)
            };
        }
        return {
            url: e.url,
            isHttps: eA(e.url),
            method: e.method,
            type: e.type,
            status: e.status,
            duration: Number(e.duration.toFixed(2)),
            nextHopProtocol: "",
            domainLookup: X.number,
            connectTime: X.number
        };
    }
    function ie() {
        return window.location.href;
    }
    function se(A) {
        return (A = ((A)=>{
            var e = "", t = A.nodeType;
            if (1 === t || 9 === t || 11 === t) {
                if ("string" == typeof A.textContent) return A.textContent;
                for(var n = A.firstChild; n; n = n.nextSibling)e += Xe(A);
            } else if (3 === t || 4 === t) return A.nodeValue;
            return e;
        })(A)) ? A.replace(/^\s+|\s+$/g, "") : "";
    }
    var ae, ce, Be, le, ue, ge, we, de, he, fe, Qe, pe, Ce, Ue, Fe, me, ye, Ee, He = (o.isIE = function() {
        return "ActiveXObject" in window;
    }, false), ve = [], Ie = /^\/[^/]/, be = !1, Le = [], Ke = {
        maxRetryCount: 10,
        retryInterval: function(A) {
            return 1e3 * (2 << A);
        },
        whenRetryEndStillFail: "discard"
    }, Se = (new t({
        name: "reportApiSpeed"
    }), new t({
        name: "reportApiSpeed",
        override: !1,
        onNewAegis: function(A) {
            var e, t;
            this.override || (this.override = !0, null != (t = A.config.api) && t.injectTraceHeader && (this.traceRequestHeader = new XA(t.injectTraceHeader, null != (e = null == t ? void 0 : t.injectTraceIgnoreUrls) ? e : [], null == t ? void 0 : t.injectTraceUrls, null == t ? void 0 : t.traceFlag)), this.overrideFetch(A.config, A), this.overrideXhr(A.config, A));
        },
        getFromParam: function(A) {
            return A.getCurrentPageUrl();
        },
        overrideFetch: function(C, U) {
            var F = this, A = C.api, A = {
                name: this.name,
                traceRequestHeader: null != A && A.injectTraceHeader ? this.traceRequestHeader : null,
                getCurrentFrom: function() {
                    return F.getFromParam(U);
                },
                then: function(u, g, w, d, h, f, Q) {
                    var A, p;
                    oA(w, C.hostUrl) || (A = u.headers ? u.headers.get("content-type") : "", "fetch" === (p = te(C, A || "", w)) ? u.clone().text().then(function(n) {
                        var A, r = u.status <= 0 || 400 <= u.status, e = (null == (e = C.api) ? void 0 : e.reqHeaders) || [], o = Ae(null == d ? void 0 : d.headers, e, "req"), e = (null == (e = C.api) ? void 0 : e.resHeaders) || [], i = Ae(u.headers, e, "res"), s = RA(null == d ? void 0 : d.headers), e = tA(n, C.api, {
                            url: w,
                            ctx: u,
                            payload: null == d ? void 0 : d.body
                        }), a = e.code, c = e.isErr, e = null == (e = C.api) ? void 0 : e.apiDetail, B = e ? nA(null == d ? void 0 : d.body, null == (A = C.api) ? void 0 : A.reqParamHandler, {
                            url: w
                        }) : "", l = e ? nA(n, null == (A = C.api) ? void 0 : A.resBodyHandler, {
                            url: w,
                            ctx: u
                        }) : "";
                        setTimeout(function() {
                            var A = oe(C, {
                                url: w,
                                duration: g,
                                type: p,
                                status: u.status || 0,
                                method: (null == d ? void 0 : d.method) || "get"
                            }), e = [
                                r ? "FETCH_ERROR: " + n : "",
                                "fetch req url: " + w,
                                "res status: " + (A.status || 0),
                                "res duration: " + A.duration + "ms",
                                "res startTime: " + h,
                                o,
                                i,
                                "req method: " + (A.method || "GET"),
                                "res retcode: " + a,
                                ee(B, "req param"),
                                ee(l, "res data")
                            ].filter(function(A) {
                                return A;
                            }).join("\n\n"), e = (A.payload = null == d ? void 0 : d.body, A.ret = a, A.isErr = +c, A.from = f || F.getFromParam(U), {
                                msg: e,
                                code: a,
                                trace: s,
                                errorMsg: "",
                                from: f || F.getFromParam(U),
                                originFrom: Q,
                                level: j.API_RESPONSE
                            }), t = C.slowApiLog && re(null == A ? void 0 : A.duration, C, A);
                            e.level = t ? j.SLOW_NET_REQUEST : ne(r, c), (t || e.level !== j.API_RESPONSE || U.isWhiteList || null != (t = null == (t = U.config) ? void 0 : t.api) && t.reportRequest) && F.publishNormalLog(e, U), F.publishSpeed(A, U);
                        }, 0);
                    }).catch(function(A) {
                        console.info("ignore something error when process resp " + A);
                    }) : setTimeout(function() {
                        var A = oe(C, {
                            url: w,
                            duration: g,
                            type: p,
                            status: u.status || 0,
                            method: (null == d ? void 0 : d.method) || "get"
                        });
                        A.type = "static", A.urlQuery = Z(w, !0), A.from = f || F.getFromParam(U), F.publishSpeed(A, U);
                    }, 0));
                },
                catch: function(e, t, n, r, o, i, s) {
                    var a, A, c, B, l;
                    throw oA(n, C.hostUrl) || (a = te(C, "", n), A = (null == (A = C.api) ? void 0 : A.reqHeaders) || [], c = Ae(null == r ? void 0 : r.headers, A, "req"), B = RA(null == r ? void 0 : r.headers), l = null != (A = C.api) && A.apiDetail ? nA(null == r ? void 0 : r.body, null == (A = C.api) ? void 0 : A.reqParamHandler, {
                        url: n
                    }) : "", setTimeout(function() {
                        var A = oe(C, {
                            url: n,
                            duration: t,
                            type: a,
                            status: 0,
                            method: (null == r ? void 0 : r.method) || "get"
                        }), A = (A.from = i || F.getFromParam(U), F.publishSpeed(A, U), "AJAX_ERROR: " + e + "\n                          \nreq url: " + n + "\n                          \nres status: 0\n                          \nres duration: " + A.duration + "ms\n                          \nreq method: " + ((null == r ? void 0 : r.method) || "get") + "\n                          \nreq param: " + l + "\n                          \nres startTime: " + o + "\n                          \n" + c);
                        F.publishNormalLog({
                            msg: A,
                            level: j.AJAX_ERROR,
                            code: -400,
                            trace: B,
                            errorMsg: "",
                            from: i || F.getFromParam(U),
                            originFrom: s
                        }, U);
                    }, 0)), e;
                }
            }, u = (this.hackFetchOptions = A, this.hackFetchOptions), g = null == (A = C.api) ? void 0 : A.ignoreHackReg;
            if (void 0 === g && (g = /\.flv(\?|$)/i), Le.find(function(A) {
                return A.name === u.name;
            })) throw new Error("name '" + u.name + "' is already in hackFetch option list");
            Le.push(u), !be && window.fetch && (be = !0, le = window.fetch, window.fetch = function(A, r) {
                void 0 === r && (r = {});
                var o = "string" == typeof A ? A : null == A ? void 0 : A.url;
                if (null != (i = null == g ? void 0 : g.test) && i.call(g, o)) return le(o, r);
                Ie.test(o) && (o = "" + location.origin + o);
                var e, t, n, i = (u || {}).traceRequestHeader;
                i && (e = void 0 === (e = (r || {}).headers) ? {} : e, t = (n = $A()).host, t = (i = i.generate(o, e, {
                    host: t,
                    pathname: n.pathname
                }) || {}).name, n = i.value) && t && (r.headers = Object.assign(e, ((i = {})[t] = n, i)));
                for(var s = new Map, a = window.location.href, c = 0; c < Le.length; c++){
                    var B = Le[c];
                    try {
                        "function" == typeof B.beforeFetch && B.beforeFetch(o, r), "function" == typeof B.getCurrentFrom && s.set(B.name, B.getCurrentFrom());
                    } catch (A) {}
                }
                var l = Date.now();
                return le(A, r).then(function(A) {
                    for(var e = A.clone(), t = 0; t < Le.length; t++){
                        var n = Le[t];
                        try {
                            "function" == typeof n.then && n.then(e, Date.now() - l, o, r, l, s.get(n.name), a);
                        } catch (A) {}
                    }
                    return e;
                }).catch(function(A) {
                    for(var e = 0; e < Le.length; e++){
                        var t = Le[e];
                        try {
                            "function" == typeof t.catch && t.catch(A, Date.now() - l, o, r, l, s.get(t.name), a);
                        } catch (A) {}
                    }
                    throw A;
                });
            });
        },
        overrideXhr: function(C, U) {
            var r, F = this, A = {
                name: this.name,
                ignoreHackReg: null == (A = C.api) ? void 0 : A.ignoreHackReg,
                traceRequestHeader: null != (A = C.api) && A.injectTraceHeader ? this.traceRequestHeader : null,
                getCurrentFrom: function() {
                    return F.getFromParam(U);
                },
                send: function(u, g, w, d) {
                    var A, e, h = Date.now(), f = (((null == C ? void 0 : C.api) || {}).injectTraceHeader && (e = (A = $A()).host, A = (e = F.traceRequestHeader.generate(u.aegisUrl, {}, {
                        host: e,
                        pathname: A.pathname
                    }) || {}).name, e = e.value, A) && e && u.setRequestHeader(A, e), u.addEventListener("loadend", function() {
                        var c, t, A, B, l = u.aegisUrl || "";
                        oA(l, C.hostUrl) || "abort" === u.failType || (c = "", (u.failType || !u.status || 400 <= u.status) && (c = u.failType || "failed"), t = Date.now() - h, A = u.getResponseHeader("content-type") || "", B = te(C, A, l), setTimeout(function() {
                            var n = oe(C, {
                                url: l,
                                duration: t,
                                type: B,
                                status: u.status,
                                method: u.aegisMethod || "get"
                            });
                            if (n.from = w || F.getFromParam(U), "fetch" === B) {
                                var A = (null == (A = C.api) ? void 0 : A.reqHeaders) || [], r = Ae(u.aegisXhrReqHeader, A, "req"), A = (null == (A = C.api) ? void 0 : A.resHeaders) || [], e = u.getAllResponseHeaders().split("\r\n").reduce(function(A, e) {
                                    e = e.split(": ");
                                    return e[0] && e[1] && (A[e[0]] = e[1]), A;
                                }, {}), o = Ae(e, A, "res"), i = RA(u.aegisXhrReqHeader), A = null == (e = C.api) ? void 0 : e.apiDetail, s = A ? nA(g, null == (e = C.api) ? void 0 : e.reqParamHandler, {
                                    url: l
                                }) : "", a = A ? nA(u.response, null == (e = C.api) ? void 0 : e.resBodyHandler, {
                                    url: l
                                }) : "";
                                try {
                                    ((A, e, t, n)=>{
                                        var r, o, i;
                                        try {
                                            if ("function" == typeof (null == e ? void 0 : e.retCodeHandlerAsync)) return e.retCodeHandlerAsync(A, null == t ? void 0 : t.url, null == t ? void 0 : t.ctx, function(A) {
                                                var e = A.code;
                                                null != n && n({
                                                    code: void 0 === e ? m : e,
                                                    isErr: A.isErr
                                                });
                                            });
                                            if ("function" == typeof (null == e ? void 0 : e.retCodeHandler)) return i = (o = e.retCodeHandler(A, null == t ? void 0 : t.url, null == t ? void 0 : t.ctx, null == t ? void 0 : t.payload) || {}).code, null != n && n({
                                                code: void 0 === i ? m : i,
                                                isErr: o.isErr
                                            });
                                            if (!(A = "string" == typeof A ? JSON.parse(A) : A)) return null != n && n({
                                                code: m,
                                                isErr: !1
                                            });
                                            "function" == typeof (null == (r = null == e ? void 0 : e.ret) ? void 0 : r.join) && (wA = [].concat(e.ret.map(function(A) {
                                                return A.toLowerCase();
                                            })));
                                            var s = Object.getOwnPropertyNames(A).filter(function(A) {
                                                return -1 !== wA.indexOf(A.toLowerCase());
                                            });
                                            if (s.length) return "\u672A\u77E5" !== (i = A[s[0]]) && "" !== i || (i = m), null != n && n({
                                                code: "" + i,
                                                isErr: 0 !== i && "0" !== i && i !== m
                                            });
                                            null != n && n({
                                                code: m,
                                                isErr: !1
                                            });
                                        } catch (A) {
                                            null != n && n({
                                                code: m,
                                                isErr: !1
                                            });
                                        }
                                    })(u.response, C.api, {
                                        url: l,
                                        ctx: u,
                                        payload: g
                                    }, function(A) {
                                        var e = A.code, A = A.isErr, t = [
                                            c ? "AJAX_ERROR: request " + c : "",
                                            "fetch req url: " + l,
                                            "res status: " + (n.status || 0),
                                            "res duration: " + n.duration + "ms",
                                            "res startTime: " + h,
                                            r,
                                            o,
                                            "req method: " + (n.method || "GET"),
                                            "res retcode: " + e,
                                            ee(s, "req param"),
                                            ee(a, "res data")
                                        ].filter(function(A) {
                                            return A;
                                        }).join("\n\n");
                                        n.ret = e, n.isErr = +A, n.payload = g, C.slowApiLog && re(null == n ? void 0 : n.duration, C, n) ? F.publishNormalLog({
                                            msg: t,
                                            level: j.SLOW_NET_REQUEST,
                                            code: e,
                                            trace: i,
                                            errorMsg: "",
                                            from: w || F.getFromParam(U),
                                            originFrom: d
                                        }, U) : F.publishNormalLog({
                                            msg: t,
                                            level: ne(!!c, A),
                                            code: e,
                                            trace: i,
                                            errorMsg: "",
                                            from: w || F.getFromParam(U),
                                            originFrom: d
                                        }, U), F.publishSpeed(n, U);
                                    });
                                } catch (A) {
                                    n.ret = m, F.publishSpeed(n, U);
                                }
                            } else n.type = "static", n.urlQuery = Z(l, !0), F.publishSpeed(n, U);
                            u.removeEventListener("abort", f), u.removeEventListener("error", Q), u.removeEventListener("timeout", p);
                        }, 0));
                    }), function() {
                        u.failType = "abort";
                    }), Q = function() {
                        u.failType = "error";
                    }, p = function() {
                        u.failType = "timeout";
                    };
                    u.addEventListener("abort", f), u.addEventListener("error", Q), u.addEventListener("timeout", p);
                }
            };
            this.hackXHROptions = A, r = this.hackXHROptions, ve.find(function(A) {
                return A.name === r.name;
            }) || (ve.push(r), !He && window.XMLHttpRequest && (ae = window.XMLHttpRequest.prototype.send, ce = window.XMLHttpRequest.prototype.open, Be = window.XMLHttpRequest.prototype.setRequestHeader, He = !0, window.XMLHttpRequest.prototype.open = function() {
                this.aegisMethod = arguments[0];
                var A, e = arguments[1];
                if (Ie.test(e) && (e = "" + location.origin + e), this.aegisUrl = e, null == (e = null == (A = r.ignoreHackReg) ? void 0 : A.test) || !e.call(A, this.aegisUrl)) {
                    if (this.aegisXhrStartTime = Date.now(), this.sendByAegis) o.isIE() || (this.timeout = 5e3);
                    else for(var t = 0; t < ve.length; t++){
                        var n = ve[t];
                        try {
                            "function" == typeof n.open && n.open(this);
                        } catch (A) {}
                    }
                }
                return ce.apply(this, arguments);
            }, window.XMLHttpRequest.prototype.setRequestHeader = function() {
                var A, e, t;
                return null != (e = null == (t = r.ignoreHackReg) ? void 0 : t.test) && e.call(t, this.aegisUrl) ? Be.apply(this, arguments) : (e = arguments[0], t = arguments[1], this.aegisXhrReqHeader = null != (A = this.aegisXhrReqHeader) ? A : {}, null != r && r.traceRequestHeader && -1 < [
                    "traceparent",
                    "b3",
                    "sw8",
                    "sentry-trace"
                ].indexOf(e) && (this.aegisXhrReqHeader[e] || (arguments[1] = t), this.aegisXhrReqHeader[e]) ? void 0 : (this.aegisXhrReqHeader[e] = arguments[1], Be.apply(this, arguments)));
            }, window.XMLHttpRequest.prototype.send = function() {
                var A, e;
                if (!(null != (e = null == (A = r.ignoreHackReg) ? void 0 : A.test) && e.call(A, this.aegisUrl) || this.sendByAegis)) for(var t = 0; t < ve.length; t++){
                    var n = ve[t];
                    try {
                        "function" == typeof n.send && n.send(this, arguments[0], "function" == typeof n.getCurrentFrom ? n.getCurrentFrom() : void 0, window.location.href);
                    } catch (A) {}
                }
                return ae.apply(this, arguments);
            }));
        },
        publishSpeed: function(t) {
            var n = this;
            this.$walk(function(A) {
                var e = n.$getConfig(A);
                "fetch" !== t.type || "function" != typeof (null == e ? void 0 : e.urlHandler) ? (t.url = Z(t.url), A.speedLogPipeline(t)) : A.speedLogPipeline(q(q({}, t), {
                    url: Z(e.urlHandler(t.url, t.payload))
                }));
            });
        },
        publishNormalLog: function(e) {
            this.$walk(function(A) {
                A.normalLogPipeline(e);
            });
        },
        destroy: function() {
            var e, t, A;
            this.option.publishSpeed = function() {}, this.option.publishNormalLog = function() {}, this.option.hackXHROptions && (e = this.option.hackXHROptions, -1 !== (A = ve.findIndex(function(A) {
                return A.name === e.name;
            }))) && ve.splice(A, 1), this.option.hackFetchOptions && (t = this.option.hackFetchOptions, -1 !== (A = Le.findIndex(function(A) {
                return A.name === t.name;
            }))) && Le.splice(A, 1), this.option.override = !1;
        }
    })), Te = {}, Oe = new t({
        name: "reportBridgeSpeed",
        override: !1,
        onNewAegis: function(A) {
            this.override || (this.override = !0, this.overrideBridge(A));
        },
        getFromParam: function(A) {
            return A.getCurrentPageUrl();
        },
        publishSpeed: function(e, t) {
            this.$walk(function(A) {
                A === t && A.speedLogPipeline(e);
            });
        },
        overrideBridge: function(c) {
            var B = this, l = c.config;
            l.reportBridgeSpeed && l.h5Bridge && l.h5BridgeFunc.length && l.h5BridgeFunc.forEach(function(A) {
                var a = l.h5Bridge[A];
                Te[A] = a, l.h5Bridge[A] = function() {
                    for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
                    var n = A[0], r = A[1], t = A[2], o = A[3], i = Date.now(), s = B.getFromParam(c);
                    a(n, r, t, function(A) {
                        var e = tA(A, l.api), t = e.code, e = e.isErr, t = {
                            url: n + "-" + r,
                            name: n + "-" + r,
                            duration: Date.now() - i,
                            type: "bridge",
                            ret: t,
                            isErr: +e,
                            from: s
                        };
                        B.publishSpeed(t, c), o(A);
                    });
                };
            });
        },
        unHackBridge: function(e) {
            Object.keys(Te).forEach(function(A) {
                Te[A] && (e.config.h5Bridge[A] = Te[A]);
            }), Te = {};
        },
        destroy: function(A) {
            this.option.publishSpeed = function() {}, this.option.unHackBridge(A), this.option.override = !1;
        }
    }), n = ((n = ue = ue || {})[n.unknown = 100] = "unknown", n[n.wifi = 1] = "wifi", n[n.net2g = 2] = "net2g", n[n.net3g = 3] = "net3g", n[n.net4g = 4] = "net4g", n[n.net5g = 5] = "net5g", n[n.net6g = 6] = "net6g", (n = ge = ge || {})[n.android = 1] = "android", n[n.ios = 2] = "ios", n[n.windows = 3] = "windows", n[n.macos = 4] = "macos", n[n.linux = 5] = "linux", n[n.other = 100] = "other", (n = we = we || {})[n.unknown = 100] = "unknown", n[n.normal = 0] = "normal", n[n.weak = 1] = "weak", n[n.disconnected = 2] = "disconnected", new t({
        name: "device",
        onNewAegis: function(A) {
            A.extendBean("platform", this.getPlatform()), A.extendBean("netType", ue.unknown), this.getDpi(A), this.refreshNetworkTypeToBean(A), this.refreshNetworkStatusToBean(A);
        },
        getDpi: function(A) {
            A.extendBean("vp", Math.round(window.innerWidth) + " * " + Math.round(window.innerHeight)), window.screen && A.extendBean("sr", Math.round(window.screen.width) + " * " + Math.round(window.screen.height));
        },
        getPlatform: function() {
            var e = {
                android: /\bAndroid\s*([^;]+)/,
                ios: /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/,
                windows: /\b(Windows NT)/,
                macos: /\b(Mac OS)/,
                linux: /\b(Linux)/i
            }, A = Object.keys(e).find(function(A) {
                return e[A].test(navigator.userAgent);
            });
            return A ? ge[A] : ge.other;
        },
        refreshNetworkTypeToBean: function(e) {
            var t = this, A = e.config;
            A && ("function" == typeof A.getNetworkType ? A.getNetworkType : xe)(function(A) {
                ue[A] || (A = ue.unknown), e.extendBean("netType", A), t.NetworkRefreshTimer = setTimeout(function() {
                    t.refreshNetworkTypeToBean(e), clearTimeout(t.NetworkRefreshTimer);
                }, 1e4);
            });
        },
        refreshNetworkStatusToBean: function(e) {
            var A, t = this, n = e.config;
            n && null != (A = "function" == typeof n.getNetworkStatus ? n.getNetworkStatus : A) && A(function(A) {
                void 0 === we[A] && (A = we.unknown), e.extendBean("netStatus", A), t.NetworkStatusRefreshTimer = setTimeout(function() {
                    t.refreshNetworkStatusToBean(e), clearTimeout(t.NetworkStatusRefreshTimer);
                }, 1e4);
            });
        }
    })), xe = function(A) {
        var e = "", t = navigator.userAgent.match(/NetType\/(\w+)/);
        t ? e = t[1] : navigator.connection && (e = navigator.connection.effectiveType || navigator.connection.type), A((t = e = e || m, 0 <= (t = String(t).toLowerCase()).indexOf("4g") ? ue.net4g : 0 <= t.indexOf("wifi") ? ue.wifi : 0 <= t.indexOf("5g") ? ue.net5g : 0 <= t.indexOf("6g") ? ue.net6g : 0 <= t.indexOf("3g") ? ue.net3g : 0 <= t.indexOf("2g") ? ue.net2g : ue.unknown));
    }, De = window.WebSocket, Re = [], Me = {
        construct: function(A, e) {
            var n = new A(e[0], e[1]);
            return n.originSend = n.send, n.addEventListener("error", function(A) {
                var A = (null == A ? void 0 : A.currentTarget) || {}, e = A.url, t = A.readyState;
                null != Re && Re.forEach(function(A) {
                    A = A.onErr;
                    null != A && A({
                        msg: "\u65E0\u6CD5\u83B7\u77E5\u5177\u4F53\u9519\u8BEF\u4FE1\u606F\uFF0C\u9700\u5728\u6D4F\u89C8\u5668\u63A7\u5236\u53F0\u67E5\u770B\uFF01",
                        readyState: t,
                        connectUrl: e
                    });
                });
            }), Object.defineProperty(n, "send", {
                get: function() {
                    return function(A) {
                        null != (e = n.originSend) && e.call(n, A);
                        var e = n.readyState;
                        if (e !== WebSocket.OPEN) {
                            var t = {
                                readyState: e,
                                connectUrl: n.url
                            };
                            switch(e){
                                case WebSocket.CLOSED:
                                    Re.forEach(function(A) {
                                        A = A.sendErr;
                                        null != A && A(q({
                                            msg: "\u6D88\u606F\u53D1\u9001\u5931\u8D25\uFF0C\u8FDE\u63A5\u5DF2\u5173\u95ED\uFF01"
                                        }, t));
                                    });
                                    break;
                                case WebSocket.CONNECTING:
                                    Re.forEach(function(A) {
                                        (0, A.sendErr)(q({
                                            msg: "\u6D88\u606F\u53D1\u9001\u5931\u8D25\uFF0C\u6B63\u5728\u8FDE\u63A5\u4E2D\uFF01"
                                        }, t));
                                    });
                                    break;
                                case WebSocket.CLOSING:
                                    Re.forEach(function(A) {
                                        (0, A.sendErr)(q({
                                            msg: "\u6D88\u606F\u53D1\u9001\u5931\u8D25\uFF0C\u8FDE\u63A5\u6B63\u5728\u5173\u95ED\uFF01"
                                        }, t));
                                    });
                            }
                        }
                    };
                }
            }), n;
        }
    }, Pe = new t({
        name: "onError"
    }), ke = Pe = new t({
        name: "onError",
        onNewAegis: function(A) {
            this.startListen(A);
        },
        getFromParam: function(A) {
            return A.getCurrentPageUrl();
        },
        startListen: function(i) {
            function A(A) {
                var e, t = A && hA(A.reason);
                t && s.publishErrorLog({
                    msg: "PROMISE_ERROR: " + t,
                    errorMsg: null == (e = null == (A = (null == (e = A.reason) ? void 0 : e.message) || (null == (e = A.reason) ? void 0 : e.errMsg) || t) ? void 0 : A.slice) ? void 0 : e.call(A, 0, 150),
                    level: j.PROMISE_ERROR,
                    from: s.getFromParam(i),
                    originFrom: i.getOriginFrom()
                }, i);
            }
            function e(A) {
                var e;
                if (A = (null == A ? void 0 : A.target) || (null == A ? void 0 : A.srcElement)) {
                    var t = A.src || A.href || "", n = A.tagName, n = (void 0 === n ? "script" : n).toLowerCase(), r = [
                        "audio",
                        "video"
                    ].includes(n);
                    if (!r || null != A && A.error) {
                        if (!(oA(e = t, i.config.hostUrl) || -1 < window.location.href.indexOf(e))) {
                            var o = {
                                msg: n + " load fail: " + t + " " + (r ? "\n\nerror code: " + (null == (e = null == A ? void 0 : A.error) ? void 0 : e.code) + ("" !== (null == (r = null == A ? void 0 : A.error) ? void 0 : r.message) ? "\nerror msg: " + (null == (e = null == A ? void 0 : A.error) ? void 0 : e.message) : "") : ""),
                                level: j.INFO,
                                from: s.getFromParam(i),
                                originFrom: i.getOriginFrom()
                            };
                            if (/\.js$/.test(t)) o.level = j.SCRIPT_ERROR;
                            else if (/\.css$/.test(t)) o.level = j.CSS_ERROR;
                            else switch(n){
                                case "script":
                                    o.level = j.SCRIPT_ERROR;
                                    break;
                                case "link":
                                    o.level = j.CSS_ERROR;
                                    break;
                                case "img":
                                    o.level = j.IMAGE_ERROR;
                                    break;
                                case "audio":
                                case "video":
                                    o.level = j.MEDIA_ERROR;
                                    break;
                                default:
                                    return;
                            }
                            s.publishErrorLog(o, i);
                        }
                    } else console.log("may be media load success because error is undefine");
                }
            }
            var t, n, r, o, s = this, a = window.onerror;
            window.onerror = function() {
                for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
                var t, n = hA(A[0]);
                "string" != typeof (t = n) || !t || G.some(function(A) {
                    return -1 < t.indexOf(A);
                }) || k.some(function(A) {
                    return -1 < t.indexOf(A);
                }) || s.publishErrorLog({
                    msg: (n || "") + " @ (" + (hA(A[1]) || "") + ":" + (A[2] || 0) + ":" + (A[3] || 0) + ")\n          \n" + hA(A[4] || ""),
                    level: j.ERROR,
                    from: s.getFromParam(i),
                    originFrom: i.getOriginFrom()
                }, i), null != a && a.call.apply(a, M([
                    window
                ], A));
            }, window.addEventListener("unhandledrejection", A);
            window.document.addEventListener("error", e, !0), i.lifeCycle.on("destroy", function() {
                0 === Pe.countInstance() && (window.document.removeEventListener("unhandledrejection", A), window.document.removeEventListener("error", e, !0));
            }), i.config.websocketHack && (t = {
                key: i.config.id + "-" + this.name,
                onErr: function(A) {
                    var e;
                    null != (e = s.publishWsErrorLog) && e.call(s, A, i);
                },
                sendErr: function(A) {
                    var e;
                    null != (e = s.publishWsErrorLog) && e.call(s, A, i);
                }
            }, this.hackWebsocketConfig = t, t = this.hackWebsocketConfig, window.Proxy) && window.WebSocket && (n = window.WebSocket, window && !n.isHack && (r = new Proxy(WebSocket, Me), n.isHack = !0, window.WebSocket = r), o = t, Re.find(function(A) {
                return A.key === o.key;
            }) || o && Re.push(o));
        },
        publishErrorLog: function(e, t) {
            this.$walk(function(A) {
                A === t && A.normalLogPipeline(e);
            });
        },
        publishWsErrorLog: function(A, e) {
            var t = A.connectUrl;
            this.publishErrorLog({
                msg: "WEBSOCKET_ERROR: \n              connect: " + t + "\n              readyState: " + A.readyState + "\n              msg: " + A.msg,
                level: j.WEBSOCKET_ERROR,
                from: this.getFromParam(e),
                originFrom: e.getOriginFrom()
            }, e);
        },
        destroy: function() {
            var e, A;
            this.option.publishErrorLog = function() {}, this.option.hackWebsocketConfig && (e = this.option.hackWebsocketConfig, window.WebSocket = De, -1 !== (A = Re.findIndex(function(A) {
                return A.key === e.key;
            }))) && Re.splice(A, 1);
        }
    }), Ge = (new t({
        name: "clickElementLog"
    }), function(A) {
        if ("" !== A.id && A.id) return 'id("' + A.id + '")';
        if (A === document.body) return A.tagName;
        if (A instanceof Document) return "document";
        var e = 0;
        if (A.parentNode) for(var t = A.parentNode.childNodes, n = 0; n < t.length; n += 1){
            var r = t[n];
            if (r === A) return Ge(A.parentNode) + "/" + A.tagName + "[" + (e + 1) + "]";
            1 === r.nodeType && r.tagName === A.tagName && (e += 1);
        }
        return 0;
    }), Ne = function(A) {
        return A instanceof Array ? new Map(A.map(function(A) {
            return [
                A,
                !0
            ];
        })) : new Map;
    }, Ve = function(A, e) {
        return "string" == typeof A ? A.split(e) : [];
    }, Xe = function(A) {
        if (3 === A.nodeType || 4 === A.nodeType) return A.nodeValue || "";
        if (1 !== A.nodeType) return "";
        if ("string" == typeof A.textContent) return A.textContent;
        for(var e = "", t = A.firstChild; t; t = t.nextSibling)e += Xe(t);
        return e;
    }, Je = new t({
        name: "clickElementLog",
        listeners: [],
        onNewAegis: function(A) {
            this.startListen(A);
        },
        startListen: function(i) {
            for(var A = function(o) {
                e.listeners.push(((A, e, t, n)=>{
                    function r(A) {
                        var e = document.documentElement;
                        e && t.call(e, A, A.target);
                    }
                    return void 0 === n && (n = !0), A.addEventListener(e, r, n), {
                        destroy: function() {
                            A.removeEventListener(e, r, n);
                        }
                    };
                })(document, o, function(A, e) {
                    var t, n, r;
                    e && !((A, e)=>{
                        t = Ne((null == (t = A.ignoreElements) ? void 0 : t.ignoreClasses) || []) || new Map;
                        for(var t, n = (A = {
                            ignoreIds: Ne((null == (A = A.ignoreElements) ? void 0 : A.ignoreIds) || []) || new Map,
                            ignoreClasses: t
                        }).ignoreClasses, r = A.ignoreIds, o = !(0 === r.size && 0 === n.size), i = e, s = (Ve(e.getAttribute("id") || "", " "), Ve(e.getAttribute("class") || "", ""), 0), a = !1; i && o && i.getAttribute;){
                            if (a) return !0;
                            if (10 <= s) break;
                            for(var c = Ve(i.getAttribute("id") || "", " "), B = Ve(i.getAttribute("class") || "", ""), l = 0, u = c; l < u.length; l++){
                                var g = u[l];
                                if (r.has(g)) {
                                    a = !0;
                                    break;
                                }
                            }
                            for(var w = 0, d = B; w < d.length; w++){
                                var h = d[w];
                                if (n.has(h)) {
                                    a = !0;
                                    break;
                                }
                            }
                            s += 1, i = i.parentNode || i.parentElement;
                        }
                        return !1;
                    })(i.config, e) && (t = Ge(e), n = se(e), r = e.getBoundingClientRect && e.getBoundingClientRect(), e = {
                        op: o,
                        view_type: (null == e ? void 0 : e.nodeName) || "",
                        view_text: n.slice(0, 127),
                        view_tag: t,
                        page: ie(),
                        page_id: ie(),
                        view_pos: {
                            p0: (parseInt(String(r.left), 10) || -1) + "," + (parseInt(String(r.top), 10) || -1),
                            p1: (parseInt(String(r.left + window.scrollX), 10) || -1) + "," + (parseInt(String(r.top + window.scrollY), 10) || -1)
                        }
                    }, i.normalLogPipeline({
                        msg: e,
                        level: j.CLICK_EVENT,
                        errorMsg: "",
                        originFrom: i.getOriginFrom()
                    }));
                }, !0));
            }, e = this, t = 0, n = Object.entries({
                click: 1,
                longpress: 2
            }); t < n.length; t++)A(n[t][0]);
        },
        destroy: function() {
            this.listeners.forEach(function(A) {
                return A.destroy();
            }), this.listeners = [];
        }
    }), We = (new t({
        name: "consoleLog"
    }), {
        log: console.log,
        error: console.error,
        warn: console.warn,
        info: console.info,
        debug: console.debug,
        trace: console.trace
    }), _e = new t({
        name: "consoleLog",
        onNewAegis: function(A) {
            this.startListen(A);
        },
        startListen: function(A) {
            var o;
            o = A, [
                "log",
                "error",
                "warn",
                "info",
                "debug",
                "trace"
            ].forEach(function(n) {
                var r = We[n];
                console[n] = function() {
                    for(var A, e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                    try {
                        r.apply(console, e), !o.isWhiteList && [
                            "log",
                            "info",
                            "debug",
                            "trace"
                        ].includes(n) || (A = e.map(function(A) {
                            if ("object" == typeof A && null !== A) try {
                                return JSON.stringify(A);
                            } catch (A) {}
                            return String(A);
                        }).join(" "), o.normalLogPipeline({
                            msg: "method: console." + n + "\nmessage: " + A,
                            level: j.CONSOLE_LOG,
                            errorMsg: "",
                            originFrom: o.getOriginFrom()
                        }));
                    } catch (A) {
                        We.error("Console hook error:", A);
                    }
                };
            });
        },
        destroy: function() {
            Object.keys(We).forEach(function(A) {
                console[A] = We[A];
            });
        }
    });
    function Ye() {
        Qe = [], he = -1, de = null, ye(addEventListener);
    }
    pe = {
        passive: !0,
        capture: !0
    }, Ce = new Date, Ue = function(A, e) {
        de || (de = e, he = A, fe = new Date, ye(removeEventListener), Fe());
    }, Fe = function() {
        var e;
        0 <= he && he < fe - Ce && (e = {
            entryType: "first-input",
            name: de.type,
            target: de.target,
            cancelable: de.cancelable,
            startTime: de.timeStamp,
            processingStart: de.timeStamp + he
        }, Qe.forEach(function(A) {
            A(e);
        }), Qe = []);
    }, me = function(A) {
        var e, t, n, r, o, i;
        A.cancelable && (e = (1e12 < A.timeStamp ? new Date : performance.now()) - A.timeStamp, "pointerdown" == A.type ? (t = e, n = A, r = function() {
            Ue(t, n), i();
        }, o = function() {
            i();
        }, i = function() {
            removeEventListener("pointerup", r, pe), removeEventListener("pointercancel", o, pe);
        }, addEventListener("pointerup", r, pe), addEventListener("pointercancel", o, pe)) : Ue(e, A));
    }, ye = function(e) {
        [
            "mousedown",
            "keydown",
            "touchstart",
            "pointerdown"
        ].forEach(function(A) {
            return e(A, me, pe);
        });
    }, Ee = "hidden" === document.visibilityState ? 0 : 1 / 0, addEventListener("visibilitychange", function A(e) {
        "hidden" === document.visibilityState && (Ee = e.timeStamp, removeEventListener("visibilitychange", A, !0));
    }, !0), Ye(), self.webVitals = {
        firstInputPolyfill: function(A) {
            Qe.push(A), Fe();
        },
        resetFirstInputPolyfill: Ye,
        get firstHiddenTime () {
            return Ee;
        }
    };
    function Ze(A, e) {
        var t = Ut(), n = "navigate";
        return 0 <= pt ? n = "back-forward-cache" : t && (document.prerendering || 0 < Ft() ? n = "prerender" : document.wasDiscarded ? n = "restore" : t.type && (n = t.type.replace(/_/g, "-"))), {
            name: A,
            value: void 0 === e ? -1 : e,
            rating: "good",
            delta: 0,
            entries: [],
            id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
            navigationType: n
        };
    }
    function qe(A, e, t) {
        try {
            var n;
            if (PerformanceObserver.supportedEntryTypes.includes(A)) return (n = new PerformanceObserver(function(A) {
                Promise.resolve().then(function() {
                    e(A.getEntries());
                });
            })).observe(Object.assign({
                type: A,
                buffered: !0
            }, t || {})), n;
        } catch (A) {}
    }
    function je(e, t, n, r) {
        var o, i;
        return function(A) {
            0 <= t.value && (A || r) && ((i = t.value - (o || 0)) || void 0 === o) && (o = t.value, t.delta = i, t.rating = (A = t.value) > n[1] ? "poor" : A > n[0] ? "needs-improvement" : "good", e(t));
        };
    }
    function ze(A) {
        requestAnimationFrame(function() {
            return requestAnimationFrame(function() {
                return A();
            });
        });
    }
    function $e(e) {
        function A(A) {
            "pagehide" !== A.type && "hidden" !== document.visibilityState || e(A);
        }
        addEventListener("visibilitychange", A, !0), addEventListener("pagehide", A, !0);
    }
    function At(e) {
        var t = !1;
        return function(A) {
            t || (e(A), t = !0);
        };
    }
    function et() {
        return mt < 0 && (mt = yt(), Ht(), Ct(function() {
            setTimeout(function() {
                mt = yt(), Ht();
            }, 0);
        })), {
            get firstHiddenTime () {
                return mt;
            }
        };
    }
    function tt(A) {
        document.prerendering ? addEventListener("prerenderingchange", function() {
            return A();
        }, !0) : A();
    }
    function nt(o, i) {
        i = i || {}, tt(function() {
            var e, t = et(), n = Ze("FCP"), r = qe("paint", function(A) {
                A.forEach(function(A) {
                    "first-contentful-paint" === A.name && (r.disconnect(), A.startTime < t.firstHiddenTime) && (n.value = Math.max(A.startTime - Ft(), 0), n.entries.push(A), e(!0));
                });
            });
            r && (e = je(o, n, It, i.reportAllChanges), Ct(function(A) {
                n = Ze("FCP"), e = je(o, n, It, i.reportAllChanges), ze(function() {
                    n.value = performance.now() - A.timeStamp, e(!0);
                });
            }));
        });
    }
    function rt(A) {
        var e, t, n, r, o, i;
        A.cancelable && (e = (1e12 < A.timeStamp ? new Date : performance.now()) - A.timeStamp, "pointerdown" == A.type ? (t = e, n = A, r = function() {
            St(t, n), i();
        }, o = function() {
            i();
        }, i = function() {
            removeEventListener("pointerup", r, Lt), removeEventListener("pointercancel", o, Lt);
        }, addEventListener("pointerup", r, Lt), addEventListener("pointercancel", o, Lt)) : St(e, A));
    }
    function ot(A) {
        A.forEach(function(A) {
            A.interactionId && (Rt = Math.min(Rt, A.interactionId), Mt = Math.max(Mt, A.interactionId), Dt = Mt ? (Mt - Rt) / 7 + 1 : 0);
        });
    }
    function it() {
        return Pt() - Gt;
    }
    function st(A) {
        var e = Nt[Nt.length - 1], t = Vt[A.interactionId];
        (t || Nt.length < 10 || A.duration > e.latency) && (t ? (t.entries.push(A), t.latency = Math.max(t.latency, A.duration)) : (e = {
            id: A.interactionId,
            latency: A.duration,
            entries: [
                A
            ]
        }, Vt[e.id] = e, Nt.push(e)), Nt.sort(function(A, e) {
            return e.latency - A.latency;
        }), Nt.splice(10).forEach(function(A) {
            delete Vt[A.id];
        }));
    }
    function at(A, e) {
        function t(e, t, n, r) {
            function o(A) {
                "visibilitychange" === e && "hidden" !== document.visibilityState || (r ? setTimeout(function() {
                    return t(A);
                }, r) : t(A), n && removeEventListener(e, o, !0));
            }
            addEventListener(e, o, !0);
        }
        var n;
        t("visibilitychange", A, null == e ? void 0 : e.once, null == (n = null == e ? void 0 : e.delay) ? void 0 : n.visibilitychange), t("pagehide", A, null == e ? void 0 : e.once, null == (n = null == e ? void 0 : e.delay) ? void 0 : n.pagehide), t("beforeunload", A, null == e ? void 0 : e.once, null == (n = null == e ? void 0 : e.delay) ? void 0 : n.beforeunload);
    }
    function ct(A) {
        var e = A.name;
        0 < (A = A.value) && (_t[e] = A);
    }
    function Bt(A, e, t, n) {
        return void 0 === t && (t = 15e3), void 0 === n && (n = 0), (e = void 0 === e ? 0 : e) <= A && A <= t ? A : n;
    }
    var lt, ut, gt, wt, dt, ht, ft, Qt, pt = -1, Ct = function(e) {
        addEventListener("pageshow", function(A) {
            A.persisted && (pt = A.timeStamp, e(A));
        }, !0);
    }, Ut = function() {
        return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    }, Ft = function() {
        var A = Ut();
        return A && A.activationStart || 0;
    }, mt = -1, yt = function() {
        return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
    }, Et = function(A) {
        "hidden" === document.visibilityState && -1 < mt && (mt = "visibilitychange" === A.type ? A.timeStamp : 0, vt());
    }, Ht = function() {
        addEventListener("visibilitychange", Et, !0), addEventListener("prerenderingchange", Et, !0);
    }, vt = function() {
        removeEventListener("visibilitychange", Et, !0), removeEventListener("prerenderingchange", Et, !0);
    }, It = [
        1800,
        3e3
    ], bt = [
        .1,
        .25
    ], Lt = {
        passive: !0,
        capture: !0
    }, Kt = new Date, St = function(A, e) {
        lt || (lt = e, ut = A, gt = new Date, Ot(removeEventListener), Tt());
    }, Tt = function() {
        var e;
        0 <= ut && ut < gt - Kt && (e = {
            entryType: "first-input",
            name: lt.type,
            target: lt.target,
            cancelable: lt.cancelable,
            startTime: lt.timeStamp,
            processingStart: lt.timeStamp + ut
        }, wt.forEach(function(A) {
            A(e);
        }), wt = []);
    }, Ot = function(e) {
        [
            "mousedown",
            "keydown",
            "touchstart",
            "pointerdown"
        ].forEach(function(A) {
            return e(A, rt, Lt);
        });
    }, xt = [
        100,
        300
    ], Dt = 0, Rt = 1 / 0, Mt = 0, Pt = function() {
        return dt ? Dt : performance.interactionCount || 0;
    }, kt = [
        200,
        500
    ], Gt = 0, Nt = [], Vt = {}, Xt = [
        2500,
        4e3
    ], Jt = {}, Wt = (tn.prototype.start = function() {
        var e = this, t = new PerformanceObserver(function(A) {
            A = A.getEntriesByName("first-contentful-paint");
            0 < A.length && (e.fcp = A[0].startTime, e.slientWindowStartTime = e.fcp, t.disconnect(), setTimeout(function() {
                e.checkTTI();
            }, Math.max(e.slienceTimeInterval - (performance.now() - e.fcp) + 20, 1)));
        });
        t.observe({
            entryTypes: [
                "paint"
            ]
        }), this.longtaskObserver = new PerformanceObserver(function(A) {
            A = A.getEntries();
            e.longTaskEntries = e.longTaskEntries.concat(A);
        }), this.longtaskObserver.observe({
            entryTypes: [
                "longtask"
            ]
        }), this.resourceObserver = new PerformanceObserver(function(A) {
            A = A.getEntries();
            e.resourceEntries = e.resourceEntries.concat(A);
        }), this.resourceObserver.observe({
            entryTypes: [
                "resource"
            ]
        });
    }, tn.prototype.checkTTI = function() {
        var A = this;
        this.hasSlientWindow() ? (this.calculateTTI(), this.longtaskObserver.disconnect(), this.resourceObserver.disconnect()) : setTimeout(function() {
            A.checkTTI();
        }, this.checkInterval);
    }, tn.prototype.hasSlientWindow = function() {
        var A, e = performance.now();
        return !(e - this.slientWindowStartTime < 5e3 || ((A = this.getLastLongTaskEndTime()) > this.slientWindowStartTime ? (this.slientWindowStartTime = A, this.resourceEntries = []) : this.getRequestCount(this.slientWindowStartTime, e) <= 2 ? (this.lastLongtaskEndTime = A, 0) : (e = this.resourceEntries.sort(function(A, e) {
            return A.startTime - e.startTime;
        }), this.slientWindowStartTime = e[this.resourceEntries.length - 2].startTime, 1)));
    }, tn.prototype.getLastLongTaskEndTime = function() {
        var e;
        return 0 === this.longTaskEntries.length ? -1 : (e = 0, this.longTaskEntries.forEach(function(A) {
            A.startTime + A.duration > e && (e = A.startTime + A.duration);
        }), e);
    }, tn.prototype.getRequestCount = function(e, t) {
        var n = 0;
        return this.resourceEntries.forEach(function(A) {
            A.startTime >= e && A.startTime + A.duration <= t && (n += 1);
        }), n;
    }, tn.prototype.calculateTTI = function() {
        var A = -1 === this.lastLongtaskEndTime ? this.slientWindowStartTime : this.lastLongtaskEndTime, e = performance.timing.domContentLoadedEventEnd - performance.timing.navigationStart, A = Math.max(e, A);
        this.onTTICallback(A);
    }, tn), _t = (new t({
        name: "webVitals"
    }), {
        FCP: -1,
        LCP: -1,
        FID: -1,
        CLS: -1,
        INP: -1,
        TTI: -1,
        from: void 0
    }), Yt = new Map, Zt = new t({
        name: "webVitals",
        onNewAegis: function(A) {
            var e, t, o, i, s, a, c, B, l, u, n = this;
            if (kA() && "function" == typeof window.PerformanceObserver && "function" == typeof performance.getEntriesByName) try {
                Yt.set(A, {
                    isWebVitalsReported: !1,
                    hasFirstEntry: !1,
                    custom: null
                }), nt(ct), l = ct, u = {}, tt(function() {
                    function A(A) {
                        (A = A[A.length - 1]) && A.startTime < n.firstHiddenTime && (r.value = Math.max(A.startTime - Ft(), 0), r.entries = [
                            A
                        ], e());
                    }
                    var e, t, n = et(), r = Ze("LCP"), o = qe("largest-contentful-paint", A);
                    o && (e = je(l, r, Xt, u.reportAllChanges), t = At(function() {
                        Jt[r.id] || (A(o.takeRecords()), o.disconnect(), Jt[r.id] = !0, e(!0));
                    }), [
                        "keydown",
                        "click"
                    ].forEach(function(A) {
                        addEventListener(A, function() {
                            return setTimeout(t, 0);
                        }, !0);
                    }), $e(t), Ct(function(A) {
                        r = Ze("LCP"), e = je(l, r, Xt, u.reportAllChanges), ze(function() {
                            r.value = performance.now() - A.timeStamp, Jt[r.id] = !0, e(!0);
                        });
                    }));
                }), c = ct, B = {}, tt(function() {
                    function e(A) {
                        A.startTime < t.firstHiddenTime && (n.value = A.processingStart - A.startTime, n.entries.push(A), o(!0));
                    }
                    function A(A) {
                        A.forEach(e);
                    }
                    var t = et(), n = Ze("FID"), r = qe("first-input", A), o = je(c, n, xt, B.reportAllChanges);
                    r && $e(At(function() {
                        A(r.takeRecords()), r.disconnect();
                    })), r && Ct(function() {
                        n = Ze("FID"), o = je(c, n, xt, B.reportAllChanges), wt = [], ut = -1, lt = null, Ot(addEventListener), wt.push(e), Tt();
                    });
                }), s = ct, a = {}, nt(At(function() {
                    function A(A) {
                        A.forEach(function(A) {
                            var e, t;
                            A.hadRecentInput || (e = r[0], t = r[r.length - 1], n && A.startTime - t.startTime < 1e3 && A.startTime - e.startTime < 5e3 ? (n += A.value, r.push(A)) : (n = A.value, r = [
                                A
                            ]));
                        }), n > t.value && (t.value = n, t.entries = r, e());
                    }
                    var e, t = Ze("CLS", 0), n = 0, r = [], o = qe("layout-shift", A);
                    o && (e = je(s, t, bt, a.reportAllChanges), $e(function() {
                        A(o.takeRecords()), e(!0);
                    }), Ct(function() {
                        t = Ze("CLS", n = 0), e = je(s, t, bt, a.reportAllChanges), ze(function() {
                            return e();
                        });
                    }), setTimeout(e, 0));
                })), o = ct, i = {}, tt(function() {
                    var A;
                    "interactionCount" in performance || (dt = dt || qe("event", ot, {
                        type: "event",
                        buffered: !0,
                        durationThreshold: 0
                    }));
                    function e(A) {
                        A.forEach(function(e) {
                            e.interactionId && st(e), "first-input" !== e.entryType || Nt.some(function(A) {
                                return A.entries.some(function(A) {
                                    return e.duration === A.duration && e.startTime === A.startTime;
                                });
                            }) || st(e);
                        }), A = Math.min(Nt.length - 1, Math.floor(it() / 50)), (A = Nt[A]) && A.latency !== t.value && (t.value = A.latency, t.entries = A.entries, r());
                    }
                    var t = Ze("INP"), n = qe("event", e, {
                        durationThreshold: null != (A = i.durationThreshold) ? A : 40
                    }), r = je(o, t, kt, i.reportAllChanges);
                    n && ("PerformanceEventTiming" in window && "interactionId" in PerformanceEventTiming.prototype && n.observe({
                        type: "first-input",
                        buffered: !0
                    }), $e(function() {
                        e(n.takeRecords()), t.value < 0 && 0 < it() && (t.value = 0, t.entries = []), r(!0);
                    }), Ct(function() {
                        Nt = [], Gt = Pt(), t = Ze("INP"), r = je(o, t, kt, i.reportAllChanges);
                    }));
                }), t = function(A) {
                    ct({
                        name: "TTI",
                        value: A
                    });
                }, kA() && new Wt(t).start(), at(function() {
                    n.tryReport(A, null, "onHidden");
                }, {
                    once: !0,
                    delay: {
                        visibilitychange: 10
                    }
                }), _t.from = null == (e = A) ? void 0 : e.getCurrentPageUrl();
            } catch (A) {}
        },
        tryReport: function(e, t, n) {
            var r = this;
            void 0 === n && (n = "manual"), this.$walk(function(A) {
                A === e && ("object" == typeof (A = r.$getConfig(e)) && !0 === A.manualReport || "onHidden" !== n ? (A = Yt.get(e)) && !A.hasFirstEntry ? (A.hasFirstEntry = !0, "manual" === n && t && (A.custom = t)) : r.doReport(e, (null == A ? void 0 : A.custom) || t) : r.doReport(e, null));
            });
        },
        doReport: function(t, n) {
            var A = Yt.get(t);
            if (A) {
                if (null != A && A.isWebVitalsReported) return;
                A.isWebVitalsReported = !0;
            }
            this.$walk(function(o) {
                var A, e;
                o === t && (e = q({}, _t), n && Object.keys(n).forEach(function(A) {
                    null != n[A] && (e[A] = n[A]);
                }), null != (A = o.sendPipeline)) && A.call(o, [
                    function(A, e) {
                        var t, n = [];
                        for(t in A)"from" !== t && n.push(t + "=" + A[t]);
                        var r = -1 === (null == (r = null == (r = o.config) ? void 0 : r.performanceUrl) ? void 0 : r.indexOf("?")) ? "?" : "&";
                        e({
                            url: o.config.webVitalsUrl + r + n.join("&"),
                            type: d.VITALS,
                            log: A,
                            sendBeacon: !0
                        });
                    }
                ], d.VITALS)(e);
            });
        },
        publish: function(A, e) {
            this.tryReport(A, e, "manual");
        },
        destroy: function() {
            this.option.publish = function() {};
        }
    }), qt = (new t({
        name: "pagePerformance"
    }), 3), jt = new Map, zt = new t({
        name: "pagePerformance",
        performanceMap: {},
        onNewAegis: function(e) {
            var A;
            kA() && (jt.set(e, {
                isPagePerformanceReported: !1
            }), ht ? this.publish(ht, e) : this.startCalcPerformance(e), A = this.publishWhenObHidden.bind(this, e), at(A, {
                once: !0
            }), e.lifeCycle.on("destroy", function() {
                var A = jt.get(e);
                A && (A.isPagePerformanceReported = !1);
            }));
        },
        publishWhenObHidden: function(A) {
            var e, t = jt.get(A);
            if (null == t || !t.isPagePerformanceReported) {
                t = 0;
                if (null != (e = A.firstScreenInfo) && e.timing) t = A.firstScreenInfo.timing;
                else if (GA("paint")) try {
                    var n, r = performance.getEntriesByName("first-contentful-paint");
                    r && 0 < r.length && (n = r[0]) && 0 < n.startTime && (t = n.startTime);
                } catch (A) {}
                (ht = this.buildPerformanceLog(A, t, this.getPageUrl(A), window.location.href)) && this.publish(ht, A, !0);
            }
        },
        buildPerformanceLog: function(A, e, t, n) {
            var r = performance.timing;
            if (r) return t = {
                from: t,
                originFrom: n,
                dnsLookup: Bt(r.domainLookupEnd - r.domainLookupStart),
                tcp: Bt(r.connectEnd - r.connectStart),
                ssl: Bt(0 === r.secureConnectionStart ? 0 : r.requestStart - r.secureConnectionStart),
                ttfb: Bt(r.responseStart - r.requestStart),
                contentDownload: Bt(r.responseEnd - r.responseStart),
                domParse: Bt(r.domInteractive - r.domLoading, 0, 15e3, 1070),
                resourceDownload: Bt(r.loadEventStart - r.domInteractive, 0, 15e3, 1070),
                firstScreenTiming: Bt(Math.floor(e), 0, 15e3, 15e3)
            }, (n = A.config).extraPerformanceData && "{}" !== JSON.stringify(n.extraPerformanceData) && (e = (r = n.extraPerformanceData).engineInit, A = r.bundleLoad, t = q(q({}, t), {
                engineInit: Bt(e, 0, 1e4),
                bundleLoad: Bt(A, 0, 1e4)
            })), t;
        },
        publish: function(i, s, a) {
            var c = this;
            void 0 === a && (a = !1), this.$walk(function(o) {
                var A, r;
                o === s && ((A = jt.get(o)) && (A.isPagePerformanceReported = !0), r = i.originFrom || window.location.href, i.originFrom && delete i.originFrom, o.sendPipeline([
                    function(A, e) {
                        var t, n, r = [];
                        for(t in A)"from" !== t && r.push(t + "=" + A[t]);
                        if (c.$getConfig(o)) return n = -1 === (null == (n = o.config.performanceUrl) ? void 0 : n.indexOf("?")) ? "?" : "&", e({
                            url: o.config.performanceUrl + n + r.join("&"),
                            type: d.PERFORMANCE,
                            log: A,
                            sendBeacon: a
                        });
                    }
                ], d.PERFORMANCE)(q({}, i)), setTimeout(function() {
                    var A = [
                        "duration: " + (i.dnsLookup + i.tcp + i.ssl + i.ttfb + i.contentDownload + i.domParse + i.resourceDownload) + "ms",
                        "firstScreenTiming: " + i.firstScreenTiming + "ms",
                        "dnsLookup: " + i.dnsLookup + "ms",
                        "tcp: " + i.tcp + "ms",
                        "ssl: " + i.ssl + "ms",
                        "ttfb: " + i.ttfb + "ms",
                        "contentDownload: " + i.contentDownload + "ms",
                        "domParse: " + i.domParse + "ms",
                        "resourceDownload: " + i.resourceDownload + "ms",
                        "lcp: " + _t.LCP + "ms",
                        "fid: " + _t.FID + "ms",
                        "cls: " + _t.CLS + "ms",
                        "fcp: " + _t.FCP + "ms",
                        i.engineInit ? "engineInit: " + i.engineInit + "ms" : "",
                        i.bundleLoad ? "bundleLoad: " + i.bundleLoad + "ms" : ""
                    ].filter(function(A) {
                        return A;
                    }).join("\n\n"), e = c.$getConfig(o), t = !1;
                    if ("function" == typeof (null == e ? void 0 : e.isSlowPage)) try {
                        t = null == e ? void 0 : e.isSlowPage(i, _t);
                    } catch (A) {
                        return void console.warn("[Aegis] isSlowPage function happen error:", A, ", this data will not be reported.");
                    }
                    else null != e && e.slowPageThreshold && "number" == typeof e.slowPageThreshold ? i.firstScreenTiming > (null == e ? void 0 : e.slowPageThreshold) && (t = !0) : t = 1e3 < i.firstScreenTiming;
                    var e = s.config.pageLoadLog, n = s.config.slowPageLoadLog && t, A = {
                        msg: A,
                        ext1: (null == (A = i.firstScreenTiming) ? void 0 : A.toString()) || "",
                        level: t ? j.SLOW_PAGE_LOAD : j.PAGE_LOAD,
                        errorMsg: "",
                        originFrom: r
                    };
                    (e || n) && o.normalLogPipeline(A);
                }, 3e3));
            });
        },
        getPageUrl: function(A) {
            var e = this.$getConfig(A);
            if (null != e && e.urlHandler && "function" == typeof (null == e ? void 0 : e.urlHandler)) {
                e = null == e ? void 0 : e.urlHandler();
                if (e) return encodeURIComponent(e);
            }
            return A.getCurrentPageUrl();
        },
        startCalcPerformance: function(e) {
            var t = this;
            try {
                var n = this.getPageUrl(e), r = e.getOriginFrom();
                this.getFirstScreenTiming(e, function(A) {
                    ht = t.buildPerformanceLog(e, A, n, r);
                    A = jt.get(e);
                    !ht || null != A && A.isPagePerformanceReported || t.publish(ht, e);
                });
            } catch (e) {}
        },
        getFirstScreenTiming: function(s, a) {
            var c = this;
            s.lifeCycle.on("destroy", function() {
                h && clearTimeout(h);
            });
            var B, l = this, t = [
                "script",
                "style",
                "link",
                "br"
            ], u = [], g = {}, w = (GA("paint") && (B = new PerformanceObserver(function(A) {
                A.getEntries().forEach(function(A) {
                    var e;
                    "paint" === A.entryType && "first-contentful-paint" === A.name && 0 < (e = document.querySelectorAll("[AEGIS-FIRST-SCREEN-TIMING]")).length && s.config.id && !c.performanceMap[s.config.id] && (c.setFirstScreenInfo(s, A.startTime, e[0], e), null != a && a(A.startTime), w.disconnect(), B.disconnect(), h) && clearTimeout(h);
                });
            })).observe({
                entryTypes: [
                    "paint"
                ]
            }), new MutationObserver(function(A) {
                var e = {
                    roots: [],
                    ignores: [],
                    rootsDomNum: [],
                    time: performance.now()
                };
                A.forEach(function(A) {
                    A && A.addedNodes && Array.prototype.slice.call(A.addedNodes).forEach(function(A) {
                        l.isEleInArray(A, e.ignores) ? e.ignores.push(A) : 1 === A.nodeType && A.hasAttribute("AEGIS-FIRST-SCREEN-TIMING") ? (Object.prototype.hasOwnProperty.apply(g, [
                            e.time
                        ]) || (g[e.time] = []), g[e.time].push(A)) : 1 === A.nodeType && (l.hasAncestorOrSelfWithAttribute(A, "AEGIS-IGNORE-FIRST-SCREEN-TIMING") ? e.ignores.push(A) : -1 !== t.indexOf(A.nodeName.toLocaleLowerCase()) || l.isEleInArray(A, e.roots) || (e.roots.push(A), e.rootsDomNum.push(l.walkAndCount(A) || 0)));
                    });
                }), e.roots.length && u.push(e);
            })), d = (w.observe(document, {
                childList: !0,
                subtree: !0
            }), function(t) {
                (t = void 0 === t ? 0 : t) || (n = 0, (A = Object.keys(g)).length ? (t = Math.max.apply(null, A), c.setFirstScreenInfo(s, t, null == (A = g[t]) ? void 0 : A[0], g)) : u.forEach(function(A) {
                    for(var e = 0; e < A.roots.length; e++)A.rootsDomNum[e] > n && l.isInFirstScreen(A.roots[e]) && (n = A.rootsDomNum[e], t = A.time, c.setFirstScreenInfo(s, t, A.roots[e]));
                }), u.length = 0, Object.keys(g).forEach(function(A) {
                    g[A] = g[A].map(function(A) {
                        var e = {
                            tagName: A.tagName
                        }, t = A.attributes;
                        if (!t) return A;
                        for(var n = 0; n < t.length; n++){
                            var r = t[n];
                            r.name && (e[r.name] = A.getAttribute(r.name));
                        }
                        return e;
                    });
                }));
                var n, A = performance.timing, e = A.domInteractive - A.domLoading, r = t;
                h = null;
                for(var o = 0, i = [
                    e,
                    A.loadEventStart - A.domInteractive,
                    r
                ]; o < i.length; o++)if (i[o] <= 0 && 0 < qt) {
                    h = setTimeout(function() {
                        return d(r);
                    }, 3e3);
                    break;
                }
                h ? --qt : (w.disconnect(), null != B && B.disconnect(), null != a && a(t));
            }), h = setTimeout(function() {
                return d();
            }, 3e3);
        },
        setFirstScreenInfo: function(A, e, t, n) {
            var r;
            A.config.id && this.performanceMap[A.config.id] || (A.config.id && (this.performanceMap[A.config.id] = !0), ("object" != typeof (null == (r = A.config) ? void 0 : r.pagePerformance) || null != (r = A.config.pagePerformance) && r.firstScreenInfo) && (A.firstScreenInfo = {
                element: t,
                timing: e,
                markDoms: n
            }));
        },
        isEleInArray: function(A, e) {
            return !(!A || A === document.documentElement) && (-1 !== e.indexOf(A) || this.isEleInArray(A.parentElement, e));
        },
        isInFirstScreen: function(A) {
            var e;
            return !(!A || "function" != typeof A.getBoundingClientRect) && (A = A.getBoundingClientRect(), e = window.innerHeight, 0 <= A.left) && A.left < window.innerWidth && 0 <= A.top && A.top < e && 0 < A.width && 0 < A.height;
        },
        walkAndCount: function(A) {
            var e = 0;
            if (A && 1 === A.nodeType) {
                e += 1;
                var t = A.children;
                if (null != t && t.length) for(var n = 0; n < t.length; n++)1 === t[n].nodeType && t[n].hasAttribute("AEGIS-IGNORE-FIRST-SCREEN-TIMING") || (e += this.walkAndCount(t[n]));
            }
            return e;
        },
        hasAncestorOrSelfWithAttribute: function(A, e) {
            for(var t = A; t && t !== document.body;){
                if (t.hasAttribute(e)) return !0;
                t = t.parentElement;
            }
            return !1;
        }
    }), $t = (new t({
        name: "spa"
    }), [
        "replaceState",
        "pushState",
        "popstate",
        "hashchange"
    ]), An = new t({
        name: "spa",
        originFireUrl: "",
        onNewAegis: function(e) {
            var t = this;
            history.pushState = this.wr("pushState") || history.pushState, history.replaceState = this.wr("replaceState") || history.replaceState, this.sendPv = this.sendPv.bind(this), e.config.spa && this.sendPv(e), $t.forEach(function(A) {
                return window.addEventListener(A, function() {
                    return t.sendPv.call(t, e);
                });
            });
        },
        wr: function(t) {
            var n = history[t], A = "__" + t + "__hasWrittenByTamSpa";
            return "function" == typeof n && !history[A] && (Object.defineProperty(history, A, {
                value: !0,
                enumerable: !1
            }), function() {
                var A = n.apply(this, arguments), e = null;
                return "function" == typeof Event ? e = new Event(t) : (e = document.createEvent("HTMLEvents")).initEvent(t, !1, !0), window.dispatchEvent(e), A;
            });
        },
        sendPv: function(r) {
            var t = this;
            setTimeout(function() {
                var e = location.pathname + location.hash + r.config.id;
                t.$walk(function(A) {
                    var n;
                    A === r && (n = A.config.pvUrl) && e && e !== t.originFireUrl && (A.sendPipeline([
                        function(A, e) {
                            var t = null != n && n.includes("?") ? "&" : "?";
                            e({
                                url: n + t + "originFrom=" + encodeURIComponent(r.getOriginFrom()),
                                type: d.PV
                            });
                        }
                    ], d.PV)(null), t.originFireUrl = e);
                });
            }, 0);
        },
        destroy: function() {
            this.option.sendPv = function() {};
        }
    }), A = (R(Qt = c, A = ft = A), Qt.prototype = null === A ? Object.create(A) : (en.prototype = A.prototype, new en), c.prototype.addExtBean = function(A, e) {
        e && this.extendBean(A, encodeURIComponent("string" == typeof e && [
            "ext1",
            "ext2",
            "ext3"
        ].includes(A) ? e.slice(0, 1024) : e));
    }, c.prototype.getBean = function(e) {
        var t = this;
        return void 0 === e && (e = []), "" + Object.getOwnPropertyNames(this.bean).filter(function(A) {
            return -1 === e.indexOf(A);
        }).map(function(A) {
            return "from" === A ? "from=" + t.getCurrentPageUrl() : A + "=" + t.bean[A];
        }).join("&");
    }, c.prototype.getCurrentPageUrl = function() {
        var A = this.config.pageUrl || location.href, A = (A = "function" == typeof this.config.urlHandler ? this.config.urlHandler() || location.href : A).slice(0, 2048);
        return encodeURIComponent(A);
    }, c.prototype.getOriginFrom = function() {
        try {
            return ("undefined" != typeof window && window.location ? window.location.href : "").slice(0, 2048);
        } catch (A) {
            return "";
        }
    }, c.prototype.ready = function() {
        function o() {
            var A, t, n, r;
            e.reportRequestQueue.length && (A = e.reportRequestQueue.splice(0, 1)[0], t = A.options, n = A.success, r = A.fail, e.$request(t, function() {
                for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
                try {
                    return null == n ? void 0 : n.apply(t, A);
                } finally{
                    o();
                }
            }, function() {
                for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
                try {
                    return null == r ? void 0 : r.apply(t, A);
                } finally{
                    o();
                }
            }));
        }
        var e = this;
        o(), this.isReportReady = !0;
    }, c.prototype.request = function(a, t, c) {
        var B, l, u = this;
        this.config.reportImmediately || this.isReportReady ? this.$request(a, B = function(A) {
            var e = JSON.parse(localStorage.getItem("aegis-web-retry-report-requests") || "[]");
            null != e && e.length && a.extraRetryOptions && (e.splice(e.findIndex(function(A) {
                return A.extraRetryOptions.requestId === a.extraRetryOptions.requestId;
            }), 1), localStorage.setItem("aegis-web-retry-report-requests", JSON.stringify(e)), delete window[a.extraRetryOptions.success], delete window[a.extraRetryOptions.fail]), null != t && t(A);
        }, l = function(A) {
            if (!u.config.reportRetry) return null == c ? void 0 : c(A);
            var e, t = "boolean" == typeof u.config.reportRetry ? Ke : q(q({}, Ke), u.config.reportRetry), n = t.maxRetryCount, r = void 0 === n ? Ke.maxRetryCount : n, n = t.retryInterval, n = void 0 === n ? Ke.retryInterval : n, t = t.whenRetryEndStillFail, o = void 0 === t ? Ke.whenRetryEndStillFail : t, i = (a.extraRetryOptions || (a.extraRetryOptions = {
                requestId: "",
                retriedCount: 0,
                success: "",
                fail: ""
            }), a.extraRetryOptions), s = (i.requestId = i.requestId || a.url + "-" + Date.now() + "-" + Math.random(), i.requestId), t = (i.retriedCount = i.retriedCount || 0, i.success = i.success || s + "_successCallback", i.fail = i.fail || s + "_failCallback", JSON.parse(localStorage.getItem("aegis-web-retry-report-requests") || "[]"));
            t.find(function(A) {
                return A.extraRetryOptions.requestId === s;
            }) ? (e = t.findIndex(function(A) {
                return A.extraRetryOptions.requestId === s;
            }), t[e] = a) : t.push(a), localStorage.setItem("aegis-web-retry-report-requests", JSON.stringify(t)), setTimeout(function() {
                console.log("failCallback retry", i.retriedCount, o), i.retriedCount < r ? (a.extraRetryOptions.retriedCount += 1, u.$request(a, B, l)) : "discard" === o && localStorage.removeItem("aegis-web-retry-report-requests");
            }, "function" == typeof n ? n(a.extraRetryOptions.retriedCount) : n), null != c && c(A), window[i.success] || (window[i.success] = B), window[i.fail] || (window[i.fail] = l);
        }) : this.reportRequestQueue.push({
            options: a,
            success: t,
            fail: c
        });
    }, c.prototype.$request = function(s, A, e) {
        var t, n, r, o;
        if (s && "string" == typeof s.url && "" !== s.url && this.bean.id) return o = s.url, !1 !== s.addBean && (o = ((A, e)=>{
            var t, n, r, o = A, i = s.beanFilter || [];
            for(t in e)-1 === i.indexOf(t) && ((r = (n = new RegExp("([?&])" + t + "(=([^&]*))?(?=&|$)")).exec(o)) ? r[2] && "" !== r[3] && "undefined" !== r[3] || (o = o.replace(n, "$1" + t + "=" + e[t])) : (r = -1 < o.indexOf("?") ? "&" : "?", o += r + t + "=" + e[t]));
            return o;
        })(o, q(q({}, this.bean), {
            from: this.getCurrentPageUrl()
        }))), s.url = o, o = s.method || "get", n = this.config.onBeforeRequest, (s = n ? n(s, this) : s) ? s.url ? void ((null != s && s.sendBeacon || this.sendNow) && "function" == typeof (null == navigator ? void 0 : navigator.sendBeacon) ? navigator.sendBeacon(s.url, s.data) : ((t = new XMLHttpRequest).sendByAegis = !0, t.addEventListener("readystatechange", function() {
            4 === t.readyState && (400 <= t.status || 0 === t.status ? null != e && e(t.response) : null != A && A(t.response));
        }), "get" === o.toLocaleLowerCase() ? (t.open("get", (n = s.url, r = s.data, "string" != typeof n ? "" : "object" == typeof r && r ? (o = Object.getOwnPropertyNames(r).map(function(A) {
            var e = r[A];
            return A + "=" + ("string" == typeof e ? encodeURIComponent(e) : encodeURIComponent(JSON.stringify(e)));
        }).join("&").replace(/eval/gi, "evaI"), n + (-1 === n.indexOf("?") ? "?" : "&") + o) : n)), t.send()) : (t.open("post", s.url), s.contentType && t.setRequestHeader("Content-Type", s.contentType), "string" == typeof s.data && (s.data = s.data.replace(/eval/gi, "evaI")), t.send(s.data)))) : console.warn("Please handle the parameters reasonably, options.url is necessary") : console.warn("Sending request blocked");
    }, c.prototype.publishPluginsLogs = function() {
        var A = c.installedPlugins.find(function(A) {
            return "reportAssetSpeed" === A.name;
        });
        null != A && A.option.collectNotReportedLog(this);
    }, c.prototype.uploadLogs = function(A, e) {
        var t;
        void 0 === A && (A = {}), void 0 === e && (e = {}), null != (t = this.lifeCycle) && t.emit("uploadLogs", A, e);
    }, c.prototype.reportWebVitals = function(A) {
        try {
            var e = c.installedPlugins.find(function(A) {
                return "webVitals" === A.name;
            });
            e && this.config.webVitals && this.config.webVitals.manualReport && e.option.publish(this, A);
        } catch (A) {}
    }, c.sessionID = "session-" + TA(), c);
    function c(A) {
        var e, t, n, r, o, i, s = ft.call(this, A) || this;
        s.sendNow = !1, s.isReportReady = !1, s.reportRequestQueue = [], s.speedLogPipeline = MA([
            iA(s),
            (i = s.config, function(A, e) {
                var t, n, r, o = "number" == typeof i.repeat ? i.repeat : 60;
                !i.speedSample || o <= 0 ? e(A) : (t = (null == i ? void 0 : i.id) || "0", n = HA[t] || {}, Array.isArray(A) ? (r = A.filter(function(A) {
                    var e = !n[A.url] || n[A.url] < o;
                    return e ? (n[A.url] = 1 + ~~n[A.url], HA[t] = n) : EA[t] || vA(t), e;
                })).length && e(r) : !n[A.url] || n[A.url] < o ? (n[A.url] = 1 + ~~n[A.url], HA[t] = n, e(A)) : EA[t] || vA(t));
            }),
            (n = s, function(e, t) {
                xe(function(A) {
                    n.extendBean("netType", A), t(e);
                });
            }),
            function(A, e) {
                null != (t = s.lifeCycle) && t.emit("beforeReportSpeed", A);
                var t, n = s.config.beforeReportSpeed;
                if ((A = "function" == typeof n ? A.filter(function(A) {
                    return !1 !== n(A);
                }) : A).length) return e(A);
            },
            function(A, e) {
                e(A.map(function(A) {
                    return void 0 !== A.payload && delete A.payload, A;
                }));
            },
            function(A) {
                return s.sendPipeline([
                    function(A, e) {
                        e({
                            type: d.SPEED,
                            url: "" + s.config.speedUrl,
                            method: "post",
                            data: rA(A, q(q({}, s.bean), {
                                from: s.getCurrentPageUrl()
                            })),
                            log: A
                        });
                    }
                ], d.SPEED)(A);
            }
        ]), A.asyncPlugin = !0;
        try {
            "undefined" != typeof document && (A.uin = A.uin || (null != (e = document.cookie.match(/\buin=\D+(\d*)/)) ? e : [])[1] || (null != (t = document.cookie.match(/\bilive_uin=\D*(\d+)/)) ? t : [])[1] || ""), s.init(A), s.extendBean("sessionId", c.sessionID), s.extendBean("from", s.getCurrentPageUrl()), "undefined" != typeof document && s.extendBean("referer", encodeURIComponent(document.referrer || "")), r = JSON.parse(localStorage.getItem("aegis-web-retry-report-requests") || "[]"), (o = function() {
                var n;
                r.length && (n = r.splice(0, 1)[0], localStorage.setItem("aegis-web-retry-report-requests", JSON.stringify(r)), s.$request(n, function() {
                    for(var A, e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                    try {
                        return null == (A = window[n.extraRetryOptions.success]) ? void 0 : A.apply(n, e);
                    } finally{
                        o();
                    }
                }, function() {
                    for(var A, e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                    try {
                        return null == (A = window[n.extraRetryOptions.fail]) ? void 0 : A.apply(n, e);
                    } finally{
                        o();
                    }
                }));
            })();
            for(var a = 1; a <= 10; a++)s.addExtBean("ext" + a, A["ext" + a]);
        } catch (A) {
            console.warn(A), console.log("%cThe above error occurred in the process of initializing Aegis, which will affect your normal use of Aegis.\nIt is recommended that you contact us for feedback and thank you for your support.", "color: red"), s.sendSDKError(A);
        }
        return s;
    }
    function en() {
        this.constructor = Qt;
    }
    function tn(A) {
        this.slienceTimeInterval = 5e3, this.checkInterval = 100, this.fcp = 0, this.longTaskEntries = [], this.resourceEntries = [], this.slientWindowStartTime = performance.now(), this.onTTICallback = A;
    }
    new t({
        name: "ie"
    }), new t({
        name: "onClose"
    });
    var nn = new t({
        name: "onClose",
        onNewAegis: function(t) {
            var n, r = this;
            o.desktop() ? (n = window.onunload, window.onunload = function() {
                for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
                r.publishNotReportedLog(t), null != n && n.call.apply(n, M([
                    window
                ], A));
            }) : at(this.publishNotReportedLog.bind(this, t), {
                once: !0
            });
        },
        publishNotReportedLog: function(e) {
            var t = this;
            this.$walk(function(A) {
                A === e && (A.sendNow = !0, A.publishPluginsLogs(), t.publishThrottlePipeLogs(A));
            });
        },
        publishThrottlePipeLogs: function(A) {
            null != A && A.speedLogPipeline([]), null != A && A.eventPipeline([]), null != A && A.customTimePipeline([]), null != A && A.normalLogPipeline([]);
        }
    });
    new t({
        name: "aid"
    });
    var rn, on = {
        containers: [
            "body",
            "html",
            "#app",
            "#root"
        ],
        ignoreContainers: [],
        detectStartPosition: {
            x: 0,
            y: 0
        },
        emptyElementsPercent: 70,
        sameElementsPercent: 70,
        debounceDuration: 2e3,
        everySideSampleNumber: 9,
        disableSameElementsCheck: !0,
        ignoreElesWhenDomChange: [],
        reDetectInterval: 2e3,
        samePointDepth: 5,
        customBlankScreenDector: null,
        enableScreenshot: !1,
        needScreenShotMeta: !1,
        screenshotQuality: .1,
        screenshotFormat: "image/webp"
    }, sn = [
        "canvas",
        "img",
        "svg",
        "iframe"
    ], an = ((r = rn = rn || {})[r.UNKNOWN = 0] = "UNKNOWN", r[r.ERROR = 1] = "ERROR", r[r.DOM_CHANGE = 2] = "DOM_CHANGE", function(A, e) {
        return (an = Object.setPrototypeOf || (({
            __proto__: []
        }) instanceof Array ? function(A, e) {
            A.__proto__ = e;
        } : function(A, e) {
            for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
        }))(A, e);
    });
    function cn(A, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
        function t() {
            this.constructor = A;
        }
        an(A, e), A.prototype = null === e ? Object.create(e) : (t.prototype = e.prototype, new t);
    }
    var Bn = function() {
        return (Bn = Object.assign || function(A) {
            for(var e, t = 1, n = arguments.length; t < n; t++)for(var r in e = arguments[t])Object.prototype.hasOwnProperty.call(e, r) && (A[r] = e[r]);
            return A;
        }).apply(this, arguments);
    };
    function l(A, i, s, a) {
        return new (s = s || Promise)(function(t, e) {
            function n(A) {
                try {
                    o(a.next(A));
                } catch (A) {
                    e(A);
                }
            }
            function r(A) {
                try {
                    o(a.throw(A));
                } catch (A) {
                    e(A);
                }
            }
            function o(A) {
                var e;
                A.done ? t(A.value) : ((e = A.value) instanceof s ? e : new s(function(A) {
                    A(e);
                })).then(n, r);
            }
            o((a = a.apply(A, i || [])).next());
        });
    }
    function S(n, r) {
        var o, i, s, a = {
            label: 0,
            sent: function() {
                if (1 & s[0]) throw s[1];
                return s[1];
            },
            trys: [],
            ops: []
        }, A = {
            next: e(0),
            throw: e(1),
            return: e(2)
        };
        return "function" == typeof Symbol && (A[Symbol.iterator] = function() {
            return this;
        }), A;
        function e(t) {
            return function(A) {
                var e = [
                    t,
                    A
                ];
                if (o) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (o = 1, i && (s = 2 & e[0] ? i.return : e[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, e[1])).done) return s;
                    switch(i = 0, (e = s ? [
                        2 & e[0],
                        s.value
                    ] : e)[0]){
                        case 0:
                        case 1:
                            s = e;
                            break;
                        case 4:
                            return a.label++, {
                                value: e[1],
                                done: !1
                            };
                        case 5:
                            a.label++, i = e[1], e = [
                                0
                            ];
                            continue;
                        case 7:
                            e = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!((s = 0 < (s = a.trys).length && s[s.length - 1]) || 6 !== e[0] && 2 !== e[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === e[0] && (!s || e[1] > s[0] && e[1] < s[3])) a.label = e[1];
                            else if (6 === e[0] && a.label < s[1]) a.label = s[1], s = e;
                            else {
                                if (!(s && a.label < s[2])) {
                                    s[2] && a.ops.pop(), a.trys.pop();
                                    continue;
                                }
                                a.label = s[2], a.ops.push(e);
                            }
                    }
                    e = r.call(n, a);
                } catch (A) {
                    e = [
                        6,
                        A
                    ], i = 0;
                } finally{
                    o = s = 0;
                }
                if (5 & e[0]) throw e[1];
                return {
                    value: e[0] ? e[1] : void 0,
                    done: !0
                };
            };
        }
    }
    function ln(A, e, t) {
        if (t || 2 === arguments.length) for(var n, r = 0, o = e.length; r < o; r++)!n && r in e || ((n = n || Array.prototype.slice.call(e, 0, r))[r] = e[r]);
        return A.concat(n || e);
    }
    Qn.prototype.add = function(A, e, t, n) {
        return new Qn(this.left + A, this.top + e, this.width + t, this.height + n);
    }, Qn.fromClientRect = function(A, e) {
        return new Qn(e.left + A.windowBounds.left, e.top + A.windowBounds.top, e.width, e.height);
    }, Qn.fromDOMRectList = function(A, e) {
        e = Array.from(e).find(function(A) {
            return 0 !== A.width;
        });
        return e ? new Qn(e.left + A.windowBounds.left, e.top + A.windowBounds.top, e.width, e.height) : Qn.EMPTY;
    }, Qn.EMPTY = new Qn(0, 0, 0, 0);
    for(var un = Qn, gn = function(A, e) {
        return un.fromClientRect(A, e.getBoundingClientRect());
    }, wn = function(A) {
        for(var e = [], t = 0, n = A.length; t < n;){
            var r, o = A.charCodeAt(t++);
            55296 <= o && o <= 56319 && t < n ? 56320 == (64512 & (r = A.charCodeAt(t++))) ? e.push(((1023 & o) << 10) + (1023 & r) + 65536) : (e.push(o), t--) : e.push(o);
        }
        return e;
    }, u = function() {
        for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, A);
        var t = A.length;
        if (!t) return "";
        for(var n = [], r = -1, o = ""; ++r < t;){
            var i = A[r];
            i <= 65535 ? n.push(i) : n.push(55296 + ((i -= 65536) >> 10), i % 1024 + 56320), (r + 1 === t || 16384 < n.length) && (o += String.fromCharCode.apply(String, n), n.length = 0);
        }
        return o;
    }, dn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", hn = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), fn = 0; fn < dn.length; fn++)hn[dn.charCodeAt(fn)] = fn;
    function Qn(A, e, t, n) {
        this.left = A, this.top = e, this.width = t, this.height = n;
    }
    for(var pn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Cn = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), Un = 0; Un < pn.length; Un++)Cn[pn.charCodeAt(Un)] = Un;
    for(var r = function(A, e, t) {
        return A.slice ? A.slice(e, t) : new Uint16Array(Array.prototype.slice.call(A, e, t));
    }, i = (En.prototype.get = function(A) {
        var e;
        if (0 <= A) {
            if (A < 55296 || 56319 < A && A <= 65535) return e = ((e = this.index[A >> 5]) << 2) + (31 & A), this.data[e];
            if (A <= 65535) return e = ((e = this.index[2048 + (A - 55296 >> 5)]) << 2) + (31 & A), this.data[e];
            if (A < this.highStart) return e = this.index[e = 2080 + (A >> 11)], e = ((e = this.index[e += A >> 5 & 63]) << 2) + (31 & A), this.data[e];
            if (A <= 1114111) return this.data[this.highValueIndex];
        }
        return this.errorValue;
    }, En), Fn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", mn = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), yn = 0; yn < Fn.length; yn++)mn[Fn.charCodeAt(yn)] = yn;
    function En(A, e, t, n, r, o) {
        this.initialValue = A, this.errorValue = e, this.highStart = t, this.highValueIndex = n, this.index = r, this.data = o;
    }
    function g(A) {
        return 48 <= A && A <= 57;
    }
    function Hn(A) {
        return g(A) || 65 <= A && A <= 70 || 97 <= A && A <= 102;
    }
    function vn(A) {
        return 10 === A || 9 === A || 32 === A;
    }
    function In(A) {
        var e;
        return 97 <= (e = A) && e <= 122 || 65 <= e && e <= 90 || 128 <= A || 95 === A;
    }
    function bn(A) {
        return In(A) || g(A) || 45 === A;
    }
    function Ln(A, e) {
        return 92 === A && 10 !== e;
    }
    function Kn(A, e, t) {
        return 45 === A ? In(e) || Ln(e, t) : !!In(A) || !(92 !== A || !Ln(A, e));
    }
    function Sn(A, e, t) {
        return 43 === A || 45 === A ? !!g(e) || 46 === e && g(t) : g(46 === A ? e : A);
    }
    function Tn(A) {
        return 17 === A.type;
    }
    function On(A) {
        return 0 === A.type;
    }
    function xn(A, e) {
        return f(A) && A.value === e;
    }
    function Dn(A) {
        return 31 !== A.type;
    }
    function Rn(A) {
        return 31 !== A.type && 4 !== A.type;
    }
    function Mn(A) {
        var e = [], t = [];
        return A.forEach(function(A) {
            if (4 === A.type) {
                if (0 === t.length) throw new Error("Error parsing function args, zero tokens for arg");
                e.push(t), t = [];
            } else 31 !== A.type && t.push(A);
        }), t.length && e.push(t), e;
    }
    function Pn(A) {
        return 1 < A.length ? [
            A[0],
            A[1]
        ] : [
            A[0]
        ];
    }
    function kn(A, e) {
        if (15 === e.type) switch(e.unit){
            case "deg":
                return Math.PI * e.number / 180;
            case "grad":
                return Math.PI / 200 * e.number;
            case "rad":
                return e.number;
            case "turn":
                return 2 * Math.PI * e.number;
        }
        throw new Error("Unsupported angle type");
    }
    function Gn(A) {
        return 15 === A.type && ("deg" === A.unit || "grad" === A.unit || "rad" === A.unit || "turn" === A.unit);
    }
    function Nn(A) {
        switch(A.filter(f).map(function(A) {
            return A.value;
        }).join(" ")){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    p,
                    p
                ];
            case "to top":
            case "bottom":
                return Vn(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    p,
                    to
                ];
            case "to right":
            case "left":
                return Vn(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    to,
                    to
                ];
            case "to bottom":
            case "top":
                return Vn(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    to,
                    p
                ];
            case "to left":
            case "right":
                return Vn(270);
        }
        return 0;
    }
    function Vn(A) {
        return Math.PI * A / 180;
    }
    function T(A) {
        var e = 255 & A, t = 255 & A >> 8, n = 255 & A >> 16, A = 255 & A >> 24;
        return e < 255 ? "rgba(" + A + "," + n + "," + t + "," + e / 255 + ")" : "rgb(" + A + "," + n + "," + t + ")";
    }
    function Xn(A, e) {
        var t;
        return 17 === A.type ? A.number : 16 === A.type ? (t = 3 === e ? 1 : 255, 3 === e ? A.number / 100 * t : Math.round(A.number / 100 * t)) : 0;
    }
    function Jn(A, e) {
        var t, n;
        return 3 === (e = e.filter(Rn)).length ? (t = (n = e.map(Xn))[0], io(t, n[1], n[2], 1)) : 4 === e.length ? (t = (n = e.map(Xn))[0], io(t, n[1], n[2], n[3])) : 0;
    }
    var Wn = 10, _n = 13, Yn = 15, Zn = 17, qn = 18, jn = 19, zn = 20, $n = 21, Ar = 22, er = 24, w = 25, tr = 26, nr = 27, rr = 28, or = 30, ir = 32, sr = 33, ar = 34, cr = 35, Br = 37, lr = 38, ur = 39, gr = 40, wr = 42, dr = [
        9001,
        65288
    ], hr = (y = ((A)=>{
        for(var e, t, n, r, o = .75 * A.length, i = A.length, s = 0, o = ("=" === A[A.length - 1] && (o--, "=" === A[A.length - 2]) && o--, new ("undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array && void 0 !== Uint8Array.prototype.slice ? ArrayBuffer : Array)(o)), a = Array.isArray(o) ? o : new Uint8Array(o), c = 0; c < i; c += 4)e = Cn[A.charCodeAt(c)], t = Cn[A.charCodeAt(c + 1)], n = Cn[A.charCodeAt(c + 2)], r = Cn[A.charCodeAt(c + 3)], a[s++] = e << 2 | t >> 4, a[s++] = (15 & t) << 4 | n >> 2, a[s++] = (3 & n) << 6 | 63 & r;
        return o;
    })("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"), C = Array.isArray(y) ? ((A)=>{
        for(var e = A.length, t = [], n = 0; n < e; n += 4)t.push(A[n + 3] << 24 | A[n + 2] << 16 | A[n + 1] << 8 | A[n]);
        return t;
    })(y) : new Uint32Array(y), y = Array.isArray(y) ? ((A)=>{
        for(var e = A.length, t = [], n = 0; n < e; n += 2)t.push(A[n + 1] << 8 | A[n]);
        return t;
    })(y) : new Uint16Array(y), mB = r(y, 12, C[4] / 2), y = 2 === C[5] ? r(y, (24 + C[4]) / 2) : (y = C, r = Math.ceil((24 + C[4]) / 4), y.slice ? y.slice(r, void 0) : new Uint32Array(Array.prototype.slice.call(y, r, void 0))), new i(C[0], C[1], C[2], C[3], mB, y)), fr = [
        or,
        36
    ], Qr = [
        1,
        2,
        3,
        5
    ], pr = [
        Wn,
        8
    ], Cr = [
        nr,
        tr
    ], Ur = Qr.concat(pr), Fr = [
        lr,
        ur,
        gr,
        ar,
        cr
    ], mr = [
        Yn,
        _n
    ], yr = function(A, e, t, n) {
        var r = n[t];
        if (Array.isArray(A) ? -1 !== A.indexOf(r) : A === r) for(var o = t; o <= n.length;){
            if ((i = n[++o]) === e) return !0;
            if (i !== Wn) break;
        }
        if (r === Wn) for(o = t; 0 < o;){
            var i, s = n[--o];
            if (Array.isArray(A) ? -1 !== A.indexOf(s) : A === s) for(var a = t; a <= n.length;){
                if ((i = n[++a]) === e) return !0;
                if (i !== Wn) break;
            }
            if (s !== Wn) break;
        }
        return !1;
    }, Er = function(A, e) {
        for(var t = A; 0 <= t;){
            var n = e[t];
            if (n !== Wn) return n;
            t--;
        }
        return 0;
    }, Hr = function(A, e, t, n, r) {
        if (0 === t[n]) return "\xd7";
        n -= 1;
        if (Array.isArray(r) && !0 === r[n]) return "\xd7";
        var o, r = n - 1, i = 1 + n, s = e[n], a = 0 <= r ? e[r] : 0, c = e[i];
        if (2 === s && 3 === c) return "\xd7";
        if (-1 !== Qr.indexOf(s)) return "!";
        if (-1 !== Qr.indexOf(c)) return "\xd7";
        if (-1 !== pr.indexOf(c)) return "\xd7";
        if (8 === Er(n, e)) return "\xf7";
        if (11 === hr.get(A[n])) return "\xd7";
        if ((s === ir || s === sr) && 11 === hr.get(A[i])) return "\xd7";
        if (7 === s || 7 === c) return "\xd7";
        if (9 === s) return "\xd7";
        if (-1 === [
            Wn,
            _n,
            Yn
        ].indexOf(s) && 9 === c) return "\xd7";
        if (-1 !== [
            Zn,
            qn,
            jn,
            er,
            rr
        ].indexOf(c)) return "\xd7";
        if (Er(n, e) === Ar) return "\xd7";
        if (yr(23, Ar, n, e)) return "\xd7";
        if (yr([
            Zn,
            qn
        ], $n, n, e)) return "\xd7";
        if (yr(12, 12, n, e)) return "\xd7";
        if (s === Wn) return "\xf7";
        if (23 === s || 23 === c) return "\xd7";
        if (16 === c || 16 === s) return "\xf7";
        if (-1 !== [
            _n,
            Yn,
            $n
        ].indexOf(c) || 14 === s) return "\xd7";
        if (36 === a && -1 !== mr.indexOf(s)) return "\xd7";
        if (s === rr && 36 === c) return "\xd7";
        if (c === zn) return "\xd7";
        if (-1 !== fr.indexOf(c) && s === w || -1 !== fr.indexOf(s) && c === w) return "\xd7";
        if (s === nr && -1 !== [
            Br,
            ir,
            sr
        ].indexOf(c) || -1 !== [
            Br,
            ir,
            sr
        ].indexOf(s) && c === tr) return "\xd7";
        if (-1 !== fr.indexOf(s) && -1 !== Cr.indexOf(c) || -1 !== Cr.indexOf(s) && -1 !== fr.indexOf(c)) return "\xd7";
        if (-1 !== [
            nr,
            tr
        ].indexOf(s) && (c === w || -1 !== [
            Ar,
            Yn
        ].indexOf(c) && e[1 + i] === w) || -1 !== [
            Ar,
            Yn
        ].indexOf(s) && c === w || s === w && -1 !== [
            w,
            rr,
            er
        ].indexOf(c)) return "\xd7";
        if (-1 !== [
            w,
            rr,
            er,
            Zn,
            qn
        ].indexOf(c)) for(var B = n; 0 <= B;){
            if ((o = e[B]) === w) return "\xd7";
            if (-1 === [
                rr,
                er
            ].indexOf(o)) break;
            B--;
        }
        if (-1 !== [
            nr,
            tr
        ].indexOf(c)) for(B = -1 !== [
            Zn,
            qn
        ].indexOf(s) ? r : n; 0 <= B;){
            if ((o = e[B]) === w) return "\xd7";
            if (-1 === [
                rr,
                er
            ].indexOf(o)) break;
            B--;
        }
        if (lr === s && -1 !== [
            lr,
            ur,
            ar,
            cr
        ].indexOf(c) || -1 !== [
            ur,
            ar
        ].indexOf(s) && -1 !== [
            ur,
            gr
        ].indexOf(c) || -1 !== [
            gr,
            cr
        ].indexOf(s) && c === gr) return "\xd7";
        if (-1 !== Fr.indexOf(s) && -1 !== [
            zn,
            tr
        ].indexOf(c) || -1 !== Fr.indexOf(c) && s === nr) return "\xd7";
        if (-1 !== fr.indexOf(s) && -1 !== fr.indexOf(c)) return "\xd7";
        if (s === er && -1 !== fr.indexOf(c)) return "\xd7";
        if (-1 !== fr.concat(w).indexOf(s) && c === Ar && -1 === dr.indexOf(A[i]) || -1 !== fr.concat(w).indexOf(c) && s === qn) return "\xd7";
        if (41 === s && 41 === c) {
            for(var l = t[n], u = 1; 0 < l && 41 === e[--l];)u++;
            if (u % 2 != 0) return "\xd7";
        }
        return s === ir && c === sr ? "\xd7" : "\xf7";
    }, vr = function(t, A) {
        void 0 === (r = (A = A || {
            lineBreak: "normal",
            wordBreak: "normal"
        }).lineBreak) && (r = "strict"), o = [], i = [], s = [], t.forEach(function(A, e) {
            var t, n = hr.get(A);
            return 50 < n ? (s.push(!0), n -= 50) : s.push(!1), -1 !== [
                "normal",
                "auto",
                "loose"
            ].indexOf(r) && -1 !== [
                8208,
                8211,
                12316,
                12448
            ].indexOf(A) ? (i.push(e), o.push(16)) : 4 === n || 11 === n ? 0 !== e && -1 === Ur.indexOf(t = o[e - 1]) ? (i.push(i[e - 1]), o.push(t)) : (i.push(e), o.push(or)) : (i.push(e), 31 === n ? o.push("strict" === r ? $n : Br) : n === wr || 29 === n ? o.push(or) : 43 === n ? o.push(131072 <= A && A <= 196605 || 196608 <= A && A <= 262141 ? Br : or) : void o.push(n));
        });
        var r, o, i, s, e = [
            i,
            o,
            s
        ], n = e[1], a = e[2];
        return [
            e[0],
            n = "break-all" !== A.wordBreak && "break-word" !== A.wordBreak ? n : n.map(function(A) {
                return -1 !== [
                    w,
                    or,
                    wr
                ].indexOf(A) ? Br : A;
            }),
            "keep-all" === A.wordBreak ? a.map(function(A, e) {
                return A && 19968 <= t[e] && t[e] <= 40959;
            }) : void 0
        ];
    }, Ir = (so.prototype.slice = function() {
        return u.apply(void 0, this.codePoints.slice(this.start, this.end));
    }, so), br = {
        type: 2
    }, Lr = {
        type: 3
    }, Kr = {
        type: 4
    }, Sr = {
        type: 13
    }, Tr = {
        type: 8
    }, Or = {
        type: 21
    }, xr = {
        type: 9
    }, Dr = {
        type: 10
    }, Rr = {
        type: 11
    }, Mr = {
        type: 12
    }, Pr = {
        type: 14
    }, kr = {
        type: 23
    }, Gr = {
        type: 1
    }, Nr = {
        type: 25
    }, Vr = {
        type: 24
    }, Xr = {
        type: 26
    }, Jr = {
        type: 27
    }, Wr = {
        type: 28
    }, _r = {
        type: 29
    }, Yr = {
        type: 31
    }, Zr = {
        type: 32
    }, qr = (a.prototype.write = function(A) {
        this._value = this._value.concat(wn(A));
    }, a.prototype.read = function() {
        for(var A = [], e = this.consumeToken(); e !== Zr;)A.push(e), e = this.consumeToken();
        return A;
    }, a.prototype.consumeToken = function() {
        var A = this.consumeCodePoint();
        switch(A){
            case 34:
                return this.consumeStringToken(34);
            case 35:
                var e = this.peekCodePoint(0), t = this.peekCodePoint(1), n = this.peekCodePoint(2);
                if (bn(e) || Ln(t, n)) return e = Kn(e, t, n) ? 2 : 1, {
                    type: 5,
                    value: this.consumeName(),
                    flags: e
                };
                break;
            case 36:
                if (61 === this.peekCodePoint(0)) return this.consumeCodePoint(), Sr;
                break;
            case 39:
                return this.consumeStringToken(39);
            case 40:
                return br;
            case 41:
                return Lr;
            case 42:
                if (61 === this.peekCodePoint(0)) return this.consumeCodePoint(), Pr;
                break;
            case 43:
                if (Sn(A, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(A), this.consumeNumericToken();
                break;
            case 44:
                return Kr;
            case 45:
                t = A, n = this.peekCodePoint(0), e = this.peekCodePoint(1);
                if (Sn(t, n, e)) return this.reconsumeCodePoint(A), this.consumeNumericToken();
                if (Kn(t, n, e)) return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
                if (45 === n && 62 === e) return this.consumeCodePoint(), this.consumeCodePoint(), Vr;
                break;
            case 46:
                if (Sn(A, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(A), this.consumeNumericToken();
                break;
            case 47:
                if (42 === this.peekCodePoint(0)) for(this.consumeCodePoint();;){
                    var r = this.consumeCodePoint();
                    if (42 === r && 47 === (r = this.consumeCodePoint())) return this.consumeToken();
                    if (-1 === r) return this.consumeToken();
                }
                break;
            case 58:
                return Xr;
            case 59:
                return Jr;
            case 60:
                if (33 === this.peekCodePoint(0) && 45 === this.peekCodePoint(1) && 45 === this.peekCodePoint(2)) return this.consumeCodePoint(), this.consumeCodePoint(), Nr;
                break;
            case 64:
                t = this.peekCodePoint(0), n = this.peekCodePoint(1), e = this.peekCodePoint(2);
                if (Kn(t, n, e)) return {
                    type: 7,
                    value: this.consumeName()
                };
                break;
            case 91:
                return Wr;
            case 92:
                if (Ln(A, this.peekCodePoint(0))) return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
                break;
            case 93:
                return _r;
            case 61:
                if (61 === this.peekCodePoint(0)) return this.consumeCodePoint(), Tr;
                break;
            case 123:
                return Rr;
            case 125:
                return Mr;
            case 117:
            case 85:
                t = this.peekCodePoint(0), n = this.peekCodePoint(1);
                return 43 !== t || !Hn(n) && 63 !== n || (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
            case 124:
                if (61 === this.peekCodePoint(0)) return this.consumeCodePoint(), xr;
                if (124 === this.peekCodePoint(0)) return this.consumeCodePoint(), Or;
                break;
            case 126:
                if (61 === this.peekCodePoint(0)) return this.consumeCodePoint(), Dr;
                break;
            case -1:
                return Zr;
        }
        return vn(A) ? (this.consumeWhiteSpace(), Yr) : g(A) ? (this.reconsumeCodePoint(A), this.consumeNumericToken()) : In(A) ? (this.reconsumeCodePoint(A), this.consumeIdentLikeToken()) : {
            type: 6,
            value: u(A)
        };
    }, a.prototype.consumeCodePoint = function() {
        var A = this._value.shift();
        return void 0 === A ? -1 : A;
    }, a.prototype.reconsumeCodePoint = function(A) {
        this._value.unshift(A);
    }, a.prototype.peekCodePoint = function(A) {
        return A >= this._value.length ? -1 : this._value[A];
    }, a.prototype.consumeUnicodeRangeToken = function() {
        for(var A = [], e = this.consumeCodePoint(); Hn(e) && A.length < 6;)A.push(e), e = this.consumeCodePoint();
        for(var t = !1; 63 === e && A.length < 6;)A.push(e), e = this.consumeCodePoint(), t = !0;
        if (t) return {
            type: 30,
            start: parseInt(u.apply(void 0, A.map(function(A) {
                return 63 === A ? 48 : A;
            })), 16),
            end: parseInt(u.apply(void 0, A.map(function(A) {
                return 63 === A ? 70 : A;
            })), 16)
        };
        var n = parseInt(u.apply(void 0, A), 16);
        if (45 === this.peekCodePoint(0) && Hn(this.peekCodePoint(1))) {
            this.consumeCodePoint();
            for(var e = this.consumeCodePoint(), r = []; Hn(e) && r.length < 6;)r.push(e), e = this.consumeCodePoint();
            return {
                type: 30,
                start: n,
                end: parseInt(u.apply(void 0, r), 16)
            };
        }
        return {
            type: 30,
            start: n,
            end: n
        };
    }, a.prototype.consumeIdentLikeToken = function() {
        var A = this.consumeName();
        return "url" === A.toLowerCase() && 40 === this.peekCodePoint(0) ? (this.consumeCodePoint(), this.consumeUrlToken()) : 40 === this.peekCodePoint(0) ? (this.consumeCodePoint(), {
            type: 19,
            value: A
        }) : {
            type: 20,
            value: A
        };
    }, a.prototype.consumeUrlToken = function() {
        var A = [];
        if (this.consumeWhiteSpace(), -1 === this.peekCodePoint(0)) return {
            type: 22,
            value: ""
        };
        var e, t = this.peekCodePoint(0);
        if (39 === t || 34 === t) return 0 === (t = this.consumeStringToken(this.consumeCodePoint())).type && (this.consumeWhiteSpace(), -1 === this.peekCodePoint(0) || 41 === this.peekCodePoint(0)) ? (this.consumeCodePoint(), {
            type: 22,
            value: t.value
        }) : (this.consumeBadUrlRemnants(), kr);
        for(;;){
            var n = this.consumeCodePoint();
            if (-1 === n || 41 === n) return {
                type: 22,
                value: u.apply(void 0, A)
            };
            if (vn(n)) return this.consumeWhiteSpace(), -1 === this.peekCodePoint(0) || 41 === this.peekCodePoint(0) ? (this.consumeCodePoint(), {
                type: 22,
                value: u.apply(void 0, A)
            }) : (this.consumeBadUrlRemnants(), kr);
            if (34 === n || 39 === n || 40 === n || 0 <= (e = n) && e <= 8 || 11 === e || 14 <= e && e <= 31 || 127 === e) return this.consumeBadUrlRemnants(), kr;
            if (92 === n) {
                if (!Ln(n, this.peekCodePoint(0))) return this.consumeBadUrlRemnants(), kr;
                A.push(this.consumeEscapedCodePoint());
            } else A.push(n);
        }
    }, a.prototype.consumeWhiteSpace = function() {
        for(; vn(this.peekCodePoint(0));)this.consumeCodePoint();
    }, a.prototype.consumeBadUrlRemnants = function() {
        for(;;){
            var A = this.consumeCodePoint();
            if (41 === A || -1 === A) return;
            Ln(A, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
        }
    }, a.prototype.consumeStringSlice = function(A) {
        for(var e = ""; 0 < A;){
            var t = Math.min(5e4, A);
            e += u.apply(void 0, this._value.splice(0, t)), A -= t;
        }
        return this._value.shift(), e;
    }, a.prototype.consumeStringToken = function(A) {
        for(var e = "", t = 0;;){
            var n, r = this._value[t];
            if (-1 === r || void 0 === r || r === A) return {
                type: 0,
                value: e += this.consumeStringSlice(t)
            };
            if (10 === r) return this._value.splice(0, t), Gr;
            92 === r && -1 !== (n = this._value[t + 1]) && void 0 !== n && (10 === n ? (e += this.consumeStringSlice(t), t = -1, this._value.shift()) : Ln(r, n) && (e = (e += this.consumeStringSlice(t)) + u(this.consumeEscapedCodePoint()), t = -1)), t++;
        }
    }, a.prototype.consumeNumber = function() {
        var A = [], e = 4;
        for(43 !== (t = this.peekCodePoint(0)) && 45 !== t || A.push(this.consumeCodePoint()); g(this.peekCodePoint(0));)A.push(this.consumeCodePoint());
        var t = this.peekCodePoint(0), n = this.peekCodePoint(1);
        if (46 === t && g(n)) for(A.push(this.consumeCodePoint(), this.consumeCodePoint()), e = 8; g(this.peekCodePoint(0));)A.push(this.consumeCodePoint());
        t = this.peekCodePoint(0);
        var n = this.peekCodePoint(1), r = this.peekCodePoint(2);
        if ((69 === t || 101 === t) && ((43 === n || 45 === n) && g(r) || g(n))) for(A.push(this.consumeCodePoint(), this.consumeCodePoint()), e = 8; g(this.peekCodePoint(0));)A.push(this.consumeCodePoint());
        return [
            ((A)=>{
                var e = 0, t = 1;
                43 !== A[e] && 45 !== A[e] || (45 === A[e] && (t = -1), e++);
                for(var n = []; g(A[e]);)n.push(A[e++]);
                var r = n.length ? parseInt(u.apply(void 0, n), 10) : 0;
                46 === A[e] && e++;
                for(var o = []; g(A[e]);)o.push(A[e++]);
                var i = o.length, s = i ? parseInt(u.apply(void 0, o), 10) : 0, a = (69 !== A[e] && 101 !== A[e] || e++, 1);
                43 !== A[e] && 45 !== A[e] || (45 === A[e] && (a = -1), e++);
                for(var c = []; g(A[e]);)c.push(A[e++]);
                var B = c.length ? parseInt(u.apply(void 0, c), 10) : 0;
                return t * (r + s * Math.pow(10, -i)) * Math.pow(10, a * B);
            })(A),
            e
        ];
    }, a.prototype.consumeNumericToken = function() {
        var A = this.consumeNumber(), e = A[0], A = A[1], t = this.peekCodePoint(0), n = this.peekCodePoint(1), r = this.peekCodePoint(2);
        return Kn(t, n, r) ? {
            type: 15,
            number: e,
            flags: A,
            unit: this.consumeName()
        } : 37 === t ? (this.consumeCodePoint(), {
            type: 16,
            number: e,
            flags: A
        }) : {
            type: 17,
            number: e,
            flags: A
        };
    }, a.prototype.consumeEscapedCodePoint = function() {
        var A = this.consumeCodePoint();
        if (Hn(A)) {
            for(var e = u(A); Hn(this.peekCodePoint(0)) && e.length < 6;)e += u(this.consumeCodePoint());
            vn(this.peekCodePoint(0)) && this.consumeCodePoint();
            var t = parseInt(e, 16);
            return 0 === t || 55296 <= t && t <= 57343 || 1114111 < t ? 65533 : t;
        }
        return -1 === A ? 65533 : A;
    }, a.prototype.consumeName = function() {
        for(var A = "";;){
            var e = this.consumeCodePoint();
            if (bn(e)) A += u(e);
            else {
                if (!Ln(e, this.peekCodePoint(0))) return this.reconsumeCodePoint(e), A;
                A += u(this.consumeEscapedCodePoint());
            }
        }
    }, a), jr = (s.create = function(A) {
        var e = new qr;
        return e.write(A), new s(e.read());
    }, s.parseValue = function(A) {
        return s.create(A).parseComponentValue();
    }, s.parseValues = function(A) {
        return s.create(A).parseComponentValues();
    }, s.prototype.parseComponentValue = function() {
        for(var A = this.consumeToken(); 31 === A.type;)A = this.consumeToken();
        if (32 === A.type) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
        this.reconsumeToken(A);
        for(var e = this.consumeComponentValue(); 31 === (A = this.consumeToken()).type;);
        if (32 === A.type) return e;
        throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    }, s.prototype.parseComponentValues = function() {
        for(var A = [];;){
            var e = this.consumeComponentValue();
            if (32 === e.type) return A;
            A.push(e), A.push();
        }
    }, s.prototype.consumeComponentValue = function() {
        var A = this.consumeToken();
        switch(A.type){
            case 11:
            case 28:
            case 2:
                return this.consumeSimpleBlock(A.type);
            case 19:
                return this.consumeFunction(A);
        }
        return A;
    }, s.prototype.consumeSimpleBlock = function(A) {
        for(var e = {
            type: A,
            values: []
        }, t = this.consumeToken();;){
            if (32 === t.type || $r(t, A)) return e;
            this.reconsumeToken(t), e.values.push(this.consumeComponentValue()), t = this.consumeToken();
        }
    }, s.prototype.consumeFunction = function(A) {
        for(var e = {
            name: A.value,
            values: [],
            type: 18
        };;){
            var t = this.consumeToken();
            if (32 === t.type || 3 === t.type) return e;
            this.reconsumeToken(t), e.values.push(this.consumeComponentValue());
        }
    }, s.prototype.consumeToken = function() {
        var A = this._tokens.shift();
        return void 0 === A ? Zr : A;
    }, s.prototype.reconsumeToken = function(A) {
        this._tokens.unshift(A);
    }, s), zr = function(A) {
        return 15 === A.type;
    }, f = function(A) {
        return 20 === A.type;
    }, $r = function(A, e) {
        return 11 === e && 12 === A.type || 28 === e && 29 === A.type || 2 === e && 3 === A.type;
    }, Ao = function(A) {
        return 17 === A.type || 15 === A.type;
    }, Q = function(A) {
        return 16 === A.type || Ao(A);
    }, p = {
        type: 17,
        number: 0,
        flags: 4
    }, eo = {
        type: 16,
        number: 50,
        flags: 4
    }, to = {
        type: 16,
        number: 100,
        flags: 4
    }, no = function(A, e, t) {
        var n = A[0], A = A[1];
        return [
            O(n, e),
            O(void 0 !== A ? A : n, t)
        ];
    }, O = function(A, e) {
        if (16 === A.type) return A.number / 100 * e;
        if (zr(A)) switch(A.unit){
            case "rem":
            case "em":
                return 16 * A.number;
            default:
                return A.number;
        }
        return A.number;
    }, ro = function(A, e) {
        if (18 === e.type) {
            var t = Qo[e.name];
            if (void 0 === t) throw new Error('Attempting to parse an unsupported color function "' + e.name + '"');
            return t(A, e.values);
        }
        if (5 === e.type) {
            var n, r, o, i;
            if (3 === e.value.length) return n = e.value.substring(0, 1), r = e.value.substring(1, 2), o = e.value.substring(2, 3), io(parseInt(n + n, 16), parseInt(r + r, 16), parseInt(o + o, 16), 1);
            if (4 === e.value.length) return n = e.value.substring(0, 1), r = e.value.substring(1, 2), o = e.value.substring(2, 3), i = e.value.substring(3, 4), io(parseInt(n + n, 16), parseInt(r + r, 16), parseInt(o + o, 16), parseInt(i + i, 16) / 255);
            if (6 === e.value.length) return n = e.value.substring(0, 2), r = e.value.substring(2, 4), o = e.value.substring(4, 6), io(parseInt(n, 16), parseInt(r, 16), parseInt(o, 16), 1);
            if (8 === e.value.length) return n = e.value.substring(0, 2), r = e.value.substring(2, 4), o = e.value.substring(4, 6), i = e.value.substring(6, 8), io(parseInt(n, 16), parseInt(r, 16), parseInt(o, 16), parseInt(i, 16) / 255);
        }
        if (20 === e.type) {
            t = Co[e.value.toUpperCase()];
            if (void 0 !== t) return t;
        }
        return Co.TRANSPARENT;
    }, oo = function(A) {
        return 0 == (255 & A);
    }, io = function(A, e, t, n) {
        return (A << 24 | e << 16 | t << 8 | Math.round(255 * n) << 0) >>> 0;
    };
    function s(A) {
        this._tokens = A;
    }
    function a() {
        this._value = [];
    }
    function so(A, e, t, n) {
        this.codePoints = A, this.required = "!" === e, this.start = t, this.end = n;
    }
    function ao(A, e, t) {
        return t < 0 && (t += 1), 1 <= t && --t, t < 1 / 6 ? (e - A) * t * 6 + A : t < .5 ? e : t < 2 / 3 ? 6 * (e - A) * (2 / 3 - t) + A : A;
    }
    function co(A, e) {
        var t, n, r = (e = e.filter(Rn))[0], o = e[1], i = e[2], e = e[3], r = (17 === r.type ? Vn(r.number) : kn(0, r)) / (2 * Math.PI), o = Q(o) ? o.number / 100 : 0, i = Q(i) ? i.number / 100 : 0, e = void 0 !== e && Q(e) ? O(e, 1) : 1;
        return 0 == o ? io(255 * i, 255 * i, 255 * i, 1) : (t = ao(o = 2 * i - (i = i <= .5 ? i * (1 + o) : i + o - i * o), i, r + 1 / 3), n = ao(o, i, r), o = ao(o, i, r - 1 / 3), io(255 * t, 255 * n, 255 * o, e));
    }
    function Bo(A, e) {
        return A = ro(A, e[0]), (e = e[1]) && Q(e) ? {
            color: A,
            stop: e
        } : {
            color: A,
            stop: null
        };
    }
    function lo(A, t) {
        var e = A[0], n = A[A.length - 1];
        null === e.stop && (e.stop = p), null === n.stop && (n.stop = to);
        for(var r = [], o = 0, i = 0; i < A.length; i++){
            var s = A[i].stop;
            null !== s ? (s = O(s, t), r.push(o < s ? s : o), o = s) : r.push(null);
        }
        for(var a = null, i = 0; i < r.length; i++){
            var c = r[i];
            if (null === c) null === a && (a = i);
            else if (null !== a) {
                for(var B = i - a, l = (c - r[a - 1]) / (1 + B), u = 1; u <= B; u++)r[a + u - 1] = l * u;
                a = null;
            }
        }
        return A.map(function(A, e) {
            return {
                color: A.color,
                stop: Math.max(Math.min(1, r[e] / t), 0)
            };
        });
    }
    function uo(A, e, n, r, o) {
        return [
            [
                0,
                0
            ],
            [
                0,
                e
            ],
            [
                A,
                0
            ],
            [
                A,
                e
            ]
        ].reduce(function(A, e) {
            var t = e[0], t = mo(n - t, r - e[1]);
            return (o ? t < A.optimumDistance : t > A.optimumDistance) ? {
                optimumCorner: e,
                optimumDistance: t
            } : A;
        }, {
            optimumDistance: o ? 1 / 0 : -1 / 0,
            optimumCorner: null
        }).optimumCorner;
    }
    function go(t, A) {
        var n = Vn(180), r = [];
        return Mn(A).forEach(function(A, e) {
            if (0 === e) {
                e = A[0];
                if (20 === e.type && -1 !== [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(e.value)) return void (n = Nn(A));
                if (Gn(e)) return void (n = (kn(0, e) + Vn(270)) % Vn(360));
            }
            e = Bo(t, A);
            r.push(e);
        }), {
            angle: n,
            stops: r,
            type: 1
        };
    }
    function wo(n, A) {
        var r = 0, o = 3, i = [], s = [];
        return Mn(A).forEach(function(A, e) {
            var t = !0;
            0 === e ? t = A.reduce(function(A, e) {
                if (f(e)) switch(e.value){
                    case "center":
                        return s.push(eo), !1;
                    case "top":
                    case "left":
                        return s.push(p), !1;
                    case "right":
                    case "bottom":
                        return s.push(to), !1;
                }
                else if (Q(e) || Ao(e)) return s.push(e), !1;
                return A;
            }, t) : 1 === e && (t = A.reduce(function(A, e) {
                if (f(e)) switch(e.value){
                    case "circle":
                        return r = 0, !1;
                    case "ellipse":
                        return r = 1, false;
                    case "contain":
                    case "closest-side":
                        return o = 0, !1;
                    case "farthest-side":
                        return o = 1, false;
                    case "closest-corner":
                        return o = 2, false;
                    case "cover":
                    case "farthest-corner":
                        return o = 3, false;
                }
                else if (Ao(e) || Q(e)) return (o = Array.isArray(o) ? o : []).push(e), !1;
                return A;
            }, t)), t && (e = Bo(n, A), i.push(e));
        }), {
            size: o,
            shape: r,
            stops: i,
            position: s,
            type: 2
        };
    }
    function ho(A, e) {
        if (22 === e.type) return t = {
            url: e.value,
            type: 0
        }, A.cache.addImage(e.value), t;
        if (18 !== e.type) throw new Error("Unsupported image type " + e.type);
        var t = yo[e.name];
        if (void 0 === t) throw new Error('Attempting to parse an unsupported image function "' + e.name + '"');
        return t(A, e.values);
    }
    var fo, Qo = {
        hsl: co,
        hsla: co,
        rgb: Jn,
        rgba: Jn
    }, po = function(A, e) {
        return ro(A, jr.create(e).parseComponentValue());
    }, Co = {
        ALICEBLUE: 4042850303,
        ANTIQUEWHITE: 4209760255,
        AQUA: 16777215,
        AQUAMARINE: 2147472639,
        AZURE: 4043309055,
        BEIGE: 4126530815,
        BISQUE: 4293182719,
        BLACK: 255,
        BLANCHEDALMOND: 4293643775,
        BLUE: 65535,
        BLUEVIOLET: 2318131967,
        BROWN: 2771004159,
        BURLYWOOD: 3736635391,
        CADETBLUE: 1604231423,
        CHARTREUSE: 2147418367,
        CHOCOLATE: 3530104575,
        CORAL: 4286533887,
        CORNFLOWERBLUE: 1687547391,
        CORNSILK: 4294499583,
        CRIMSON: 3692313855,
        CYAN: 16777215,
        DARKBLUE: 35839,
        DARKCYAN: 9145343,
        DARKGOLDENROD: 3095837695,
        DARKGRAY: 2846468607,
        DARKGREEN: 6553855,
        DARKGREY: 2846468607,
        DARKKHAKI: 3182914559,
        DARKMAGENTA: 2332068863,
        DARKOLIVEGREEN: 1433087999,
        DARKORANGE: 4287365375,
        DARKORCHID: 2570243327,
        DARKRED: 2332033279,
        DARKSALMON: 3918953215,
        DARKSEAGREEN: 2411499519,
        DARKSLATEBLUE: 1211993087,
        DARKSLATEGRAY: 793726975,
        DARKSLATEGREY: 793726975,
        DARKTURQUOISE: 13554175,
        DARKVIOLET: 2483082239,
        DEEPPINK: 4279538687,
        DEEPSKYBLUE: 12582911,
        DIMGRAY: 1768516095,
        DIMGREY: 1768516095,
        DODGERBLUE: 512819199,
        FIREBRICK: 2988581631,
        FLORALWHITE: 4294635775,
        FORESTGREEN: 579543807,
        FUCHSIA: 4278255615,
        GAINSBORO: 3705462015,
        GHOSTWHITE: 4177068031,
        GOLD: 4292280575,
        GOLDENROD: 3668254975,
        GRAY: 2155905279,
        GREEN: 8388863,
        GREENYELLOW: 2919182335,
        GREY: 2155905279,
        HONEYDEW: 4043305215,
        HOTPINK: 4285117695,
        INDIANRED: 3445382399,
        INDIGO: 1258324735,
        IVORY: 4294963455,
        KHAKI: 4041641215,
        LAVENDER: 3873897215,
        LAVENDERBLUSH: 4293981695,
        LAWNGREEN: 2096890111,
        LEMONCHIFFON: 4294626815,
        LIGHTBLUE: 2916673279,
        LIGHTCORAL: 4034953471,
        LIGHTCYAN: 3774873599,
        LIGHTGOLDENRODYELLOW: 4210742015,
        LIGHTGRAY: 3553874943,
        LIGHTGREEN: 2431553791,
        LIGHTGREY: 3553874943,
        LIGHTPINK: 4290167295,
        LIGHTSALMON: 4288707327,
        LIGHTSEAGREEN: 548580095,
        LIGHTSKYBLUE: 2278488831,
        LIGHTSLATEGRAY: 2005441023,
        LIGHTSLATEGREY: 2005441023,
        LIGHTSTEELBLUE: 2965692159,
        LIGHTYELLOW: 4294959359,
        LIME: 16711935,
        LIMEGREEN: 852308735,
        LINEN: 4210091775,
        MAGENTA: 4278255615,
        MAROON: 2147483903,
        MEDIUMAQUAMARINE: 1724754687,
        MEDIUMBLUE: 52735,
        MEDIUMORCHID: 3126187007,
        MEDIUMPURPLE: 2473647103,
        MEDIUMSEAGREEN: 1018393087,
        MEDIUMSLATEBLUE: 2070474495,
        MEDIUMSPRINGGREEN: 16423679,
        MEDIUMTURQUOISE: 1221709055,
        MEDIUMVIOLETRED: 3340076543,
        MIDNIGHTBLUE: 421097727,
        MINTCREAM: 4127193855,
        MISTYROSE: 4293190143,
        MOCCASIN: 4293178879,
        NAVAJOWHITE: 4292783615,
        NAVY: 33023,
        OLDLACE: 4260751103,
        OLIVE: 2155872511,
        OLIVEDRAB: 1804477439,
        ORANGE: 4289003775,
        ORANGERED: 4282712319,
        ORCHID: 3664828159,
        PALEGOLDENROD: 4008225535,
        PALEGREEN: 2566625535,
        PALETURQUOISE: 2951671551,
        PALEVIOLETRED: 3681588223,
        PAPAYAWHIP: 4293907967,
        PEACHPUFF: 4292524543,
        PERU: 3448061951,
        PINK: 4290825215,
        PLUM: 3718307327,
        POWDERBLUE: 2967529215,
        PURPLE: 2147516671,
        REBECCAPURPLE: 1714657791,
        RED: 4278190335,
        ROSYBROWN: 3163525119,
        ROYALBLUE: 1097458175,
        SADDLEBROWN: 2336560127,
        SALMON: 4202722047,
        SANDYBROWN: 4104413439,
        SEAGREEN: 780883967,
        SEASHELL: 4294307583,
        SIENNA: 2689740287,
        SILVER: 3233857791,
        SKYBLUE: 2278484991,
        SLATEBLUE: 1784335871,
        SLATEGRAY: 1887473919,
        SLATEGREY: 1887473919,
        SNOW: 4294638335,
        SPRINGGREEN: 16744447,
        STEELBLUE: 1182971135,
        TAN: 3535047935,
        TEAL: 8421631,
        THISTLE: 3636451583,
        TOMATO: 4284696575,
        TRANSPARENT: 0,
        TURQUOISE: 1088475391,
        VIOLET: 4001558271,
        WHEAT: 4125012991,
        WHITE: 4294967295,
        WHITESMOKE: 4126537215,
        YELLOW: 4294902015,
        YELLOWGREEN: 2597139199
    }, Uo = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: !1,
        type: 1,
        parse: function(A, e) {
            return e.map(function(A) {
                if (f(A)) switch(A.value){
                    case "padding-box":
                        return 1;
                    case "content-box":
                        return 2;
                }
                return 0;
            });
        }
    }, Fo = {
        name: "background-color",
        initialValue: "transparent",
        prefix: !1,
        type: 3,
        format: "color"
    }, mo = function(A, e) {
        return Math.sqrt(A * A + e * e);
    }, yo = {
        "linear-gradient": function(t, A) {
            var n = Vn(180), r = [];
            return Mn(A).forEach(function(A, e) {
                if (0 === e) {
                    e = A[0];
                    if (20 === e.type && "to" === e.value) return void (n = Nn(A));
                    if (Gn(e)) return void (n = kn(0, e));
                }
                e = Bo(t, A);
                r.push(e);
            }), {
                angle: n,
                stops: r,
                type: 1
            };
        },
        "-moz-linear-gradient": go,
        "-ms-linear-gradient": go,
        "-o-linear-gradient": go,
        "-webkit-linear-gradient": go,
        "radial-gradient": function(r, A) {
            var o = 0, i = 3, s = [], a = [];
            return Mn(A).forEach(function(A, e) {
                var t, n = !0;
                0 === e && (t = !1, n = A.reduce(function(A, e) {
                    if (t) {
                        if (f(e)) switch(e.value){
                            case "center":
                                return a.push(eo), A;
                            case "top":
                            case "left":
                                return a.push(p), A;
                            case "right":
                            case "bottom":
                                return a.push(to), A;
                        }
                        else (Q(e) || Ao(e)) && a.push(e);
                    } else if (f(e)) switch(e.value){
                        case "circle":
                            return o = 0, !1;
                        case "ellipse":
                            return o = 1, false;
                        case "at":
                            return t = !0, false;
                        case "closest-side":
                            return i = 0, !1;
                        case "cover":
                        case "farthest-side":
                            return i = 1, false;
                        case "contain":
                        case "closest-corner":
                            return i = 2, false;
                        case "farthest-corner":
                            return i = 3, false;
                    }
                    else if (Ao(e) || Q(e)) return (i = Array.isArray(i) ? i : []).push(e), !1;
                    return A;
                }, n)), n && (e = Bo(r, A), s.push(e));
            }), {
                size: i,
                shape: o,
                stops: s,
                position: a,
                type: 2
            };
        },
        "-moz-radial-gradient": wo,
        "-ms-radial-gradient": wo,
        "-o-radial-gradient": wo,
        "-webkit-radial-gradient": wo,
        "-webkit-gradient": function(n, A) {
            var e = Vn(180), r = [], o = 1;
            return Mn(A).forEach(function(A, e) {
                var t, A = A[0];
                if (0 === e) {
                    if (f(A) && "linear" === A.value) return void (o = 1);
                    if (f(A) && "radial" === A.value) return void (o = 2);
                }
                18 === A.type && ("from" === A.name ? (t = ro(n, A.values[0]), r.push({
                    stop: p,
                    color: t
                })) : "to" === A.name ? (t = ro(n, A.values[0]), r.push({
                    stop: to,
                    color: t
                })) : "color-stop" === A.name && 2 === (e = A.values.filter(Rn)).length && (t = ro(n, e[1]), A = e[0], Tn(A)) && r.push({
                    stop: {
                        type: 16,
                        number: 100 * A.number,
                        flags: A.flags
                    },
                    color: t
                }));
            }), 1 === o ? {
                angle: (e + Vn(180)) % Vn(360),
                stops: r,
                type: o
            } : {
                size: 3,
                shape: 0,
                stops: r,
                position: [],
                type: o
            };
        }
    }, Eo = {
        name: "background-image",
        initialValue: "none",
        type: 1,
        prefix: !1,
        parse: function(e, A) {
            var t;
            return 0 === A.length || 20 === (t = A[0]).type && "none" === t.value ? [] : A.filter(function(A) {
                return Rn(A) && !(20 === A.type && "none" === A.value || 18 === A.type && !yo[A.name]);
            }).map(function(A) {
                return ho(e, A);
            });
        }
    }, Ho = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: !1,
        type: 1,
        parse: function(A, e) {
            return e.map(function(A) {
                if (f(A)) switch(A.value){
                    case "padding-box":
                        return 1;
                    case "content-box":
                        return 2;
                }
                return 0;
            });
        }
    }, vo = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1,
        prefix: !1,
        parse: function(A, e) {
            return Mn(e).map(function(A) {
                return A.filter(Q);
            }).map(Pn);
        }
    }, Io = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: !1,
        type: 1,
        parse: function(A, e) {
            return Mn(e).map(function(A) {
                return A.filter(f).map(function(A) {
                    return A.value;
                }).join(" ");
            }).map(bo);
        }
    }, bo = function(A) {
        switch(A){
            case "no-repeat":
                return 1;
            case "repeat-x":
            case "repeat no-repeat":
                return 2;
            case "repeat-y":
            case "no-repeat repeat":
                return 3;
            default:
                return 0;
        }
    };
    (r = fo = fo || {}).AUTO = "auto", r.CONTAIN = "contain";
    function Lo(A) {
        return {
            name: "border-" + A + "-color",
            initialValue: "transparent",
            prefix: !1,
            type: 3,
            format: "color"
        };
    }
    function Ko(A) {
        return {
            name: "border-radius-" + A,
            initialValue: "0 0",
            prefix: !1,
            type: 1,
            parse: function(A, e) {
                return Pn(e.filter(Q));
            }
        };
    }
    function So(A) {
        return {
            name: "border-" + A + "-style",
            initialValue: "solid",
            prefix: !1,
            type: 2,
            parse: function(A, e) {
                switch(e){
                    case "none":
                        return 0;
                    case "dashed":
                        return 2;
                    case "dotted":
                        return 3;
                    case "double":
                        return 4;
                }
                return 1;
            }
        };
    }
    function To(A) {
        return {
            name: "border-" + A + "-width",
            initialValue: "0",
            type: 0,
            prefix: !1,
            parse: function(A, e) {
                return zr(e) ? e.number : 0;
            }
        };
    }
    function Oo(A, e) {
        return f(A) && "normal" === A.value ? 1.2 * e : 17 === A.type ? e * A.number : Q(A) ? O(A, e) : e;
    }
    function xo(A) {
        return {
            name: "margin-" + A,
            initialValue: "0",
            prefix: !1,
            type: 4
        };
    }
    function Do(A) {
        return {
            name: "padding-" + A,
            initialValue: "0",
            prefix: !1,
            type: 3,
            format: "length-percentage"
        };
    }
    var Ro, Mo, Po = {
        name: "background-size",
        initialValue: "0",
        prefix: (r.COVER = "cover", false),
        type: 1,
        parse: function(A, e) {
            return Mn(e).map(function(A) {
                return A.filter(ko);
            });
        }
    }, ko = function(A) {
        return f(A) || Q(A);
    }, Go = Lo("top"), No = Lo("right"), Vo = Lo("bottom"), Xo = Lo("left"), Jo = Ko("top-left"), Wo = Ko("top-right"), _o = Ko("bottom-right"), Yo = Ko("bottom-left"), Zo = So("top"), qo = So("right"), jo = So("bottom"), zo = So("left"), $o = To("top"), Ai = To("right"), ei = To("bottom"), ti = To("left"), ni = {
        name: "color",
        initialValue: "transparent",
        prefix: !1,
        type: 3,
        format: "color"
    }, ri = {
        name: "direction",
        initialValue: "ltr",
        prefix: !1,
        type: 2,
        parse: function(A, e) {
            return "rtl" !== e ? 0 : 1;
        }
    }, oi = {
        name: "display",
        initialValue: "inline-block",
        prefix: !1,
        type: 1,
        parse: function(A, e) {
            return e.filter(f).reduce(function(A, e) {
                return A | ii(e.value);
            }, 0);
        }
    }, ii = function(A) {
        switch(A){
            case "block":
            case "-webkit-box":
                return 2;
            case "inline":
                return 4;
            case "run-in":
                return 8;
            case "flow":
                return 16;
            case "flow-root":
                return 32;
            case "table":
                return 64;
            case "flex":
            case "-webkit-flex":
                return 128;
            case "grid":
            case "-ms-grid":
                return 256;
            case "ruby":
                return 512;
            case "subgrid":
                return 1024;
            case "list-item":
                return 2048;
            case "table-row-group":
                return 4096;
            case "table-header-group":
                return 8192;
            case "table-footer-group":
                return 16384;
            case "table-row":
                return 32768;
            case "table-cell":
                return 65536;
            case "table-column-group":
                return 131072;
            case "table-column":
                return 262144;
            case "table-caption":
                return 524288;
            case "ruby-base":
                return 1048576;
            case "ruby-text":
                return 2097152;
            case "ruby-base-container":
                return 4194304;
            case "ruby-text-container":
                return 8388608;
            case "contents":
                return 16777216;
            case "inline-block":
                return 33554432;
            case "inline-list-item":
                return 67108864;
            case "inline-table":
                return 134217728;
            case "inline-flex":
                return 268435456;
            case "inline-grid":
                return 536870912;
        }
        return 0;
    }, si = {
        name: "float",
        initialValue: "none",
        prefix: !1,
        type: 2,
        parse: function(A, e) {
            switch(e){
                case "left":
                    return 1;
                case "right":
                    return 2;
                case "inline-start":
                    return 3;
                case "inline-end":
                    return 4;
            }
            return 0;
        }
    }, ai = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: !1,
        type: 0,
        parse: function(A, e) {
            return !(20 === e.type && "normal" === e.value || 17 !== e.type && 15 !== e.type) ? e.number : 0;
        }
    }, ci = {
        name: "line-break",
        initialValue: (i = Ro = Ro || {}).NORMAL = "normal",
        prefix: (i.STRICT = "strict", false),
        type: 2,
        parse: function(A, e) {
            return "strict" !== e ? Ro.NORMAL : Ro.STRICT;
        }
    }, Bi = {
        name: "line-height",
        initialValue: "normal",
        prefix: !1,
        type: 4
    }, li = {
        name: "list-style-image",
        initialValue: "none",
        type: 0,
        prefix: !1,
        parse: function(A, e) {
            return 20 === e.type && "none" === e.value ? null : ho(A, e);
        }
    }, ui = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: !1,
        type: 2,
        parse: function(A, e) {
            return "inside" !== e ? 1 : 0;
        }
    }, gi = {
        name: "list-style-type",
        initialValue: "none",
        prefix: !1,
        type: 2,
        parse: function(A, e) {
            switch(e){
                case "disc":
                    return 0;
                case "circle":
                    return 1;
                case "square":
                    return 2;
                case "decimal":
                    return 3;
                case "cjk-decimal":
                    return 4;
                case "decimal-leading-zero":
                    return 5;
                case "lower-roman":
                    return 6;
                case "upper-roman":
                    return 7;
                case "lower-greek":
                    return 8;
                case "lower-alpha":
                    return 9;
                case "upper-alpha":
                    return 10;
                case "arabic-indic":
                    return 11;
                case "armenian":
                    return 12;
                case "bengali":
                    return 13;
                case "cambodian":
                    return 14;
                case "cjk-earthly-branch":
                    return 15;
                case "cjk-heavenly-stem":
                    return 16;
                case "cjk-ideographic":
                    return 17;
                case "devanagari":
                    return 18;
                case "ethiopic-numeric":
                    return 19;
                case "georgian":
                    return 20;
                case "gujarati":
                    return 21;
                case "gurmukhi":
                case "hebrew":
                    return 22;
                case "hiragana":
                    return 23;
                case "hiragana-iroha":
                    return 24;
                case "japanese-formal":
                    return 25;
                case "japanese-informal":
                    return 26;
                case "kannada":
                    return 27;
                case "katakana":
                    return 28;
                case "katakana-iroha":
                    return 29;
                case "khmer":
                    return 30;
                case "korean-hangul-formal":
                    return 31;
                case "korean-hanja-formal":
                    return 32;
                case "korean-hanja-informal":
                    return 33;
                case "lao":
                    return 34;
                case "lower-armenian":
                    return 35;
                case "malayalam":
                    return 36;
                case "mongolian":
                    return 37;
                case "myanmar":
                    return 38;
                case "oriya":
                    return 39;
                case "persian":
                    return 40;
                case "simp-chinese-formal":
                    return 41;
                case "simp-chinese-informal":
                    return 42;
                case "tamil":
                    return 43;
                case "telugu":
                    return 44;
                case "thai":
                    return 45;
                case "tibetan":
                    return 46;
                case "trad-chinese-formal":
                    return 47;
                case "trad-chinese-informal":
                    return 48;
                case "upper-armenian":
                    return 49;
                case "disclosure-open":
                    return 50;
                case "disclosure-closed":
                    return 51;
                default:
                    return -1;
            }
        }
    }, wi = xo("top"), di = xo("right"), hi = xo("bottom"), fi = xo("left"), Qi = {
        name: "overflow",
        initialValue: "visible",
        prefix: !1,
        type: 1,
        parse: function(A, e) {
            return e.filter(f).map(function(A) {
                switch(A.value){
                    case "hidden":
                        return 1;
                    case "scroll":
                        return 2;
                    case "clip":
                        return 3;
                    case "auto":
                        return 4;
                    default:
                        return 0;
                }
            });
        }
    }, pi = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: !1,
        type: 2,
        parse: function(A, e) {
            return "break-word" !== e ? "normal" : "break-word";
        }
    }, Ci = Do("top"), Ui = Do("right"), Fi = Do("bottom"), mi = Do("left"), yi = {
        name: "text-align",
        initialValue: "left",
        prefix: !1,
        type: 2,
        parse: function(A, e) {
            switch(e){
                case "right":
                    return 2;
                case "center":
                case "justify":
                    return 1;
                default:
                    return 0;
            }
        }
    }, Ei = {
        name: "position",
        initialValue: "static",
        prefix: !1,
        type: 2,
        parse: function(A, e) {
            switch(e){
                case "relative":
                    return 1;
                case "absolute":
                    return 2;
                case "fixed":
                    return 3;
                case "sticky":
                    return 4;
            }
            return 0;
        }
    }, Hi = {
        name: "text-shadow",
        initialValue: "none",
        type: 1,
        prefix: !1,
        parse: function(o, A) {
            return 1 === A.length && xn(A[0], "none") ? [] : Mn(A).map(function(A) {
                for(var e = {
                    color: Co.TRANSPARENT,
                    offsetX: p,
                    offsetY: p,
                    blur: p
                }, t = 0, n = 0; n < A.length; n++){
                    var r = A[n];
                    Ao(r) ? (0 === t ? e.offsetX = r : 1 === t ? e.offsetY = r : e.blur = r, t++) : e.color = ro(o, r);
                }
                return e;
            });
        }
    }, vi = {
        name: "text-transform",
        initialValue: "none",
        prefix: !1,
        type: 2,
        parse: function(A, e) {
            switch(e){
                case "uppercase":
                    return 2;
                case "lowercase":
                    return 1;
                case "capitalize":
                    return 3;
            }
            return 0;
        }
    }, Ii = {
        name: "transform",
        initialValue: "none",
        prefix: !0,
        type: 0,
        parse: function(A, e) {
            if (20 === e.type && "none" === e.value) return null;
            if (18 !== e.type) return null;
            var t = bi[e.name];
            if (void 0 === t) throw new Error('Attempting to parse an unsupported transform function "' + e.name + '"');
            return t(e.values);
        }
    }, bi = {
        matrix: function(A) {
            A = A.filter(function(A) {
                return 17 === A.type;
            }).map(function(A) {
                return A.number;
            });
            return 6 === A.length ? A : null;
        },
        matrix3d: function(A) {
            var A = A.filter(function(A) {
                return 17 === A.type;
            }).map(function(A) {
                return A.number;
            }), e = A[0];
            return 16 === A.length ? [
                e,
                A[1],
                A[4],
                A[5],
                A[12],
                A[13]
            ] : null;
        }
    }, C = {
        type: 16,
        number: 50,
        flags: 4
    }, Li = [
        C,
        C
    ], Ki = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: !0,
        type: 1,
        parse: function(A, e) {
            e = e.filter(Q);
            return 2 !== e.length ? Li : [
                e[0],
                e[1]
            ];
        }
    }, Si = {
        name: "visible",
        initialValue: "none",
        prefix: !1,
        type: 2,
        parse: function(A, e) {
            switch(e){
                case "hidden":
                    return 1;
                case "collapse":
                    return 2;
                default:
                    return 0;
            }
        }
    };
    (mB = Mo = Mo || {}).NORMAL = "normal", mB.BREAK_ALL = "break-all";
    for(var Ti = {
        name: "word-break",
        initialValue: "normal",
        prefix: (mB.KEEP_ALL = "keep-all", false),
        type: 2,
        parse: function(A, e) {
            switch(e){
                case "break-all":
                    return Mo.BREAK_ALL;
                case "keep-all":
                    return Mo.KEEP_ALL;
                default:
                    return Mo.NORMAL;
            }
        }
    }, Oi = {
        name: "z-index",
        initialValue: "auto",
        prefix: !1,
        type: 0,
        parse: function(A, e) {
            if (20 === e.type) return {
                auto: !0,
                order: 0
            };
            if (Tn(e)) return {
                auto: !1,
                order: e.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    }, xi = function(A, e) {
        if (15 === e.type) switch(e.unit.toLowerCase()){
            case "s":
                return 1e3 * e.number;
            case "ms":
                return e.number;
        }
        throw new Error("Unsupported time type");
    }, Di = {
        name: "opacity",
        initialValue: "1",
        type: 0,
        prefix: !1,
        parse: function(A, e) {
            return Tn(e) ? e.number : 1;
        }
    }, Ri = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: !1,
        type: 3,
        format: "color"
    }, Mi = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: !1,
        type: 1,
        parse: function(A, e) {
            return e.filter(f).map(function(A) {
                switch(A.value){
                    case "underline":
                        return 1;
                    case "overline":
                        return 2;
                    case "line-through":
                        return 3;
                    case "none":
                        return 4;
                }
                return 0;
            }).filter(function(A) {
                return 0 !== A;
            });
        }
    }, Pi = {
        name: "font-family",
        initialValue: "",
        prefix: !1,
        type: 1,
        parse: function(A, e) {
            var t = [], n = [];
            return e.forEach(function(A) {
                switch(A.type){
                    case 20:
                    case 0:
                        t.push(A.value);
                        break;
                    case 17:
                        t.push(A.number.toString());
                        break;
                    case 4:
                        n.push(t.join(" ")), t.length = 0;
                }
            }), t.length && n.push(t.join(" ")), n.map(function(A) {
                return -1 === A.indexOf(" ") ? A : "'" + A + "'";
            });
        }
    }, ki = {
        name: "font-size",
        initialValue: "0",
        prefix: !1,
        type: 3,
        format: "length"
    }, Gi = {
        name: "font-weight",
        initialValue: "normal",
        type: 0,
        prefix: !1,
        parse: function(A, e) {
            return Tn(e) ? e.number : !f(e) || "bold" !== e.value ? 400 : 700;
        }
    }, Ni = {
        name: "font-variant",
        initialValue: "none",
        type: 1,
        prefix: !1,
        parse: function(A, e) {
            return e.filter(f).map(function(A) {
                return A.value;
            });
        }
    }, Vi = {
        name: "font-style",
        initialValue: "normal",
        prefix: !1,
        type: 2,
        parse: function(A, e) {
            switch(e){
                case "oblique":
                    return "oblique";
                case "italic":
                    return "italic";
                default:
                    return "normal";
            }
        }
    }, U = function(A, e) {
        return 0 != (A & e);
    }, Xi = {
        name: "content",
        initialValue: "none",
        type: 1,
        prefix: !1,
        parse: function(A, e) {
            var t;
            return 0 === e.length || 20 === (t = e[0]).type && "none" === t.value ? [] : e;
        }
    }, Ji = {
        name: "counter-increment",
        initialValue: "none",
        prefix: !0,
        type: 1,
        parse: function(A, e) {
            if (0 === e.length) return null;
            var t = e[0];
            if (20 === t.type && "none" === t.value) return null;
            for(var n = [], r = e.filter(Dn), o = 0; o < r.length; o++){
                var i = r[o], s = r[o + 1];
                20 === i.type && (s = s && Tn(s) ? s.number : 1, n.push({
                    counter: i.value,
                    increment: s
                }));
            }
            return n;
        }
    }, Wi = {
        name: "counter-reset",
        initialValue: "none",
        prefix: !0,
        type: 1,
        parse: function(A, e) {
            if (0 === e.length) return [];
            for(var t = [], n = e.filter(Dn), r = 0; r < n.length; r++){
                var o = n[r], i = n[r + 1];
                f(o) && "none" !== o.value && (i = i && Tn(i) ? i.number : 0, t.push({
                    counter: o.value,
                    reset: i
                }));
            }
            return t;
        }
    }, _i = {
        name: "duration",
        initialValue: "0s",
        prefix: !1,
        type: 1,
        parse: function(A, e) {
            return e.filter(zr).map(function(A) {
                return xi(0, A);
            });
        }
    }, Yi = {
        name: "quotes",
        initialValue: "none",
        prefix: !0,
        type: 1,
        parse: function(A, e) {
            if (0 === e.length) return null;
            var t = e[0];
            if (20 === t.type && "none" === t.value) return null;
            var n = [], r = e.filter(On);
            if (r.length % 2 != 0) return null;
            for(var o = 0; o < r.length; o += 2){
                var i = r[o].value, s = r[o + 1].value;
                n.push({
                    open: i,
                    close: s
                });
            }
            return n;
        }
    }, Zi = function(A, e, t) {
        return A && (e = A[Math.min(e, A.length - 1)]) ? t ? e.open : e.close : "";
    }, qi = {
        name: "box-shadow",
        initialValue: "none",
        type: 1,
        prefix: !1,
        parse: function(o, A) {
            return 1 === A.length && xn(A[0], "none") ? [] : Mn(A).map(function(A) {
                for(var e = {
                    color: 255,
                    offsetX: p,
                    offsetY: p,
                    blur: p,
                    spread: p,
                    inset: !1
                }, t = 0, n = 0; n < A.length; n++){
                    var r = A[n];
                    xn(r, "inset") ? e.inset = !0 : Ao(r) ? (0 === t ? e.offsetX = r : 1 === t ? e.offsetY = r : 2 === t ? e.blur = r : e.spread = r, t++) : e.color = ro(o, r);
                }
                return e;
            });
        }
    }, ji = {
        name: "paint-order",
        initialValue: "normal",
        prefix: !1,
        type: 1,
        parse: function(A, e) {
            var t = [];
            return e.filter(f).forEach(function(A) {
                switch(A.value){
                    case "stroke":
                        t.push(1);
                        break;
                    case "fill":
                        t.push(0);
                        break;
                    case "markers":
                        t.push(2);
                }
            }), [
                0,
                1,
                2
            ].forEach(function(A) {
                -1 === t.indexOf(A) && t.push(A);
            }), t;
        }
    }, zi = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: !1,
        type: 3,
        format: "color"
    }, $i = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0,
        prefix: !1,
        parse: function(A, e) {
            return zr(e) ? e.number : 0;
        }
    }, As = (as.prototype.isVisible = function() {
        return 0 < this.display && 0 < this.opacity && 0 === this.visibility;
    }, as.prototype.isTransparent = function() {
        return oo(this.backgroundColor);
    }, as.prototype.isTransformed = function() {
        return null !== this.transform;
    }, as.prototype.isPositioned = function() {
        return 0 !== this.position;
    }, as.prototype.isPositionedWithZIndex = function() {
        return this.isPositioned() && !this.zIndex.auto;
    }, as.prototype.isFloating = function() {
        return 0 !== this.float;
    }, as.prototype.isInlineLevel = function() {
        return U(this.display, 4) || U(this.display, 33554432) || U(this.display, 268435456) || U(this.display, 536870912) || U(this.display, 67108864) || U(this.display, 134217728);
    }, as), es = function(A, e) {
        this.content = F(A, Xi, e.content), this.quotes = F(A, Yi, e.quotes);
    }, ts = function(A, e) {
        this.counterIncrement = F(A, Ji, e.counterIncrement), this.counterReset = F(A, Wi, e.counterReset);
    }, F = function(A, e, t) {
        var n = new qr, t = null != t ? t.toString() : e.initialValue, r = (n.write(t), new jr(n.read()));
        switch(e.type){
            case 2:
                var o = r.parseComponentValue();
                return e.parse(A, f(o) ? o.value : e.initialValue);
            case 0:
                return e.parse(A, r.parseComponentValue());
            case 1:
                return e.parse(A, r.parseComponentValues());
            case 4:
                return r.parseComponentValue();
            case 3:
                switch(e.format){
                    case "angle":
                        return kn(0, r.parseComponentValue());
                    case "color":
                        return ro(A, r.parseComponentValue());
                    case "image":
                        return ho(A, r.parseComponentValue());
                    case "length":
                        var i = r.parseComponentValue();
                        return Ao(i) ? i : p;
                    case "length-percentage":
                        i = r.parseComponentValue();
                        return Q(i) ? i : p;
                    case "time":
                        return xi(0, r.parseComponentValue());
                }
        }
    }, ns = function(A, e) {
        var t = (()=>{
            switch(A.getAttribute("data-html2canvas-debug")){
                case "all":
                    return 1;
                case "clone":
                    return 2;
                case "parse":
                    return 3;
                case "render":
                    return 4;
                default:
                    return 0;
            }
        })();
        return 1 === t || e === t;
    }, rs = function(A, e) {
        this.context = A, this.textNodes = [], this.elements = [], this.flags = 0, ns(e, 3), this.styles = new As(A, window.getComputedStyle(e, null)), fa(e) && (this.styles.animationDuration.some(function(A) {
            return 0 < A;
        }) && (e.style.animationDuration = "0s"), null !== this.styles.transform) && (e.style.transform = "none"), this.bounds = gn(this.context, e), ns(e, 4) && (this.flags |= 16);
    }, os = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", is = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), ss = 0; ss < os.length; ss++)is[os.charCodeAt(ss)] = ss;
    function as(A, e) {
        this.animationDuration = F(A, _i, e.animationDuration), this.backgroundClip = F(A, Uo, e.backgroundClip), this.backgroundColor = F(A, Fo, e.backgroundColor), this.backgroundImage = F(A, Eo, e.backgroundImage), this.backgroundOrigin = F(A, Ho, e.backgroundOrigin), this.backgroundPosition = F(A, vo, e.backgroundPosition), this.backgroundRepeat = F(A, Io, e.backgroundRepeat), this.backgroundSize = F(A, Po, e.backgroundSize), this.borderTopColor = F(A, Go, e.borderTopColor), this.borderRightColor = F(A, No, e.borderRightColor), this.borderBottomColor = F(A, Vo, e.borderBottomColor), this.borderLeftColor = F(A, Xo, e.borderLeftColor), this.borderTopLeftRadius = F(A, Jo, e.borderTopLeftRadius), this.borderTopRightRadius = F(A, Wo, e.borderTopRightRadius), this.borderBottomRightRadius = F(A, _o, e.borderBottomRightRadius), this.borderBottomLeftRadius = F(A, Yo, e.borderBottomLeftRadius), this.borderTopStyle = F(A, Zo, e.borderTopStyle), this.borderRightStyle = F(A, qo, e.borderRightStyle), this.borderBottomStyle = F(A, jo, e.borderBottomStyle), this.borderLeftStyle = F(A, zo, e.borderLeftStyle), this.borderTopWidth = F(A, $o, e.borderTopWidth), this.borderRightWidth = F(A, Ai, e.borderRightWidth), this.borderBottomWidth = F(A, ei, e.borderBottomWidth), this.borderLeftWidth = F(A, ti, e.borderLeftWidth), this.boxShadow = F(A, qi, e.boxShadow), this.color = F(A, ni, e.color), this.direction = F(A, ri, e.direction), this.display = F(A, oi, e.display), this.float = F(A, si, e.cssFloat), this.fontFamily = F(A, Pi, e.fontFamily), this.fontSize = F(A, ki, e.fontSize), this.fontStyle = F(A, Vi, e.fontStyle), this.fontVariant = F(A, Ni, e.fontVariant), this.fontWeight = F(A, Gi, e.fontWeight), this.letterSpacing = F(A, ai, e.letterSpacing), this.lineBreak = F(A, ci, e.lineBreak), this.lineHeight = F(A, Bi, e.lineHeight), this.listStyleImage = F(A, li, e.listStyleImage), this.listStylePosition = F(A, ui, e.listStylePosition), this.listStyleType = F(A, gi, e.listStyleType), this.marginTop = F(A, wi, e.marginTop), this.marginRight = F(A, di, e.marginRight), this.marginBottom = F(A, hi, e.marginBottom), this.marginLeft = F(A, fi, e.marginLeft), this.opacity = F(A, Di, e.opacity);
        var t = F(A, Qi, e.overflow);
        this.overflowX = t[0], this.overflowY = t[1 < t.length ? 1 : 0], this.overflowWrap = F(A, pi, e.overflowWrap), this.paddingTop = F(A, Ci, e.paddingTop), this.paddingRight = F(A, Ui, e.paddingRight), this.paddingBottom = F(A, Fi, e.paddingBottom), this.paddingLeft = F(A, mi, e.paddingLeft), this.paintOrder = F(A, ji, e.paintOrder), this.position = F(A, Ei, e.position), this.textAlign = F(A, yi, e.textAlign), this.textDecorationColor = F(A, Ri, null != (t = e.textDecorationColor) ? t : e.color), this.textDecorationLine = F(A, Mi, null != (t = e.textDecorationLine) ? t : e.textDecoration), this.textShadow = F(A, Hi, e.textShadow), this.textTransform = F(A, vi, e.textTransform), this.transform = F(A, Ii, e.transform), this.transformOrigin = F(A, Ki, e.transformOrigin), this.visibility = F(A, Si, e.visibility), this.webkitTextStrokeColor = F(A, zi, e.webkitTextStrokeColor), this.webkitTextStrokeWidth = F(A, $i, e.webkitTextStrokeWidth), this.wordBreak = F(A, Ti, e.wordBreak), this.zIndex = F(A, Oi, e.zIndex);
    }
    for(var y = function(A, e, t) {
        return A.slice ? A.slice(e, t) : new Uint16Array(Array.prototype.slice.call(A, e, t));
    }, r = (us.prototype.get = function(A) {
        var e;
        if (0 <= A) {
            if (A < 55296 || 56319 < A && A <= 65535) return e = ((e = this.index[A >> 5]) << 2) + (31 & A), this.data[e];
            if (A <= 65535) return e = ((e = this.index[2048 + (A - 55296 >> 5)]) << 2) + (31 & A), this.data[e];
            if (A < this.highStart) return e = this.index[e = 2080 + (A >> 11)], e = ((e = this.index[e += A >> 5 & 63]) << 2) + (31 & A), this.data[e];
            if (A <= 1114111) return this.data[this.highValueIndex];
        }
        return this.errorValue;
    }, us), cs = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Bs = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), ls = 0; ls < cs.length; ls++)Bs[cs.charCodeAt(ls)] = ls;
    function us(A, e, t, n, r, o) {
        this.initialValue = A, this.errorValue = e, this.highStart = t, this.highValueIndex = n, this.index = r, this.data = o;
    }
    function gs(A) {
        var t = ((A)=>{
            for(var e = [], t = 0, n = A.length; t < n;){
                var r, o = A.charCodeAt(t++);
                55296 <= o && o <= 56319 && t < n ? 56320 == (64512 & (r = A.charCodeAt(t++))) ? e.push(((1023 & o) << 10) + (1023 & r) + 65536) : (e.push(o), t--) : e.push(o);
            }
            return e;
        })(A), n = t.length, r = 0, o = 0, i = t.map(Ps);
        return {
            next: function() {
                if (n <= r) return {
                    done: !0,
                    value: null
                };
                for(var A, e = "\xd7"; r < n && "\xd7" === (e = ks(0, i, ++r)););
                return "\xd7" !== e || r === n ? (A = Rs.apply(null, t.slice(o, r)), o = r, {
                    value: A,
                    done: !1
                }) : {
                    done: !0,
                    value: null
                };
            }
        };
    }
    function ws(A) {
        return 0 === A[0] && 255 === A[1] && 0 === A[2] && 255 === A[3];
    }
    function ds(A, e, t, n, r) {
        var o = "http://www.w3.org/2000/svg", i = document.createElementNS(o, "svg"), o = document.createElementNS(o, "foreignObject");
        return i.setAttributeNS(null, "width", A.toString()), i.setAttributeNS(null, "height", e.toString()), o.setAttributeNS(null, "width", "100%"), o.setAttributeNS(null, "height", "100%"), o.setAttributeNS(null, "x", t.toString()), o.setAttributeNS(null, "y", n.toString()), o.setAttributeNS(null, "externalResourcesRequired", "true"), i.appendChild(o), o.appendChild(r), i;
    }
    function hs(n) {
        return new Promise(function(A, e) {
            var t = new Image;
            t.onload = function() {
                return A(t);
            }, t.onerror = e, t.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent((new XMLSerializer).serializeToString(n));
        });
    }
    function fs(A) {
        return "VIDEO" === A.tagName;
    }
    function Qs(A) {
        return "STYLE" === A.tagName;
    }
    function ps(A) {
        return 0 < A.tagName.indexOf("-");
    }
    function Cs(n, A, e, r, t, o) {
        return n < A || e < n ? Da(n, t, 0 < o.length) : r.integers.reduce(function(A, e, t) {
            for(; e <= n;)n -= e, A += r.values[t];
            return A;
        }, "") + o;
    }
    function E(A, e, t, n, r) {
        var o = t - e + 1;
        return (A < 0 ? "-" : "") + (xa(Math.abs(A), o, n, function(A) {
            return u(Math.floor(A % o) + e);
        }) + r);
    }
    function Us(A, e, t) {
        void 0 === t && (t = ". ");
        var n = e.length;
        return xa(Math.abs(A), n, !1, function(A) {
            return e[Math.floor(A % n)];
        }) + t;
    }
    function Fs(A, e, t, n, r, o) {
        if (A < -9999 || 9999 < A) return Da(A, 4, 0 < r.length);
        var i = Math.abs(A), s = r;
        if (0 === i) return e[0] + s;
        for(var a = 0; 0 < i && a <= 4; a++){
            var c = i % 10;
            0 == c && U(o, 1) && "" !== s ? s = e[c] + s : 1 < c || 1 == c && 0 === a || 1 == c && 1 === a && U(o, 2) || 1 == c && 1 === a && U(o, 4) && 100 < A || 1 == c && 1 < a && U(o, 8) ? s = e[c] + (0 < a ? t[a - 1] : "") + s : 1 == c && 0 < a && (s = t[a - 1] + s), i = Math.floor(i / 10);
        }
        return (A < 0 ? n : "") + s;
    }
    var ms, ys, Es, Hs, vs, Is, bs, Ls, Ks, Ss, y, Ts = 8, Os = 9, xs = 11, Ds = 12, Rs = function() {
        for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, A);
        var t = A.length;
        if (!t) return "";
        for(var n = [], r = -1, o = ""; ++r < t;){
            var i = A[r];
            i <= 65535 ? n.push(i) : n.push(55296 + ((i -= 65536) >> 10), i % 1024 + 56320), (r + 1 === t || 16384 < n.length) && (o += String.fromCharCode.apply(String, n), n.length = 0);
        }
        return o;
    }, Ms = (i = ((A)=>{
        for(var e, t, n, r, o = .75 * A.length, i = A.length, s = 0, o = ("=" === A[A.length - 1] && (o--, "=" === A[A.length - 2]) && o--, new ("undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array && void 0 !== Uint8Array.prototype.slice ? ArrayBuffer : Array)(o)), a = Array.isArray(o) ? o : new Uint8Array(o), c = 0; c < i; c += 4)e = is[A.charCodeAt(c)], t = is[A.charCodeAt(c + 1)], n = is[A.charCodeAt(c + 2)], r = is[A.charCodeAt(c + 3)], a[s++] = e << 2 | t >> 4, a[s++] = (15 & t) << 4 | n >> 2, a[s++] = (3 & n) << 6 | 63 & r;
        return o;
    })("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"), C = Array.isArray(i) ? ((A)=>{
        for(var e = A.length, t = [], n = 0; n < e; n += 4)t.push(A[n + 3] << 24 | A[n + 2] << 16 | A[n + 1] << 8 | A[n]);
        return t;
    })(i) : new Uint32Array(i), i = Array.isArray(i) ? ((A)=>{
        for(var e = A.length, t = [], n = 0; n < e; n += 2)t.push(A[n + 1] << 8 | A[n]);
        return t;
    })(i) : new Uint16Array(i), mB = y(i, 12, C[4] / 2), i = 2 === C[5] ? y(i, (24 + C[4]) / 2) : (i = C, y = Math.ceil((24 + C[4]) / 4), i.slice ? i.slice(y, void 0) : new Uint32Array(Array.prototype.slice.call(i, y, void 0))), new r(C[0], C[1], C[2], C[3], mB, i)), Ps = function(A) {
        return Ms.get(A);
    }, ks = function(A, e, t) {
        var n = t - 2, r = e[n], o = e[t - 1], t = e[t];
        if (2 === o && 3 === t) return "\xd7";
        if (2 !== o && 3 !== o && 4 !== o && 2 !== t && 3 !== t && 4 !== t) {
            if (o === Ts && -1 !== [
                Ts,
                Os,
                xs,
                Ds
            ].indexOf(t)) return "\xd7";
            if (!(o !== xs && o !== Os || t !== Os && 10 !== t)) return "\xd7";
            if ((o === Ds || 10 === o) && 10 === t) return "\xd7";
            if (13 === t || 5 === t) return "\xd7";
            if (7 === t) return "\xd7";
            if (1 === o) return "\xd7";
            if (13 === o && 14 === t) {
                for(; 5 === r;)r = e[--n];
                if (14 === r) return "\xd7";
            }
            if (15 === o && 15 === t) {
                for(var i = 0; 15 === r;)i++, r = e[--n];
                if (i % 2 == 0) return "\xd7";
            }
        }
        return "\xf7";
    }, H = {
        get SUPPORT_RANGE_BOUNDS () {
            var A1 = ((A)=>{
                if (A.createRange) {
                    var e = A.createRange();
                    if (e.getBoundingClientRect) {
                        var t = A.createElement("boundtest"), e = (t.style.height = "123px", t.style.display = "block", A.body.appendChild(t), e.selectNode(t), e.getBoundingClientRect()), e = Math.round(e.height);
                        if (A.body.removeChild(t), 123 === e) return !0;
                    }
                }
                return !1;
            })(document);
            return Object.defineProperty(H, "SUPPORT_RANGE_BOUNDS", {
                value: A1
            }), A1;
        },
        get SUPPORT_WORD_BREAKING () {
            var A2, n1, r1, e1, o1, i1, t1 = H.SUPPORT_RANGE_BOUNDS && (t1 = document, (A2 = t1.createElement("boundtest")).style.width = "50px", A2.style.display = "block", A2.style.fontSize = "12px", A2.style.letterSpacing = "0px", A2.style.wordSpacing = "0px", t1.body.appendChild(A2), n1 = t1.createRange(), A2.innerHTML = "function" == typeof "".repeat ? "&#128104;".repeat(10) : "", r1 = A2.firstChild, e1 = wn(r1.data).map(function(A) {
                return u(A);
            }), o1 = 0, i1 = {}, e1 = e1.every(function(A, e) {
                n1.setStart(r1, o1), n1.setEnd(r1, o1 + A.length);
                var t = n1.getBoundingClientRect(), A = (o1 += A.length, t.x > i1.x || t.y > i1.y);
                return i1 = t, 0 === e || A;
            }), t1.body.removeChild(A2), e1);
            return Object.defineProperty(H, "SUPPORT_WORD_BREAKING", {
                value: t1
            }), t1;
        },
        get SUPPORT_SVG_DRAWING () {
            var A3 = ((A)=>{
                var e = new Image, t = A.createElement("canvas"), n = t.getContext("2d");
                if (!n) return !1;
                e.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
                try {
                    n.drawImage(e, 0, 0), t.toDataURL();
                } catch (A) {
                    return !1;
                }
                return !0;
            })(document);
            return Object.defineProperty(H, "SUPPORT_SVG_DRAWING", {
                value: A3
            }), A3;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var A4 = "function" == typeof Array.from && "function" == typeof window.fetch ? ((t)=>{
                (e = t.createElement("canvas")).width = 100, e.height = 100;
                var n = e.getContext("2d");
                if (!n) return Promise.reject(!1);
                n.fillStyle = "rgb(0, 255, 0)", n.fillRect(0, 0, 100, 100);
                var A = new Image, r = e.toDataURL(), e = (A.src = r, ds(100, 100, 0, 0, A));
                return n.fillStyle = "red", n.fillRect(0, 0, 100, 100), hs(e).then(function(A) {
                    n.drawImage(A, 0, 0);
                    var A = n.getImageData(0, 0, 100, 100).data, e = (n.fillStyle = "red", n.fillRect(0, 0, 100, 100), t.createElement("div"));
                    return e.style.backgroundImage = "url(" + r + ")", e.style.height = "100px", ws(A) ? hs(ds(100, 100, 0, 0, e)) : Promise.reject(!1);
                }).then(function(A) {
                    return n.drawImage(A, 0, 0), ws(n.getImageData(0, 0, 100, 100).data);
                }).catch(function() {
                    return !1;
                });
            })(document) : Promise.resolve(!1);
            return Object.defineProperty(H, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: A4
            }), A4;
        },
        get SUPPORT_CORS_IMAGES () {
            var A5 = void 0 !== (new Image).crossOrigin;
            return Object.defineProperty(H, "SUPPORT_CORS_IMAGES", {
                value: A5
            }), A5;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var A6 = "string" == typeof (new XMLHttpRequest).responseType;
            return Object.defineProperty(H, "SUPPORT_RESPONSE_TYPE", {
                value: A6
            }), A6;
        },
        get SUPPORT_CORS_XHR () {
            var A7 = "withCredentials" in new XMLHttpRequest;
            return Object.defineProperty(H, "SUPPORT_CORS_XHR", {
                value: A7
            }), A7;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            var A8 = !("undefined" == typeof Intl || !Intl.Segmenter);
            return Object.defineProperty(H, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: A8
            }), A8;
        }
    }, Gs = function(A, e) {
        this.text = A, this.bounds = e;
    }, Ns = function(A, e) {
        var t = e.ownerDocument;
        if (t) {
            var t = t.createElement("html2canvaswrapper"), n = (t.appendChild(e.cloneNode(!0)), e.parentNode);
            if (n) return n.replaceChild(t, e), e = gn(A, t), t.firstChild && n.replaceChild(t.firstChild, t), e;
        }
        return un.EMPTY;
    }, Vs = function(A, e, t) {
        var n = A.ownerDocument;
        if (n) return (n = n.createRange()).setStart(A, e), n.setEnd(A, e + t), n;
        throw new Error("Node has no owner document");
    }, Xs = function(A) {
        var e;
        if (H.SUPPORT_NATIVE_TEXT_SEGMENTATION) return e = new Intl.Segmenter(void 0, {
            granularity: "grapheme"
        }), Array.from(e.segment(A)).map(function(A) {
            return A.segment;
        });
        for(var t, n = gs(A), r = []; !(t = n.next()).done;)t.value && r.push(t.value.slice());
        return r;
    }, Js = function(A, e) {
        var t;
        return 0 !== e.letterSpacing ? Xs(A) : (A, e, H.SUPPORT_NATIVE_TEXT_SEGMENTATION ? (t = new Intl.Segmenter(void 0, {
            granularity: "word"
        }), Array.from(t.segment(A)).map(function(A) {
            return A.segment;
        })) : _s(A, e));
    }, Ws = [
        32,
        160,
        4961,
        65792,
        65793,
        4153,
        4241
    ], _s = function(A, e) {
        e = {
            lineBreak: e.lineBreak,
            wordBreak: "break-word" === e.overflowWrap ? "break-word" : e.wordBreak
        }, n = wn(A), e = vr(n, e), r = e[0], o = e[1], i = e[2], s = n.length, c = a = 0;
        for(var t, n, r, o, i, s, a, c, B = {
            next: function() {
                if (s <= c) return {
                    done: !0,
                    value: null
                };
                for(var A, e = "\xd7"; c < s && "\xd7" === (e = Hr(n, o, r, ++c, i)););
                return "\xd7" !== e || c === s ? (A = new Ir(n, e, a, c), a = c, {
                    value: A,
                    done: !1
                }) : {
                    done: !0,
                    value: null
                };
            }
        }, l = []; !(t = B.next()).done;)(()=>{
            var A, e;
            t.value && (A = t.value.slice(), A = wn(A), e = "", A.forEach(function(A) {
                -1 === Ws.indexOf(A) ? e += u(A) : (e.length && l.push(e), l.push(u(A)), e = "");
            }), e.length) && l.push(e);
        })();
        return l;
    }, Ys = function(A, e, t) {
        var r, o, i, s, a;
        this.text = Zs(e.data, t.textTransform), this.textBounds = (r = A, A = this.text, i = e, A = Js(A, o = t), s = [], a = 0, A.forEach(function(A) {
            var e, t, n;
            o.textDecorationLine.length || 0 < A.trim().length ? H.SUPPORT_RANGE_BOUNDS ? 1 < (e = Vs(i, a, A.length).getClientRects()).length ? (n = Xs(A), t = 0, n.forEach(function(A) {
                s.push(new Gs(A, un.fromDOMRectList(r, Vs(i, t + a, A.length).getClientRects()))), t += A.length;
            })) : s.push(new Gs(A, un.fromDOMRectList(r, e))) : (n = i.splitText(A.length), s.push(new Gs(A, Ns(r, i))), i = n) : H.SUPPORT_RANGE_BOUNDS || (i = i.splitText(A.length)), a += A.length;
        }), s);
    }, Zs = function(A, e) {
        switch(e){
            case 1:
                return A.toLowerCase();
            case 3:
                return A.replace(qs, js);
            case 2:
                return A.toUpperCase();
            default:
                return A;
        }
    }, qs = /(^|\s|:|-|\(|\))([a-z])/g, js = function(A, e, t) {
        return 0 < A.length ? e + t.toUpperCase() : A;
    }, zs = (cn(Ya, Ss = rs), Ya), $s = (cn(_a, Ks = rs), _a), Aa = (cn(Wa, Ls = rs), Wa), ea = (cn(Ja, bs = rs), Ja), ta = (cn(Xa, Is = rs), Xa), na = [
        {
            type: 15,
            flags: 0,
            unit: "px",
            number: 3
        }
    ], ra = [
        {
            type: 16,
            flags: 0,
            number: 50
        }
    ], oa = (cn(Va, vs = rs), Va), ia = (cn(Na, Hs = rs), Na), sa = (cn(Ga, Es = rs), Ga), aa = (cn(ka, ys = rs), ka), ca = [
        "OL",
        "UL",
        "MENU"
    ], Ba = function(e, A, t, n) {
        for(var r, o, i = A.firstChild; i; i = r)r = i.nextSibling, da(i) && 0 < i.data.trim().length ? t.textNodes.push(new Ys(e, i, t.styles)) : ha(i) && (ba(i) && i.assignedNodes ? i.assignedNodes().forEach(function(A) {
            return Ba(e, A, t, n);
        }) : (o = la(e, i)).styles.isVisible() && (ga(i, o, n) ? o.flags |= 4 : wa(o.styles) && (o.flags |= 2), -1 !== ca.indexOf(i.tagName) && (o.flags |= 8), t.elements.push(o), i.slot, i.shadowRoot ? Ba(e, i.shadowRoot, o, n) : va(i) || Fa(i) || Ia(i) || Ba(e, i, o, n)));
    }, la = function(A, e) {
        return new (Ea(e) ? zs : ya(e) ? $s : Fa(e) ? Aa : pa(e) ? ea : Ca(e) ? ta : Ua(e) ? oa : Ia(e) ? ia : va(e) ? sa : Ha(e) ? aa : rs)(A, e);
    }, ua = function(A, e) {
        var t = la(A, e);
        return t.flags |= 4, Ba(A, e, t, t), t;
    }, ga = function(A, e, t) {
        return e.styles.isPositionedWithZIndex() || e.styles.opacity < 1 || e.styles.isTransformed() || ma(A) && t.styles.isTransparent();
    }, wa = function(A) {
        return A.isPositioned() || A.isFloating();
    }, da = function(A) {
        return A.nodeType === Node.TEXT_NODE;
    }, ha = function(A) {
        return A.nodeType === Node.ELEMENT_NODE;
    }, fa = function(A) {
        return ha(A) && void 0 !== A.style && !Qa(A);
    }, Qa = function(A) {
        return "object" == typeof A.className;
    }, pa = function(A) {
        return "LI" === A.tagName;
    }, Ca = function(A) {
        return "OL" === A.tagName;
    }, Ua = function(A) {
        return "INPUT" === A.tagName;
    }, Fa = function(A) {
        return "svg" === A.tagName;
    }, ma = function(A) {
        return "BODY" === A.tagName;
    }, ya = function(A) {
        return "CANVAS" === A.tagName;
    }, Ea = function(A) {
        return "IMG" === A.tagName;
    }, Ha = function(A) {
        return "IFRAME" === A.tagName;
    }, va = function(A) {
        return "TEXTAREA" === A.tagName;
    }, Ia = function(A) {
        return "SELECT" === A.tagName;
    }, ba = function(A) {
        return "SLOT" === A.tagName;
    }, La = (Pa.prototype.getCounterValue = function(A) {
        A = this.counters[A];
        return A && A.length ? A[A.length - 1] : 1;
    }, Pa.prototype.getCounterValues = function(A) {
        return this.counters[A] || [];
    }, Pa.prototype.pop = function(A) {
        var e = this;
        A.forEach(function(A) {
            return e.counters[A].pop();
        });
    }, Pa.prototype.parse = function(A) {
        var t = this, e = A.counterIncrement, A = A.counterReset, n = !0, r = (null !== e && e.forEach(function(A) {
            var e = t.counters[A.counter];
            e && 0 !== A.increment && (n = !1, e.length || e.push(1), e[Math.max(0, e.length - 1)] += A.increment);
        }), []);
        return n && A.forEach(function(A) {
            var e = t.counters[A.counter];
            r.push(A.counter), (e = e || (t.counters[A.counter] = [])).push(A.reset);
        }), r;
    }, Pa), Ka = {
        integers: [
            1e3,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    }, Sa = {
        integers: [
            9e3,
            8e3,
            7e3,
            6e3,
            5e3,
            4e3,
            3e3,
            2e3,
            1e3,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    }, Ta = {
        integers: [
            1e4,
            9e3,
            8e3,
            7e3,
            6e3,
            5e3,
            4e3,
            3e3,
            2e3,
            1e3,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    }, Oa = {
        integers: [
            1e4,
            9e3,
            8e3,
            7e3,
            6e3,
            5e3,
            4e3,
            3e3,
            2e3,
            1e3,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    }, xa = function(A, e, t, n) {
        for(var r = ""; t || A--, r = n(A) + r, e <= (A /= e) * e;);
        return r;
    }, Da = function(A, e, t) {
        var n = t ? ". " : "", r = t ? "\u3001" : "", o = t ? ", " : "", i = t ? " " : "";
        switch(e){
            case 0:
                return "\u2022" + i;
            case 1:
                return "\u25E6" + i;
            case 2:
                return "\u25FE" + i;
            case 5:
                var s = E(A, 48, 57, !0, n);
                return s.length < 4 ? "0" + s : s;
            case 4:
                return Us(A, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", r);
            case 6:
                return Cs(A, 1, 3999, Ka, 3, n).toLowerCase();
            case 7:
                return Cs(A, 1, 3999, Ka, 3, n);
            case 8:
                return E(A, 945, 969, !1, n);
            case 9:
                return E(A, 97, 122, !1, n);
            case 10:
                return E(A, 65, 90, !1, n);
            case 11:
                return E(A, 1632, 1641, !0, n);
            case 12:
            case 49:
                return Cs(A, 1, 9999, Sa, 3, n);
            case 35:
                return Cs(A, 1, 9999, Sa, 3, n).toLowerCase();
            case 13:
                return E(A, 2534, 2543, !0, n);
            case 14:
            case 30:
                return E(A, 6112, 6121, !0, n);
            case 15:
                return Us(A, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", r);
            case 16:
                return Us(A, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", r);
            case 17:
            case 48:
                return Fs(A, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", "\u8CA0", r, 14);
            case 47:
                return Fs(A, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", "\u62FE\u4F70\u4EDF\u842C", "\u8CA0", r, 15);
            case 42:
                return Fs(A, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", "\u8D1F", r, 14);
            case 41:
                return Fs(A, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", "\u62FE\u4F70\u4EDF\u842C", "\u8D1F", r, 15);
            case 26:
                return Fs(A, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", "\u30DE\u30A4\u30CA\u30B9", r, 0);
            case 25:
                return Fs(A, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", "\u30DE\u30A4\u30CA\u30B9", r, 7);
            case 31:
                return Fs(A, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", "\uB9C8\uC774\uB108\uC2A4", o, 7);
            case 33:
                return Fs(A, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", "\uB9C8\uC774\uB108\uC2A4", o, 0);
            case 32:
                return Fs(A, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", "\uB9C8\uC774\uB108\uC2A4", o, 7);
            case 18:
                return E(A, 2406, 2415, !0, n);
            case 20:
                return Cs(A, 1, 19999, Oa, 3, n);
            case 21:
                return E(A, 2790, 2799, !0, n);
            case 22:
                return E(A, 2662, 2671, !0, n);
            case 22:
                return Cs(A, 1, 10999, Ta, 3, n);
            case 23:
                return Us(A, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24:
                return Us(A, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27:
                return E(A, 3302, 3311, !0, n);
            case 28:
                return Us(A, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", r);
            case 29:
                return Us(A, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", r);
            case 34:
                return E(A, 3792, 3801, !0, n);
            case 37:
                return E(A, 6160, 6169, !0, n);
            case 38:
                return E(A, 4160, 4169, !0, n);
            case 39:
                return E(A, 2918, 2927, !0, n);
            case 40:
                return E(A, 1776, 1785, !0, n);
            case 43:
                return E(A, 3046, 3055, !0, n);
            case 44:
                return E(A, 3174, 3183, !0, n);
            case 45:
                return E(A, 3664, 3673, !0, n);
            case 46:
                return E(A, 3872, 3881, !0, n);
            default:
                return E(A, 48, 57, !0, n);
        }
    }, Ra = (Ma.prototype.toIFrame = function(A, n) {
        var e, r, o, t, i = this, s = za(A, n);
        return s.contentWindow ? (e = A.defaultView.pageXOffset, A = A.defaultView.pageYOffset, o = (r = s.contentWindow).document, t = Ac(s).then(function() {
            return l(i, void 0, void 0, function() {
                var e, t;
                return S(this, function(A) {
                    switch(A.label){
                        case 0:
                            return this.scrolledElements.forEach(oc), r && (r.scrollTo(n.left, n.top), !/(iPad|iPhone|iPod)/g.test(navigator.userAgent) || r.scrollY === n.top && r.scrollX === n.left || (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(r.scrollX - n.left, r.scrollY - n.top, 0, 0))), e = this.options.onclone, void 0 === (t = this.clonedReferenceElement) ? [
                                2,
                                Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                            ] : o.fonts && o.fonts.ready ? [
                                4,
                                o.fonts.ready
                            ] : [
                                3,
                                2
                            ];
                        case 1:
                            A.sent(), A.label = 2;
                        case 2:
                            return /(AppleWebKit)/g.test(navigator.userAgent) ? [
                                4,
                                $a(o)
                            ] : [
                                3,
                                4
                            ];
                        case 3:
                            A.sent(), A.label = 4;
                        case 4:
                            return "function" == typeof e ? [
                                2,
                                Promise.resolve().then(function() {
                                    return e(o, t);
                                }).then(function() {
                                    return s;
                                })
                            ] : [
                                2,
                                s
                            ];
                    }
                });
            });
        }), o.open(), o.write(nc(document.doctype) + "<html></html>"), rc(this.referenceElement.ownerDocument, e, A), o.replaceChild(o.adoptNode(this.documentElement), o.documentElement), o.close(), t) : Promise.reject("Unable to find iframe window");
    }, Ma.prototype.createElementClone = function(A) {
        var e;
        return ns(A, 2), ya(A) ? this.createCanvasClone(A) : fs(A) ? this.createVideoClone(A) : Qs(A) ? this.createStyleClone(A) : (e = A.cloneNode(!1), Ea(e) && (Ea(A) && A.currentSrc && A.currentSrc !== A.src && (e.src = A.currentSrc, e.srcset = ""), "lazy" === e.loading) && (e.loading = "eager"), ps(e) ? this.createCustomElementClone(e) : e);
    }, Ma.prototype.createCustomElementClone = function(A) {
        var e = document.createElement("html2canvascustomelement");
        return tc(A.style, e), e;
    }, Ma.prototype.createStyleClone = function(A) {
        try {
            var e, t, n = A.sheet;
            if (n && n.cssRules) return e = [].slice.call(n.cssRules, 0).reduce(function(A, e) {
                return e && "string" == typeof e.cssText ? A + e.cssText : A;
            }, ""), (t = A.cloneNode(!1)).textContent = e, t;
        } catch (A) {
            if (this.context.logger.error("Unable to access cssRules property", A), "SecurityError" !== A.name) throw A;
        }
        return A.cloneNode(!1);
    }, Ma.prototype.createCanvasClone = function(A) {
        var e;
        if (this.options.inlineImages && A.ownerDocument) {
            var t = A.ownerDocument.createElement("img");
            try {
                return t.src = A.toDataURL(), t;
            } catch (e) {
                this.context.logger.info("Unable to inline canvas contents, canvas is tainted", A);
            }
        }
        t = A.cloneNode(!1);
        try {
            t.width = A.width, t.height = A.height;
            var n, r, o = A.getContext("2d"), i = t.getContext("2d");
            i && (!this.options.allowTaint && o ? i.putImageData(o.getImageData(0, 0, A.width, A.height), 0, 0) : ((n = null != (e = A.getContext("webgl2")) ? e : A.getContext("webgl")) && !1 === (null == (r = n.getContextAttributes()) ? void 0 : r.preserveDrawingBuffer) && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", A), i.drawImage(A, 0, 0)));
        } catch (e) {
            this.context.logger.info("Unable to clone canvas as it is tainted", A);
        }
        return t;
    }, Ma.prototype.createVideoClone = function(A) {
        var e = A.ownerDocument.createElement("canvas"), t = (e.width = A.offsetWidth, e.height = A.offsetHeight, e.getContext("2d"));
        try {
            return t && (t.drawImage(A, 0, 0, e.width, e.height), this.options.allowTaint || t.getImageData(0, 0, e.width, e.height)), e;
        } catch (e) {
            this.context.logger.info("Unable to clone video as it is tainted", A);
        }
        t = A.ownerDocument.createElement("canvas");
        return t.width = A.offsetWidth, t.height = A.offsetHeight, t;
    }, Ma.prototype.appendChildNode = function(A, e, t) {
        ha(e) && ("SCRIPT" === e.tagName || e.hasAttribute("data-html2canvas-ignore") || "function" == typeof this.options.ignoreElements && this.options.ignoreElements(e)) || this.options.copyStyles && ha(e) && Qs(e) || A.appendChild(this.cloneNode(e, t));
    }, Ma.prototype.cloneChildNodes = function(A, e, t) {
        for(var n, r = this, o = (A.shadowRoot || A).firstChild; o; o = o.nextSibling)ha(o) && ba(o) && "function" == typeof o.assignedNodes ? (n = o.assignedNodes()).length && n.forEach(function(A) {
            return r.appendChildNode(e, A, t);
        }) : this.appendChildNode(e, o, t);
    }, Ma.prototype.cloneNode = function(A, e) {
        var t, n, r, o, i;
        return da(A) ? document.createTextNode(A.data) : A.ownerDocument && (r = A.ownerDocument.defaultView) && ha(A) && (fa(A) || Qa(A)) ? ((t = this.createElementClone(A)).style.transitionProperty = "none", n = r.getComputedStyle(A), i = r.getComputedStyle(A, ":before"), r = r.getComputedStyle(A, ":after"), this.referenceElement === A && fa(t) && (this.clonedReferenceElement = t), ma(t) && ac(t), o = this.counters.parse(new ts(this.context, n)), i = this.resolvePseudoContent(A, t, i, ms.BEFORE), ps(A) && (e = !0), fs(A) || this.cloneChildNodes(A, t, e), i && t.insertBefore(i, t.firstChild), (i = this.resolvePseudoContent(A, t, r, ms.AFTER)) && t.appendChild(i), this.counters.pop(o), (n && (this.options.copyStyles || Qa(A)) && !Ha(A) || e) && tc(n, t), 0 === A.scrollTop && 0 === A.scrollLeft || this.scrolledElements.push([
            t,
            A.scrollLeft,
            A.scrollTop
        ]), (va(A) || Ia(A)) && (va(t) || Ia(t)) && (t.value = A.value), t) : A.cloneNode(!1);
    }, Ma.prototype.resolvePseudoContent = function(i, A, e, t) {
        var s = this;
        if (e) {
            var a, c, n = e.content, B = A.ownerDocument;
            if (B && n && "none" !== n && "-moz-alt-content" !== n && "none" !== e.display) return this.counters.parse(new ts(this.context, e)), a = new es(this.context, e), c = B.createElement("html2canvaspseudoelement"), tc(e, c), a.content.forEach(function(A) {
                if (0 === A.type) c.appendChild(B.createTextNode(A.value));
                else if (22 === A.type) {
                    var e = B.createElement("img");
                    e.src = A.value, e.style.opacity = "1", c.appendChild(e);
                } else if (18 === A.type) {
                    var t, n, r, o;
                    "attr" === A.name ? (e = A.values.filter(f)).length && c.appendChild(B.createTextNode(i.getAttribute(e[0].value) || "")) : "counter" === A.name ? (r = (e = A.values.filter(Rn))[0], o = e[1], r && f(r) && (e = s.counters.getCounterValue(r.value), t = o && f(o) ? gi.parse(s.context, o.value) : 3, c.appendChild(B.createTextNode(Da(e, t, !1))))) : "counters" === A.name && (r = (e = A.values.filter(Rn))[0], t = e[1], o = e[2], r) && f(r) && (e = s.counters.getCounterValues(r.value), n = o && f(o) ? gi.parse(s.context, o.value) : 3, r = t && 0 === t.type ? t.value : "", o = e.map(function(A) {
                        return Da(A, n, !1);
                    }).join(r), c.appendChild(B.createTextNode(o)));
                } else if (20 === A.type) switch(A.value){
                    case "open-quote":
                        c.appendChild(B.createTextNode(Zi(a.quotes, s.quoteDepth++, !0)));
                        break;
                    case "close-quote":
                        c.appendChild(B.createTextNode(Zi(a.quotes, --s.quoteDepth, !1)));
                        break;
                    default:
                        c.appendChild(B.createTextNode(A.value));
                }
            }), c.className = ic + " " + sc, n = t === ms.BEFORE ? " " + ic : " " + sc, Qa(A) ? A.className.baseValue += n : A.className += n, c;
        }
    }, Ma.destroy = function(A) {
        return !!A.parentNode && (A.parentNode.removeChild(A), !0);
    }, Ma);
    function Ma(A, e, t) {
        if (this.context = A, this.options = t, this.scrolledElements = [], this.referenceElement = e, this.counters = new La, this.quoteDepth = 0, !e.ownerDocument) throw new Error("Cloned element does not have an owner document");
        this.documentElement = this.cloneNode(e.ownerDocument.documentElement, !1);
    }
    function Pa() {
        this.counters = {};
    }
    function ka(A, e) {
        var t, n, r = ys.call(this, A, e) || this;
        r.src = e.src, r.width = parseInt(e.width, 10) || 0, r.height = parseInt(e.height, 10) || 0, r.backgroundColor = r.styles.backgroundColor;
        try {
            e.contentWindow && e.contentWindow.document && e.contentWindow.document.documentElement && (r.tree = ua(A, e.contentWindow.document.documentElement), t = e.contentWindow.document.documentElement ? po(A, getComputedStyle(e.contentWindow.document.documentElement).backgroundColor) : Co.TRANSPARENT, n = e.contentWindow.document.body ? po(A, getComputedStyle(e.contentWindow.document.body).backgroundColor) : Co.TRANSPARENT, r.backgroundColor = oo(t) ? oo(n) ? r.styles.backgroundColor : n : t);
        } catch (A) {}
        return r;
    }
    function Ga(A, e) {
        A = Es.call(this, A, e) || this;
        return A.value = e.value, A;
    }
    function Na(A, e) {
        A = Hs.call(this, A, e) || this, e = e.options[e.selectedIndex || 0];
        return A.value = e && e.text || "", A;
    }
    function Va(A, e) {
        var t = vs.call(this, A, e) || this;
        switch(t.type = e.type.toLowerCase(), t.checked = e.checked, t.value = 0 === (e = "password" === (A = e).type ? new Array(A.value.length + 1).join("\u2022") : A.value).length ? A.placeholder || "" : e, "checkbox" !== t.type && "radio" !== t.type || (t.styles.backgroundColor = 3739148031, t.styles.borderTopColor = t.styles.borderRightColor = t.styles.borderBottomColor = t.styles.borderLeftColor = 2779096575, t.styles.borderTopWidth = t.styles.borderRightWidth = t.styles.borderBottomWidth = t.styles.borderLeftWidth = 1, t.styles.borderTopStyle = t.styles.borderRightStyle = t.styles.borderBottomStyle = t.styles.borderLeftStyle = 1, t.styles.backgroundClip = [
            0
        ], t.styles.backgroundOrigin = [
            0
        ], t.bounds = (A = t.bounds).width > A.height ? new un(A.left + (A.width - A.height) / 2, A.top, A.height, A.height) : A.width < A.height ? new un(A.left, A.top + (A.height - A.width) / 2, A.width, A.width) : A), t.type){
            case "checkbox":
                t.styles.borderTopRightRadius = t.styles.borderTopLeftRadius = t.styles.borderBottomRightRadius = t.styles.borderBottomLeftRadius = na;
                break;
            case "radio":
                t.styles.borderTopRightRadius = t.styles.borderTopLeftRadius = t.styles.borderBottomRightRadius = t.styles.borderBottomLeftRadius = ra;
        }
        return t;
    }
    function Xa(A, e) {
        A = Is.call(this, A, e) || this;
        return A.start = e.start, A.reversed = "boolean" == typeof e.reversed && !0 === e.reversed, A;
    }
    function Ja(A, e) {
        A = bs.call(this, A, e) || this;
        return A.value = e.value, A;
    }
    function Wa(A, e) {
        var t = Ls.call(this, A, e) || this, n = new XMLSerializer, A = gn(A, e);
        return e.setAttribute("width", A.width + "px"), e.setAttribute("height", A.height + "px"), t.svg = "data:image/svg+xml," + encodeURIComponent(n.serializeToString(e)), t.intrinsicWidth = e.width.baseVal.value, t.intrinsicHeight = e.height.baseVal.value, t.context.cache.addImage(t.svg), t;
    }
    function _a(A, e) {
        A = Ks.call(this, A, e) || this;
        return A.canvas = e, A.intrinsicWidth = e.width, A.intrinsicHeight = e.height, A;
    }
    function Ya(A, e) {
        A = Ss.call(this, A, e) || this;
        return A.src = e.currentSrc || e.src, A.intrinsicWidth = e.naturalWidth, A.intrinsicHeight = e.naturalHeight, A.context.cache.addImage(A.src), A;
    }
    (y = ms = ms || {})[y.BEFORE = 0] = "BEFORE", y[y.AFTER = 1] = "AFTER";
    function Za(e) {
        return new Promise(function(A) {
            !e.complete && e.src ? (e.onload = A, e.onerror = A) : A();
        });
    }
    function qa(A, e, t) {
        return new I(A.x + (e.x - A.x) * t, A.y + (e.y - A.y) * t);
    }
    function ja(A) {
        var e = A.styles, t = A.bounds, n = (r = no(e.borderTopLeftRadius, t.width, t.height))[0], r = r[1], o = (i = no(e.borderTopRightRadius, t.width, t.height))[0], i = i[1], s = (a = no(e.borderBottomRightRadius, t.width, t.height))[0], a = a[1], c = (B = no(e.borderBottomLeftRadius, t.width, t.height))[0], B = B[1];
        (l = []).push((n + o) / t.width), l.push((c + s) / t.width), l.push((r + B) / t.height), l.push((i + a) / t.height);
        1 < (l = Math.max.apply(Math, l)) && (n /= l, r /= l, o /= l, i /= l, s /= l, a /= l, c /= l, B /= l);
        var l = t.width - o, u = t.height - a, g = t.width - s, w = t.height - B, d = e.borderTopWidth, h = e.borderRightWidth, f = e.borderBottomWidth, Q = e.borderLeftWidth, p = O(e.paddingTop, A.bounds.width), C = O(e.paddingRight, A.bounds.width), U = O(e.paddingBottom, A.bounds.width), e = O(e.paddingLeft, A.bounds.width);
        this.topLeftBorderDoubleOuterBox = 0 < n || 0 < r ? b(t.left + Q / 3, t.top + d / 3, n - Q / 3, r - d / 3, v.TOP_LEFT) : new I(t.left + Q / 3, t.top + d / 3), this.topRightBorderDoubleOuterBox = 0 < n || 0 < r ? b(t.left + l, t.top + d / 3, o - h / 3, i - d / 3, v.TOP_RIGHT) : new I(t.left + t.width - h / 3, t.top + d / 3), this.bottomRightBorderDoubleOuterBox = 0 < s || 0 < a ? b(t.left + g, t.top + u, s - h / 3, a - f / 3, v.BOTTOM_RIGHT) : new I(t.left + t.width - h / 3, t.top + t.height - f / 3), this.bottomLeftBorderDoubleOuterBox = 0 < c || 0 < B ? b(t.left + Q / 3, t.top + w, c - Q / 3, B - f / 3, v.BOTTOM_LEFT) : new I(t.left + Q / 3, t.top + t.height - f / 3), this.topLeftBorderDoubleInnerBox = 0 < n || 0 < r ? b(t.left + 2 * Q / 3, t.top + 2 * d / 3, n - 2 * Q / 3, r - 2 * d / 3, v.TOP_LEFT) : new I(t.left + 2 * Q / 3, t.top + 2 * d / 3), this.topRightBorderDoubleInnerBox = 0 < n || 0 < r ? b(t.left + l, t.top + 2 * d / 3, o - 2 * h / 3, i - 2 * d / 3, v.TOP_RIGHT) : new I(t.left + t.width - 2 * h / 3, t.top + 2 * d / 3), this.bottomRightBorderDoubleInnerBox = 0 < s || 0 < a ? b(t.left + g, t.top + u, s - 2 * h / 3, a - 2 * f / 3, v.BOTTOM_RIGHT) : new I(t.left + t.width - 2 * h / 3, t.top + t.height - 2 * f / 3), this.bottomLeftBorderDoubleInnerBox = 0 < c || 0 < B ? b(t.left + 2 * Q / 3, t.top + w, c - 2 * Q / 3, B - 2 * f / 3, v.BOTTOM_LEFT) : new I(t.left + 2 * Q / 3, t.top + t.height - 2 * f / 3), this.topLeftBorderStroke = 0 < n || 0 < r ? b(t.left + Q / 2, t.top + d / 2, n - Q / 2, r - d / 2, v.TOP_LEFT) : new I(t.left + Q / 2, t.top + d / 2), this.topRightBorderStroke = 0 < n || 0 < r ? b(t.left + l, t.top + d / 2, o - h / 2, i - d / 2, v.TOP_RIGHT) : new I(t.left + t.width - h / 2, t.top + d / 2), this.bottomRightBorderStroke = 0 < s || 0 < a ? b(t.left + g, t.top + u, s - h / 2, a - f / 2, v.BOTTOM_RIGHT) : new I(t.left + t.width - h / 2, t.top + t.height - f / 2), this.bottomLeftBorderStroke = 0 < c || 0 < B ? b(t.left + Q / 2, t.top + w, c - Q / 2, B - f / 2, v.BOTTOM_LEFT) : new I(t.left + Q / 2, t.top + t.height - f / 2), this.topLeftBorderBox = 0 < n || 0 < r ? b(t.left, t.top, n, r, v.TOP_LEFT) : new I(t.left, t.top), this.topRightBorderBox = 0 < o || 0 < i ? b(t.left + l, t.top, o, i, v.TOP_RIGHT) : new I(t.left + t.width, t.top), this.bottomRightBorderBox = 0 < s || 0 < a ? b(t.left + g, t.top + u, s, a, v.BOTTOM_RIGHT) : new I(t.left + t.width, t.top + t.height), this.bottomLeftBorderBox = 0 < c || 0 < B ? b(t.left, t.top + w, c, B, v.BOTTOM_LEFT) : new I(t.left, t.top + t.height), this.topLeftPaddingBox = 0 < n || 0 < r ? b(t.left + Q, t.top + d, Math.max(0, n - Q), Math.max(0, r - d), v.TOP_LEFT) : new I(t.left + Q, t.top + d), this.topRightPaddingBox = 0 < o || 0 < i ? b(t.left + Math.min(l, t.width - h), t.top + d, l > t.width + h ? 0 : Math.max(0, o - h), Math.max(0, i - d), v.TOP_RIGHT) : new I(t.left + t.width - h, t.top + d), this.bottomRightPaddingBox = 0 < s || 0 < a ? b(t.left + Math.min(g, t.width - Q), t.top + Math.min(u, t.height - f), Math.max(0, s - h), Math.max(0, a - f), v.BOTTOM_RIGHT) : new I(t.left + t.width - h, t.top + t.height - f), this.bottomLeftPaddingBox = 0 < c || 0 < B ? b(t.left + Q, t.top + Math.min(w, t.height - f), Math.max(0, c - Q), Math.max(0, B - f), v.BOTTOM_LEFT) : new I(t.left + Q, t.top + t.height - f), this.topLeftContentBox = 0 < n || 0 < r ? b(t.left + Q + e, t.top + d + p, Math.max(0, n - (Q + e)), Math.max(0, r - (d + p)), v.TOP_LEFT) : new I(t.left + Q + e, t.top + d + p), this.topRightContentBox = 0 < o || 0 < i ? b(t.left + Math.min(l, t.width + Q + e), t.top + d + p, l > t.width + Q + e ? 0 : o - Q + e, i - (d + p), v.TOP_RIGHT) : new I(t.left + t.width - (h + C), t.top + d + p), this.bottomRightContentBox = 0 < s || 0 < a ? b(t.left + Math.min(g, t.width - (Q + e)), t.top + Math.min(u, t.height + d + p), Math.max(0, s - (h + C)), a - (f + U), v.BOTTOM_RIGHT) : new I(t.left + t.width - (h + C), t.top + t.height - (f + U)), this.bottomLeftContentBox = 0 < c || 0 < B ? b(t.left + Q + e, t.top + w, Math.max(0, c - (Q + e)), B - (f + U), v.BOTTOM_LEFT) : new I(t.left + Q + e, t.top + t.height - (f + U));
    }
    var v, za = function(A, e) {
        var t = A.createElement("iframe");
        return t.className = "html2canvas-container", t.style.visibility = "hidden", t.style.position = "fixed", t.style.left = "-10000px", t.style.top = "0px", t.style.border = "0", t.width = e.width.toString(), t.height = e.height.toString(), t.scrolling = "no", t.setAttribute("data-html2canvas-ignore", "true"), A.body.appendChild(t), t;
    }, $a = function(A) {
        return Promise.all([].slice.call(A.images, 0).map(Za));
    }, Ac = function(r) {
        return new Promise(function(e, A) {
            var t = r.contentWindow;
            if (!t) return A("No window assigned for iframe");
            var n = t.document;
            t.onload = r.onload = function() {
                t.onload = r.onload = null;
                var A = setInterval(function() {
                    0 < n.body.childNodes.length && "complete" === n.readyState && (clearInterval(A), e(r));
                }, 50);
            };
        });
    }, ec = [
        "all",
        "d",
        "content"
    ], tc = function(A, e) {
        for(var t = A.length - 1; 0 <= t; t--){
            var n = A.item(t);
            -1 === ec.indexOf(n) && e.style.setProperty(n, A.getPropertyValue(n));
        }
        return e;
    }, nc = function(A) {
        var e = "";
        return A && (e += "<!DOCTYPE ", A.name && (e += A.name), A.internalSubset && (e += A.internalSubset), A.publicId && (e += '"' + A.publicId + '"'), A.systemId && (e += '"' + A.systemId + '"'), e += ">"), e;
    }, rc = function(A, e, t) {
        A && A.defaultView && (e !== A.defaultView.pageXOffset || t !== A.defaultView.pageYOffset) && A.defaultView.scrollTo(e, t);
    }, oc = function(A) {
        var e = A[0], t = A[2];
        e.scrollLeft = A[1], e.scrollTop = t;
    }, ic = "___html2canvas___pseudoelement_before", sc = "___html2canvas___pseudoelement_after", ac = function(A) {
        cc(A, "." + ic + ':before{\n    content: "" !important;\n    display: none !important;\n}\n         .' + sc + ':after{\n    content: "" !important;\n    display: none !important;\n}');
    }, cc = function(A, e) {
        var t = A.ownerDocument;
        t && ((t = t.createElement("style")).textContent = e, A.appendChild(t));
    }, Bc = (Ec.getOrigin = function(A) {
        var e = Ec._link;
        return e ? (e.href = A, e.href = e.href, e.protocol + e.hostname + e.port) : "about:blank";
    }, Ec.isSameOrigin = function(A) {
        return Ec.getOrigin(A) === Ec._origin;
    }, Ec.setContext = function(A) {
        Ec._link = A.document.createElement("a"), Ec._origin = Ec.getOrigin(A.location.href);
    }, Ec._origin = "about:blank", Ec), lc = (yc.prototype.addImage = function(A) {
        var e = Promise.resolve();
        return this.has(A) || (Qc(A) || dc(A)) && (this._cache[A] = this.loadImage(A)).catch(function() {}), e;
    }, yc.prototype.match = function(A) {
        return this._cache[A];
    }, yc.prototype.loadImage = function(i) {
        return l(this, void 0, void 0, function() {
            var e, n, t, r, o = this;
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        return e = Bc.isSameOrigin(i), n = !hc(i) && !0 === this._options.useCORS && H.SUPPORT_CORS_IMAGES && !e, t = !hc(i) && !e && !Qc(i) && "string" == typeof this._options.proxy && H.SUPPORT_CORS_XHR && !n, e || !1 !== this._options.allowTaint || hc(i) || Qc(i) || t || n ? (r = i, t ? [
                            4,
                            this.proxy(r)
                        ] : [
                            3,
                            2
                        ]) : [
                            2
                        ];
                    case 1:
                        r = A.sent(), A.label = 2;
                    case 2:
                        return this.context.logger.debug("Added image " + i.substring(0, 256)), [
                            4,
                            new Promise(function(A, e) {
                                var t = new Image;
                                t.onload = function() {
                                    return A(t);
                                }, t.onerror = e, (fc(r) || n) && (t.crossOrigin = "anonymous"), t.src = r, !0 === t.complete && setTimeout(function() {
                                    return A(t);
                                }, 500), 0 < o._options.imageTimeout && setTimeout(function() {
                                    return e("Timed out (" + o._options.imageTimeout + "ms) loading image");
                                }, o._options.imageTimeout);
                            })
                        ];
                    case 3:
                        return [
                            2,
                            A.sent()
                        ];
                }
            });
        });
    }, yc.prototype.has = function(A) {
        return void 0 !== this._cache[A];
    }, yc.prototype.keys = function() {
        return Promise.resolve(Object.keys(this._cache));
    }, yc.prototype.proxy = function(i) {
        var s, a = this, c = this._options.proxy;
        if (c) return s = i.substring(0, 256), new Promise(function(e, t) {
            var A, n = H.SUPPORT_RESPONSE_TYPE ? "blob" : "text", r = new XMLHttpRequest, o = (r.onload = function() {
                var A;
                200 === r.status ? "text" == n ? e(r.response) : ((A = new FileReader).addEventListener("load", function() {
                    return e(A.result);
                }, !1), A.addEventListener("error", function(A) {
                    return t(A);
                }, !1), A.readAsDataURL(r.response)) : t("Failed to proxy resource " + s + " with status code " + r.status);
            }, r.onerror = t, -1 < c.indexOf("?") ? "&" : "?");
            r.open("GET", c + o + "url=" + encodeURIComponent(i) + "&responseType=" + n), "text" != n && r instanceof XMLHttpRequest && (r.responseType = n), a._options.imageTimeout && (A = a._options.imageTimeout, r.timeout = A, r.ontimeout = function() {
                return t("Timed out (" + A + "ms) proxying " + s);
            }), r.send();
        });
        throw new Error("No proxy defined");
    }, yc), uc = /^data:image\/svg\+xml/i, gc = /^data:image\/.*;base64,/i, wc = /^data:image\/.*/i, dc = function(A) {
        return H.SUPPORT_SVG_DRAWING || !pc(A);
    }, hc = function(A) {
        return wc.test(A);
    }, fc = function(A) {
        return gc.test(A);
    }, Qc = function(A) {
        return "blob" === A.substr(0, 4);
    }, pc = function(A) {
        return "svg" === A.substr(-3).toLowerCase() || uc.test(A);
    }, I = (mc.prototype.add = function(A, e) {
        return new mc(this.x + A, this.y + e);
    }, mc), Cc = (Fc.prototype.subdivide = function(A, e) {
        var t = qa(this.start, this.startControl, A), n = qa(this.startControl, this.endControl, A), r = qa(this.endControl, this.end, A), o = qa(t, n, A), n = qa(n, r, A), A = qa(o, n, A);
        return e ? new Fc(this.start, t, o, A) : new Fc(A, n, r, this.end);
    }, Fc.prototype.add = function(A, e) {
        return new Fc(this.start.add(A, e), this.startControl.add(A, e), this.endControl.add(A, e), this.end.add(A, e));
    }, Fc.prototype.reverse = function() {
        return new Fc(this.end, this.endControl, this.startControl, this.start);
    }, Fc), Uc = function(A) {
        return 1 === A.type;
    };
    function Fc(A, e, t, n) {
        this.type = 1, this.start = A, this.startControl = e, this.endControl = t, this.end = n;
    }
    function mc(A, e) {
        this.type = 0, this.x = A, this.y = e;
    }
    function yc(A, e) {
        this.context = A, this._options = e, this._cache = {};
    }
    function Ec() {}
    (r = v = v || {})[r.TOP_LEFT = 0] = "TOP_LEFT", r[r.TOP_RIGHT = 1] = "TOP_RIGHT", r[r.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", r[r.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
    function Hc(A) {
        return [
            A.topLeftBorderBox,
            A.topRightBorderBox,
            A.bottomRightBorderBox,
            A.bottomLeftBorderBox
        ];
    }
    function vc(A) {
        return [
            A.topLeftPaddingBox,
            A.topRightPaddingBox,
            A.bottomRightPaddingBox,
            A.bottomLeftPaddingBox
        ];
    }
    function Ic(A, e, t) {
        this.offsetX = A, this.offsetY = e, this.matrix = t, this.type = 0, this.target = 6;
    }
    function bc(A, e) {
        this.path = A, this.target = e, this.type = 1;
    }
    function Lc(A) {
        this.opacity = A, this.type = 2, this.target = 6;
    }
    function Kc(A) {
        return 1 === A.type;
    }
    function Sc(A, t) {
        return A.length === t.length && A.some(function(A, e) {
            return A === t[e];
        });
    }
    function Tc(A) {
        this.element = A, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
    }
    function Oc(c, B, l, u) {
        c.container.elements.forEach(function(A) {
            var e, t, n, r, o = U(A.flags, 4), i = U(A.flags, 2), s = new Vc(A, c), a = (U(A.styles.display, 2048) && u.push(s), U(A.flags, 8) ? [] : u);
            o || i ? (i = o || A.styles.isPositioned() ? l : B, e = new Tc(s), A.styles.isPositioned() || A.styles.opacity < 1 || A.styles.isTransformed() ? (t = A.styles.zIndex.order) < 0 ? (n = 0, i.negativeZIndex.some(function(A, e) {
                return t > A.element.container.styles.zIndex.order ? (n = e, !1) : 0 < n;
            }), i.negativeZIndex.splice(n, 0, e)) : 0 < t ? (r = 0, i.positiveZIndex.some(function(A, e) {
                return t >= A.element.container.styles.zIndex.order ? (r = e + 1, !1) : 0 < r;
            }), i.positiveZIndex.splice(r, 0, e)) : i.zeroOrAutoZIndexOrTransformedOrOpacity.push(e) : (A.styles.isFloating() ? i.nonPositionedFloats : i.nonPositionedInlineLevel).push(e), Oc(s, e, o ? e : l, a)) : ((A.styles.isInlineLevel() ? B.inlineLevel : B.nonInlineLevel).push(s), Oc(s, B, l, a)), U(A.flags, 8) && xc(A, a);
        });
    }
    function xc(A, e) {
        for(var t = A instanceof ta ? A.start : 1, n = A instanceof ta && A.reversed, r = 0; r < e.length; r++){
            var o = e[r];
            o.container instanceof ea && "number" == typeof o.container.value && 0 !== o.container.value && (t = o.container.value), o.listValue = Da(t, o.container.styles.listStyleType, !0), t += n ? -1 : 1;
        }
    }
    function Dc(A, e) {
        switch(e){
            case 0:
                return Mc(A.topLeftBorderBox, A.topLeftPaddingBox, A.topRightBorderBox, A.topRightPaddingBox);
            case 1:
                return Mc(A.topRightBorderBox, A.topRightPaddingBox, A.bottomRightBorderBox, A.bottomRightPaddingBox);
            case 2:
                return Mc(A.bottomRightBorderBox, A.bottomRightPaddingBox, A.bottomLeftBorderBox, A.bottomLeftPaddingBox);
            default:
                return Mc(A.bottomLeftBorderBox, A.bottomLeftPaddingBox, A.topLeftBorderBox, A.topLeftPaddingBox);
        }
    }
    function Rc(A, e) {
        var t = [];
        return Uc(A) ? t.push(A.subdivide(.5, !1)) : t.push(A), Uc(e) ? t.push(e.subdivide(.5, !0)) : t.push(e), t;
    }
    function Mc(A, e, t, n) {
        var r = [];
        return Uc(A) ? r.push(A.subdivide(.5, !1)) : r.push(A), Uc(t) ? r.push(t.subdivide(.5, !0)) : r.push(t), Uc(n) ? r.push(n.subdivide(.5, !0).reverse()) : r.push(n), Uc(e) ? r.push(e.subdivide(.5, !1).reverse()) : r.push(e), r;
    }
    function Pc(A, e, t) {
        n = Zc(A.styles.backgroundOrigin, e), r = A;
        var n = 0 === n ? r.bounds : (2 === n ? Jc : Xc)(r), r = (r = Zc(A.styles.backgroundClip, e), o = A, 0 === r ? o.bounds : (2 === r ? Jc : Xc)(o)), o = Yc(Zc(A.styles.backgroundSize, e), t, n), t = o[0], i = o[1], s = no(Zc(A.styles.backgroundPosition, e), n.width - t, n.height - i);
        return [
            qc(Zc(A.styles.backgroundRepeat, e), s, o, n, r),
            Math.round(n.left + s[0]),
            Math.round(n.top + s[1]),
            t,
            i
        ];
    }
    function kc(A, e) {
        this.context = A, this.options = e;
    }
    var Gc, Nc, b = function(A, e, t, n, r) {
        var o = (Math.sqrt(2) - 1) / 3 * 4, i = t * o, s = n * o, a = A + t, c = e + n;
        switch(r){
            case v.TOP_LEFT:
                return new Cc(new I(A, c), new I(A, c - s), new I(a - i, e), new I(a, e));
            case v.TOP_RIGHT:
                return new Cc(new I(A, e), new I(A + i, e), new I(a, c - s), new I(a, c));
            case v.BOTTOM_RIGHT:
                return new Cc(new I(a, e), new I(a, e + s), new I(A + i, c), new I(A, c));
            default:
                v.BOTTOM_LEFT;
                return new Cc(new I(a, c), new I(a - i, c), new I(A, e + s), new I(A, e));
        }
    }, Vc = (uB.prototype.getEffects = function(e) {
        for(var A = -1 === [
            2,
            3
        ].indexOf(this.container.styles.position), t = this.parent, n = this.effects.slice(0); t;){
            var r, o, i = t.effects.filter(function(A) {
                return !Kc(A);
            });
            A || 0 !== t.container.styles.position || !t.parent ? (n.unshift.apply(n, i), A = -1 === [
                2,
                3
            ].indexOf(t.container.styles.position), 0 !== t.container.styles.overflowX && (r = Hc(t.curves), o = vc(t.curves), Sc(r, o) || n.unshift(new bc(o, 6)))) : n.unshift.apply(n, i), t = t.parent;
        }
        return n.filter(function(A) {
            return U(A.target, e);
        });
    }, uB), Xc = function(A) {
        var e = A.bounds, A = A.styles;
        return e.add(A.borderLeftWidth, A.borderTopWidth, -(A.borderRightWidth + A.borderLeftWidth), -(A.borderTopWidth + A.borderBottomWidth));
    }, Jc = function(A) {
        var e = A.styles, A = A.bounds, t = O(e.paddingLeft, A.width), n = O(e.paddingRight, A.width), r = O(e.paddingTop, A.width), o = O(e.paddingBottom, A.width);
        return A.add(t + e.borderLeftWidth, r + e.borderTopWidth, -(e.borderRightWidth + e.borderLeftWidth + t + n), -(e.borderTopWidth + e.borderBottomWidth + r + o));
    }, Wc = function(A) {
        return f(A) && A.value === fo.AUTO;
    }, _c = function(A) {
        return "number" == typeof A;
    }, Yc = function(A, e, t) {
        var n = e[0], r = e[1], e = e[2], o = A[0], A = A[1];
        if (!o) return [
            0,
            0
        ];
        if (Q(o) && A && Q(A)) return [
            O(o, t.width),
            O(A, t.height)
        ];
        var i = _c(e);
        if (f(o) && (o.value === fo.CONTAIN || o.value === fo.COVER)) return _c(e) ? t.width / t.height < e != (o.value === fo.COVER) ? [
            t.width,
            t.width / e
        ] : [
            t.height * e,
            t.height
        ] : [
            t.width,
            t.height
        ];
        var s = _c(n), a = _c(r), c = s || a;
        if (Wc(o) && (!A || Wc(A))) return s && a ? [
            n,
            r
        ] : i || c ? c && i ? [
            s ? n : r * e,
            a ? r : n / e
        ] : [
            s ? n : t.width,
            a ? r : t.height
        ] : [
            t.width,
            t.height
        ];
        if (i) return i = c = 0, Q(o) ? c = O(o, t.width) : Q(A) && (i = O(A, t.height)), Wc(o) ? c = i * e : A && !Wc(A) || (i = c / e), [
            c,
            i
        ];
        e = null, c = null;
        if (Q(o) ? e = O(o, t.width) : A && Q(A) && (c = O(A, t.height)), null !== (e = null !== (c = null === e || A && !Wc(A) ? c : s && a ? e / n * r : t.height) && Wc(o) ? s && a ? c / r * n : t.width : e) && null !== c) return [
            e,
            c
        ];
        throw new Error("Unable to calculate background-size for element");
    }, Zc = function(A, e) {
        e = A[e];
        return void 0 === e ? A[0] : e;
    }, qc = function(A, e, t, n, r) {
        var o = e[0], i = e[1], s = t[0], a = t[1];
        switch(A){
            case 2:
                return [
                    new I(Math.round(n.left), Math.round(n.top + i)),
                    new I(Math.round(n.left + n.width), Math.round(n.top + i)),
                    new I(Math.round(n.left + n.width), Math.round(a + n.top + i)),
                    new I(Math.round(n.left), Math.round(a + n.top + i))
                ];
            case 3:
                return [
                    new I(Math.round(n.left + o), Math.round(n.top)),
                    new I(Math.round(n.left + o + s), Math.round(n.top)),
                    new I(Math.round(n.left + o + s), Math.round(n.height + n.top)),
                    new I(Math.round(n.left + o), Math.round(n.height + n.top))
                ];
            case 1:
                return [
                    new I(Math.round(n.left + o), Math.round(n.top + i)),
                    new I(Math.round(n.left + o + s), Math.round(n.top + i)),
                    new I(Math.round(n.left + o + s), Math.round(n.top + i + a)),
                    new I(Math.round(n.left + o), Math.round(n.top + i + a))
                ];
            default:
                return [
                    new I(Math.round(r.left), Math.round(r.top)),
                    new I(Math.round(r.left + r.width), Math.round(r.top)),
                    new I(Math.round(r.left + r.width), Math.round(r.height + r.top)),
                    new I(Math.round(r.left), Math.round(r.height + r.top))
                ];
        }
    }, jc = (lB.prototype.parseMetrics = function(A, e) {
        var t = this._document.createElement("div"), n = this._document.createElement("img"), r = this._document.createElement("span"), o = this._document.body, A = (t.style.visibility = "hidden", t.style.fontFamily = A, t.style.fontSize = e, t.style.margin = "0", t.style.padding = "0", t.style.whiteSpace = "nowrap", o.appendChild(t), n.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", n.width = 1, n.height = 1, n.style.margin = "0", n.style.padding = "0", n.style.verticalAlign = "baseline", r.style.fontFamily = A, r.style.fontSize = e, r.style.margin = "0", r.style.padding = "0", r.appendChild(this._document.createTextNode("Hidden Text")), t.appendChild(r), t.appendChild(n), n.offsetTop - r.offsetTop + 2), e = (t.removeChild(r), t.appendChild(this._document.createTextNode("Hidden Text")), t.style.lineHeight = "normal", n.style.verticalAlign = "super", n.offsetTop - t.offsetTop + 2);
        return o.removeChild(t), {
            baseline: A,
            middle: e
        };
    }, lB.prototype.getMetrics = function(A, e) {
        var t = A + " " + e;
        return void 0 === this._data[t] && (this._data[t] = this.parseMetrics(A, e)), this._data[t];
    }, lB), zc = (cn(L, Nc = kc), L.prototype.applyEffects = function(A) {
        for(var e = this; this._activeEffects.length;)this.popEffect();
        A.forEach(function(A) {
            return e.applyEffect(A);
        });
    }, L.prototype.applyEffect = function(A) {
        this.ctx.save(), 2 === A.type && (this.ctx.globalAlpha = A.opacity), 0 === A.type && (this.ctx.translate(A.offsetX, A.offsetY), this.ctx.transform(A.matrix[0], A.matrix[1], A.matrix[2], A.matrix[3], A.matrix[4], A.matrix[5]), this.ctx.translate(-A.offsetX, -A.offsetY)), Kc(A) && (this.path(A.path), this.ctx.clip()), this._activeEffects.push(A);
    }, L.prototype.popEffect = function() {
        this._activeEffects.pop(), this.ctx.restore();
    }, L.prototype.renderStack = function(e) {
        return l(this, void 0, void 0, function() {
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        return e.element.container.styles.isVisible() ? [
                            4,
                            this.renderStackContent(e)
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                        A.sent(), A.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, L.prototype.renderNode = function(e) {
        return l(this, void 0, void 0, function() {
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        return U(e.container.flags, 16), e.container.styles.isVisible() ? [
                            4,
                            this.renderNodeBackgroundAndBorders(e)
                        ] : [
                            3,
                            3
                        ];
                    case 1:
                        return A.sent(), [
                            4,
                            this.renderNodeContent(e)
                        ];
                    case 2:
                        A.sent(), A.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    }, L.prototype.renderTextWithLetterSpacing = function(t, A, n) {
        var r = this;
        0 === A ? this.ctx.fillText(t.text, t.bounds.left, t.bounds.top + n) : Xs(t.text).reduce(function(A, e) {
            return r.ctx.fillText(e, A, t.bounds.top + n), A + r.ctx.measureText(e).width;
        }, t.bounds.left);
    }, L.prototype.createFontStyle = function(A) {
        var e = A.fontVariant.filter(function(A) {
            return "normal" === A || "small-caps" === A;
        }).join(""), t = nB(A.fontFamily).join(", "), n = zr(A.fontSize) ? "" + A.fontSize.number + A.fontSize.unit : A.fontSize.number + "px";
        return [
            [
                A.fontStyle,
                e,
                A.fontWeight,
                n,
                t
            ].join(" "),
            t,
            n
        ];
    }, L.prototype.renderTextNode = function(a, c) {
        return l(this, void 0, void 0, function() {
            var e, t, n, r, o, i, s = this;
            return S(this, function(A) {
                return t = this.createFontStyle(c), n = t[0], e = t[1], t = t[2], this.ctx.font = n, this.ctx.direction = 1 === c.direction ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", n = this.fontMetrics.getMetrics(e, t), r = n.baseline, o = n.middle, i = c.paintOrder, a.textBounds.forEach(function(t) {
                    i.forEach(function(A) {
                        switch(A){
                            case 0:
                                s.ctx.fillStyle = T(c.color), s.renderTextWithLetterSpacing(t, c.letterSpacing, r);
                                var e = c.textShadow;
                                e.length && t.text.trim().length && (e.slice(0).reverse().forEach(function(A) {
                                    s.ctx.shadowColor = T(A.color), s.ctx.shadowOffsetX = A.offsetX.number * s.options.scale, s.ctx.shadowOffsetY = A.offsetY.number * s.options.scale, s.ctx.shadowBlur = A.blur.number, s.renderTextWithLetterSpacing(t, c.letterSpacing, r);
                                }), s.ctx.shadowColor = "", s.ctx.shadowOffsetX = 0, s.ctx.shadowOffsetY = 0, s.ctx.shadowBlur = 0), c.textDecorationLine.length && (s.ctx.fillStyle = T(c.textDecorationColor || c.color), c.textDecorationLine.forEach(function(A) {
                                    switch(A){
                                        case 1:
                                            s.ctx.fillRect(t.bounds.left, Math.round(t.bounds.top + r), t.bounds.width, 1);
                                            break;
                                        case 2:
                                            s.ctx.fillRect(t.bounds.left, Math.round(t.bounds.top), t.bounds.width, 1);
                                            break;
                                        case 3:
                                            s.ctx.fillRect(t.bounds.left, Math.ceil(t.bounds.top + o), t.bounds.width, 1);
                                    }
                                }));
                                break;
                            case 1:
                                c.webkitTextStrokeWidth && t.text.trim().length && (s.ctx.strokeStyle = T(c.webkitTextStrokeColor), s.ctx.lineWidth = c.webkitTextStrokeWidth, s.ctx.lineJoin = window.chrome ? "miter" : "round", s.ctx.strokeText(t.text, t.bounds.left, t.bounds.top + r)), s.ctx.strokeStyle = "", s.ctx.lineWidth = 0, s.ctx.lineJoin = "miter";
                        }
                    });
                }), [
                    2
                ];
            });
        });
    }, L.prototype.renderReplacedElement = function(A, e, t) {
        var n;
        t && 0 < A.intrinsicWidth && 0 < A.intrinsicHeight && (n = Jc(A), e = vc(e), this.path(e), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(t, 0, 0, A.intrinsicWidth, A.intrinsicHeight, n.left, n.top, n.width, n.height), this.ctx.restore());
    }, L.prototype.renderNodeContent = function(w) {
        return l(this, void 0, void 0, function() {
            var e, t, n, r, o, i, s, a, c, B, l, u, g;
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        this.applyEffects(w.getEffects(4)), e = w.container, t = w.curves, n = e.styles, r = 0, o = e.textNodes, A.label = 1;
                    case 1:
                        return r < o.length ? (i = o[r], [
                            4,
                            this.renderTextNode(i, n)
                        ]) : [
                            3,
                            4
                        ];
                    case 2:
                        A.sent(), A.label = 3;
                    case 3:
                        return r++, [
                            3,
                            1
                        ];
                    case 4:
                        if (!(e instanceof zs)) return [
                            3,
                            8
                        ];
                        A.label = 5;
                    case 5:
                        return A.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]), [
                            4,
                            this.context.cache.match(e.src)
                        ];
                    case 6:
                        return B = A.sent(), this.renderReplacedElement(e, t, B), [
                            3,
                            8
                        ];
                    case 7:
                        return A.sent(), this.context.logger.error("Error loading image " + e.src), [
                            3,
                            8
                        ];
                    case 8:
                        if (e instanceof $s && this.renderReplacedElement(e, t, e.canvas), !(e instanceof Aa)) return [
                            3,
                            12
                        ];
                        A.label = 9;
                    case 9:
                        return A.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]), [
                            4,
                            this.context.cache.match(e.svg)
                        ];
                    case 10:
                        return B = A.sent(), this.renderReplacedElement(e, t, B), [
                            3,
                            12
                        ];
                    case 11:
                        return A.sent(), this.context.logger.error("Error loading svg " + e.svg.substring(0, 255)), [
                            3,
                            12
                        ];
                    case 12:
                        return e instanceof aa && e.tree ? [
                            4,
                            new L(this.context, {
                                scale: this.options.scale,
                                backgroundColor: e.backgroundColor,
                                x: 0,
                                y: 0,
                                width: e.width,
                                height: e.height
                            }).render(e.tree)
                        ] : [
                            3,
                            14
                        ];
                    case 13:
                        i = A.sent(), e.width && e.height && this.ctx.drawImage(i, 0, 0, e.width, e.height, e.bounds.left, e.bounds.top, e.bounds.width, e.bounds.height), A.label = 14;
                    case 14:
                        if (e instanceof oa && (s = Math.min(e.bounds.width, e.bounds.height), "checkbox" === e.type ? e.checked && (this.ctx.save(), this.path([
                            new I(e.bounds.left + .39363 * s, e.bounds.top + .79 * s),
                            new I(e.bounds.left + .16 * s, e.bounds.top + .5549 * s),
                            new I(e.bounds.left + .27347 * s, e.bounds.top + .44071 * s),
                            new I(e.bounds.left + .39694 * s, e.bounds.top + .5649 * s),
                            new I(e.bounds.left + .72983 * s, e.bounds.top + .23 * s),
                            new I(e.bounds.left + .84 * s, e.bounds.top + .34085 * s),
                            new I(e.bounds.left + .39363 * s, e.bounds.top + .79 * s)
                        ]), this.ctx.fillStyle = T(707406591), this.ctx.fill(), this.ctx.restore()) : "radio" === e.type && e.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(e.bounds.left + s / 2, e.bounds.top + s / 2, s / 4, 0, 2 * Math.PI, !0), this.ctx.fillStyle = T(707406591), this.ctx.fill(), this.ctx.restore())), $c(e) && e.value.length) {
                            switch(s = this.createFontStyle(n), u = s[0], l = s[1], l = this.fontMetrics.getMetrics(u, l).baseline, this.ctx.font = u, this.ctx.fillStyle = T(n.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = eB(e.styles.textAlign), g = Jc(e), a = 0, e.styles.textAlign){
                                case 1:
                                    a += g.width / 2;
                                    break;
                                case 2:
                                    a += g.width;
                            }
                            c = g.add(a, 0, 0, -g.height / 2 + 1), this.ctx.save(), this.path([
                                new I(g.left, g.top),
                                new I(g.left + g.width, g.top),
                                new I(g.left + g.width, g.top + g.height),
                                new I(g.left, g.top + g.height)
                            ]), this.ctx.clip(), this.renderTextWithLetterSpacing(new Gs(e.value, c), n.letterSpacing, l), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
                        }
                        if (!U(e.styles.display, 2048)) return [
                            3,
                            20
                        ];
                        if (null === e.styles.listStyleImage) return [
                            3,
                            19
                        ];
                        if (0 !== (c = e.styles.listStyleImage).type) return [
                            3,
                            18
                        ];
                        B = void 0, l = c.url, A.label = 15;
                    case 15:
                        return A.trys.push([
                            15,
                            17,
                            ,
                            18
                        ]), [
                            4,
                            this.context.cache.match(l)
                        ];
                    case 16:
                        return B = A.sent(), this.ctx.drawImage(B, e.bounds.left - (B.width + 10), e.bounds.top), [
                            3,
                            18
                        ];
                    case 17:
                        return A.sent(), this.context.logger.error("Error loading list-style-image " + l), [
                            3,
                            18
                        ];
                    case 18:
                        return [
                            3,
                            20
                        ];
                    case 19:
                        w.listValue && -1 !== e.styles.listStyleType && (u = this.createFontStyle(n)[0], this.ctx.font = u, this.ctx.fillStyle = T(n.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", g = new un(e.bounds.left, e.bounds.top + O(e.styles.paddingTop, e.bounds.width), e.bounds.width, Oo(n.lineHeight, n.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new Gs(w.listValue, g), n.letterSpacing, Oo(n.lineHeight, n.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), A.label = 20;
                    case 20:
                        return [
                            2
                        ];
                }
            });
        });
    }, L.prototype.renderStackContent = function(h) {
        return l(this, void 0, void 0, function() {
            var e, t, n, r, o, i, s, a, c, B, l, u, g, w, d;
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        return U(h.element.container.flags, 16), [
                            4,
                            this.renderNodeBackgroundAndBorders(h.element)
                        ];
                    case 1:
                        A.sent(), e = 0, t = h.negativeZIndex, A.label = 2;
                    case 2:
                        return e < t.length ? (d = t[e], [
                            4,
                            this.renderStack(d)
                        ]) : [
                            3,
                            5
                        ];
                    case 3:
                        A.sent(), A.label = 4;
                    case 4:
                        return e++, [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            4,
                            this.renderNodeContent(h.element)
                        ];
                    case 6:
                        A.sent(), n = 0, r = h.nonInlineLevel, A.label = 7;
                    case 7:
                        return n < r.length ? (d = r[n], [
                            4,
                            this.renderNode(d)
                        ]) : [
                            3,
                            10
                        ];
                    case 8:
                        A.sent(), A.label = 9;
                    case 9:
                        return n++, [
                            3,
                            7
                        ];
                    case 10:
                        o = 0, i = h.nonPositionedFloats, A.label = 11;
                    case 11:
                        return o < i.length ? (d = i[o], [
                            4,
                            this.renderStack(d)
                        ]) : [
                            3,
                            14
                        ];
                    case 12:
                        A.sent(), A.label = 13;
                    case 13:
                        return o++, [
                            3,
                            11
                        ];
                    case 14:
                        s = 0, a = h.nonPositionedInlineLevel, A.label = 15;
                    case 15:
                        return s < a.length ? (d = a[s], [
                            4,
                            this.renderStack(d)
                        ]) : [
                            3,
                            18
                        ];
                    case 16:
                        A.sent(), A.label = 17;
                    case 17:
                        return s++, [
                            3,
                            15
                        ];
                    case 18:
                        c = 0, B = h.inlineLevel, A.label = 19;
                    case 19:
                        return c < B.length ? (d = B[c], [
                            4,
                            this.renderNode(d)
                        ]) : [
                            3,
                            22
                        ];
                    case 20:
                        A.sent(), A.label = 21;
                    case 21:
                        return c++, [
                            3,
                            19
                        ];
                    case 22:
                        l = 0, u = h.zeroOrAutoZIndexOrTransformedOrOpacity, A.label = 23;
                    case 23:
                        return l < u.length ? (d = u[l], [
                            4,
                            this.renderStack(d)
                        ]) : [
                            3,
                            26
                        ];
                    case 24:
                        A.sent(), A.label = 25;
                    case 25:
                        return l++, [
                            3,
                            23
                        ];
                    case 26:
                        g = 0, w = h.positiveZIndex, A.label = 27;
                    case 27:
                        return g < w.length ? (d = w[g], [
                            4,
                            this.renderStack(d)
                        ]) : [
                            3,
                            30
                        ];
                    case 28:
                        A.sent(), A.label = 29;
                    case 29:
                        return g++, [
                            3,
                            27
                        ];
                    case 30:
                        return [
                            2
                        ];
                }
            });
        });
    }, L.prototype.mask = function(A) {
        this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(A.slice(0).reverse()), this.ctx.closePath();
    }, L.prototype.path = function(A) {
        this.ctx.beginPath(), this.formatPath(A), this.ctx.closePath();
    }, L.prototype.formatPath = function(A) {
        var n = this;
        A.forEach(function(A, e) {
            var t = Uc(A) ? A.start : A;
            0 === e ? n.ctx.moveTo(t.x, t.y) : n.ctx.lineTo(t.x, t.y), Uc(A) && n.ctx.bezierCurveTo(A.startControl.x, A.startControl.y, A.endControl.x, A.endControl.y, A.end.x, A.end.y);
        });
    }, L.prototype.renderRepeat = function(A, e, t, n) {
        this.path(A), this.ctx.fillStyle = e, this.ctx.translate(t, n), this.ctx.fill(), this.ctx.translate(-t, -n);
    }, L.prototype.resizeImage = function(A, e, t) {
        var n;
        return A.width === e && A.height === t ? A : ((n = (null != (n = this.canvas.ownerDocument) ? n : document).createElement("canvas")).width = Math.max(1, e), n.height = Math.max(1, t), n.getContext("2d").drawImage(A, 0, 0, A.width, A.height, 0, 0, e, t), n);
    }, L.prototype.renderBackgroundImage = function(K) {
        return l(this, void 0, void 0, function() {
            var b, e, L, t, n, r;
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        b = K.styles.backgroundImage.length - 1, e = function(s) {
                            var a, c, B, l, u, g, w, d, h, f, Q, p, C, U, F, m, y, E, H, v, I;
                            return S(this, function(A) {
                                switch(A.label){
                                    case 0:
                                        if (0 !== s.type) return [
                                            3,
                                            5
                                        ];
                                        a = void 0, c = s.url, A.label = 1;
                                    case 1:
                                        return A.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]), [
                                            4,
                                            L.context.cache.match(c)
                                        ];
                                    case 2:
                                        return a = A.sent(), [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        return A.sent(), L.context.logger.error("Error loading background-image " + c), [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return a && (f = Pc(K, b, [
                                            a.width,
                                            a.height,
                                            a.width / a.height
                                        ]), g = f[0], p = f[1], C = f[2], h = f[3], f = f[4], l = L.ctx.createPattern(L.resizeImage(a, h, f), "repeat"), L.renderRepeat(g, l, p, C)), [
                                            3,
                                            6
                                        ];
                                    case 5:
                                        1 === s.type ? (Q = Pc(K, b, [
                                            null,
                                            null,
                                            null
                                        ]), g = Q[0], p = Q[1], C = Q[2], h = Q[3], f = Q[4], e = s.angle, t = h, n = f, e = "number" == typeof e ? e : (i = t / 2, o = (r = n) / 2, i = O(e[0], t) - i, o -= O(e[1], r), (Math.atan2(o, i) + 2 * Math.PI) % (2 * Math.PI)), r = Math.abs(t * Math.sin(e)) + Math.abs(n * Math.cos(e)), o = t / 2, i = n / 2, t = r / 2, n = Math.sin(e - Math.PI / 2) * t, e = Math.cos(e - Math.PI / 2) * t, U = (Q = [
                                            r,
                                            o - e,
                                            o + e,
                                            i - n,
                                            i + n
                                        ])[0], u = Q[1], d = Q[2], w = Q[3], Q = Q[4], (m = document.createElement("canvas")).width = h, m.height = f, F = m.getContext("2d"), B = F.createLinearGradient(u, w, d, Q), lo(s.stops, U).forEach(function(A) {
                                            return B.addColorStop(A.stop, T(A.color));
                                        }), F.fillStyle = B, F.fillRect(0, 0, h, f), 0 < h && 0 < f && (l = L.ctx.createPattern(m, "repeat"), L.renderRepeat(g, l, p, C))) : 2 === s.type && (u = Pc(K, b, [
                                            null,
                                            null,
                                            null
                                        ]), g = u[0], w = u[1], d = u[2], h = u[3], f = u[4], Q = 0 === s.position.length ? [
                                            eo
                                        ] : s.position, p = O(Q[0], h), C = O(Q[Q.length - 1], f), U = ((A, e, t, n, r)=>{
                                            var o, i, s, a = 0, c = 0;
                                            switch(A.size){
                                                case 0:
                                                    0 === A.shape ? a = c = Math.min(Math.abs(e), Math.abs(e - n), Math.abs(t), Math.abs(t - r)) : 1 === A.shape && (a = Math.min(Math.abs(e), Math.abs(e - n)), c = Math.min(Math.abs(t), Math.abs(t - r)));
                                                    break;
                                                case 2:
                                                    0 === A.shape ? a = c = Math.min(mo(e, t), mo(e, t - r), mo(e - n, t), mo(e - n, t - r)) : 1 === A.shape && (o = Math.min(Math.abs(t), Math.abs(t - r)) / Math.min(Math.abs(e), Math.abs(e - n)), s = (i = uo(n, r, e, t, !0))[0], c = o * (a = mo(s - e, (i[1] - t) / o)));
                                                    break;
                                                case 1:
                                                    0 === A.shape ? a = c = Math.max(Math.abs(e), Math.abs(e - n), Math.abs(t), Math.abs(t - r)) : 1 === A.shape && (a = Math.max(Math.abs(e), Math.abs(e - n)), c = Math.max(Math.abs(t), Math.abs(t - r)));
                                                    break;
                                                case 3:
                                                    0 === A.shape ? a = c = Math.max(mo(e, t), mo(e, t - r), mo(e - n, t), mo(e - n, t - r)) : 1 === A.shape && (o = Math.max(Math.abs(t), Math.abs(t - r)) / Math.max(Math.abs(e), Math.abs(e - n)), s = (i = uo(n, r, e, t, !1))[0], c = o * (a = mo(s - e, (i[1] - t) / o)));
                                            }
                                            return Array.isArray(A.size) && (a = O(A.size[0], n), c = 2 === A.size.length ? O(A.size[1], r) : a), [
                                                a,
                                                c
                                            ];
                                        })(s, p, C, h, f), F = U[0], m = U[1], 0 < F) && 0 < m && (y = L.ctx.createRadialGradient(w + p, d + C, 0, w + p, d + C, F), lo(s.stops, 2 * F).forEach(function(A) {
                                            return y.addColorStop(A.stop, T(A.color));
                                        }), L.path(g), L.ctx.fillStyle = y, F !== m ? (E = K.bounds.left + .5 * K.bounds.width, H = K.bounds.top + .5 * K.bounds.height, I = 1 / (v = m / F), L.ctx.save(), L.ctx.translate(E, H), L.ctx.transform(1, 0, 0, v, 0, 0), L.ctx.translate(-E, -H), L.ctx.fillRect(w, I * (d - H) + H, h, f * I), L.ctx.restore()) : L.ctx.fill()), A.label = 6;
                                    case 6:
                                        return b--, [
                                            2
                                        ];
                                }
                                var e, t, n, r, o, i;
                            });
                        }, L = this, t = 0, n = K.styles.backgroundImage.slice(0).reverse(), A.label = 1;
                    case 1:
                        return t < n.length ? (r = n[t], [
                            5,
                            e(r)
                        ]) : [
                            3,
                            4
                        ];
                    case 2:
                        A.sent(), A.label = 3;
                    case 3:
                        return t++, [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, L.prototype.renderSolidBorder = function(e, t, n) {
        return l(this, void 0, void 0, function() {
            return S(this, function(A) {
                return this.path(Dc(n, t)), this.ctx.fillStyle = T(e), this.ctx.fill(), [
                    2
                ];
            });
        });
    }, L.prototype.renderDoubleBorder = function(t, n, r, o) {
        return l(this, void 0, void 0, function() {
            var e;
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        return n < 3 ? [
                            4,
                            this.renderSolidBorder(t, r, o)
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                        return A.sent(), [
                            2
                        ];
                    case 2:
                        return e = ((A)=>{
                            switch(r){
                                case 0:
                                    return Mc(A.topLeftBorderBox, A.topLeftBorderDoubleOuterBox, A.topRightBorderBox, A.topRightBorderDoubleOuterBox);
                                case 1:
                                    return Mc(A.topRightBorderBox, A.topRightBorderDoubleOuterBox, A.bottomRightBorderBox, A.bottomRightBorderDoubleOuterBox);
                                case 2:
                                    return Mc(A.bottomRightBorderBox, A.bottomRightBorderDoubleOuterBox, A.bottomLeftBorderBox, A.bottomLeftBorderDoubleOuterBox);
                                default:
                                    return Mc(A.bottomLeftBorderBox, A.bottomLeftBorderDoubleOuterBox, A.topLeftBorderBox, A.topLeftBorderDoubleOuterBox);
                            }
                        })(o), this.path(e), this.ctx.fillStyle = T(t), this.ctx.fill(), e = ((A)=>{
                            switch(r){
                                case 0:
                                    return Mc(A.topLeftBorderDoubleInnerBox, A.topLeftPaddingBox, A.topRightBorderDoubleInnerBox, A.topRightPaddingBox);
                                case 1:
                                    return Mc(A.topRightBorderDoubleInnerBox, A.topRightPaddingBox, A.bottomRightBorderDoubleInnerBox, A.bottomRightPaddingBox);
                                case 2:
                                    return Mc(A.bottomRightBorderDoubleInnerBox, A.bottomRightPaddingBox, A.bottomLeftBorderDoubleInnerBox, A.bottomLeftPaddingBox);
                                default:
                                    return Mc(A.bottomLeftBorderDoubleInnerBox, A.bottomLeftPaddingBox, A.topLeftBorderDoubleInnerBox, A.topLeftPaddingBox);
                            }
                        })(o), this.path(e), this.ctx.fill(), [
                            2
                        ];
                }
            });
        });
    }, L.prototype.renderNodeBackgroundAndBorders = function(B) {
        return l(this, void 0, void 0, function() {
            var e, t, n, r, o, i, s, a, c = this;
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        return this.applyEffects(B.getEffects(2)), e = B.container.styles, t = !oo(e.backgroundColor) || e.backgroundImage.length, n = [
                            {
                                style: e.borderTopStyle,
                                color: e.borderTopColor,
                                width: e.borderTopWidth
                            },
                            {
                                style: e.borderRightStyle,
                                color: e.borderRightColor,
                                width: e.borderRightWidth
                            },
                            {
                                style: e.borderBottomStyle,
                                color: e.borderBottomColor,
                                width: e.borderBottomWidth
                            },
                            {
                                style: e.borderLeftStyle,
                                color: e.borderLeftColor,
                                width: e.borderLeftWidth
                            }
                        ], r = AB(Zc(e.backgroundClip, 0), B.curves), t || e.boxShadow.length ? (this.ctx.save(), this.path(r), this.ctx.clip(), oo(e.backgroundColor) || (this.ctx.fillStyle = T(e.backgroundColor), this.ctx.fill()), [
                            4,
                            this.renderBackgroundImage(B.container)
                        ]) : [
                            3,
                            2
                        ];
                    case 1:
                        A.sent(), this.ctx.restore(), e.boxShadow.slice(0).reverse().forEach(function(A) {
                            c.ctx.save();
                            var t, n, r, o, e = Hc(B.curves), i = A.inset ? 0 : 1e4, s = (t = -i + (A.inset ? 1 : -1) * A.spread.number, n = (A.inset ? 1 : -1) * A.spread.number, r = A.spread.number * (A.inset ? -2 : 2), o = A.spread.number * (A.inset ? -2 : 2), e.map(function(A, e) {
                                switch(e){
                                    case 0:
                                        return A.add(t, n);
                                    case 1:
                                        return A.add(t + r, n);
                                    case 2:
                                        return A.add(t + r, n + o);
                                    case 3:
                                        return A.add(t, n + o);
                                }
                                return A;
                            }));
                            A.inset ? (c.path(e), c.ctx.clip(), c.mask(s)) : (c.mask(e), c.ctx.clip(), c.path(s)), c.ctx.shadowOffsetX = A.offsetX.number + i, c.ctx.shadowOffsetY = A.offsetY.number, c.ctx.shadowColor = T(A.color), c.ctx.shadowBlur = A.blur.number, c.ctx.fillStyle = A.inset ? T(A.color) : "rgba(0,0,0,1)", c.ctx.fill(), c.ctx.restore();
                        }), A.label = 2;
                    case 2:
                        i = o = 0, s = n, A.label = 3;
                    case 3:
                        return i < s.length ? 0 !== (a = s[i]).style && !oo(a.color) && 0 < a.width ? 2 !== a.style ? [
                            3,
                            5
                        ] : [
                            4,
                            this.renderDashedDottedBorder(a.color, a.width, o, B.curves, 2)
                        ] : [
                            3,
                            11
                        ] : [
                            3,
                            13
                        ];
                    case 4:
                        return A.sent(), [
                            3,
                            11
                        ];
                    case 5:
                        return 3 !== a.style ? [
                            3,
                            7
                        ] : [
                            4,
                            this.renderDashedDottedBorder(a.color, a.width, o, B.curves, 3)
                        ];
                    case 6:
                        return A.sent(), [
                            3,
                            11
                        ];
                    case 7:
                        return 4 !== a.style ? [
                            3,
                            9
                        ] : [
                            4,
                            this.renderDoubleBorder(a.color, a.width, o, B.curves)
                        ];
                    case 8:
                        return A.sent(), [
                            3,
                            11
                        ];
                    case 9:
                        return [
                            4,
                            this.renderSolidBorder(a.color, o, B.curves)
                        ];
                    case 10:
                        A.sent(), A.label = 11;
                    case 11:
                        o++, A.label = 12;
                    case 12:
                        return i++, [
                            3,
                            3
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        });
    }, L.prototype.renderDashedDottedBorder = function(u, g, w, d, h) {
        return l(this, void 0, void 0, function() {
            var e, t, n, r, o, i, s, a, c, B, l;
            return S(this, function(A) {
                return this.ctx.save(), o = ((A)=>{
                    switch(w){
                        case 0:
                            return Rc(A.topLeftBorderStroke, A.topRightBorderStroke);
                        case 1:
                            return Rc(A.topRightBorderStroke, A.bottomRightBorderStroke);
                        case 2:
                            return Rc(A.bottomRightBorderStroke, A.bottomLeftBorderStroke);
                        default:
                            return Rc(A.bottomLeftBorderStroke, A.topLeftBorderStroke);
                    }
                })(d), e = Dc(d, w), 2 === h && (this.path(e), this.ctx.clip()), c = (Uc(e[0]) ? (t = e[0].start.x, e[0].start) : (t = e[0].x, e[0])).y, r = (Uc(e[1]) ? (n = e[1].end.x, e[1].end) : (n = e[1].x, e[1])).y, c = 0 === w || 2 === w ? Math.abs(t - n) : Math.abs(c - r), this.ctx.beginPath(), 3 === h ? this.formatPath(o) : this.formatPath(e.slice(0, 2)), r = g < 3 ? 3 * g : 2 * g, o = g < 3 ? 2 * g : g, 3 === h && (o = r = g), i = !0, c <= 2 * r ? i = !1 : c <= 2 * r + o ? (r *= s = c / (2 * r + o), o *= s) : (s = Math.floor((c + o) / (r + o)), a = (c - s * r) / (s - 1), o = (c = (c - (s + 1) * r) / s) <= 0 || Math.abs(o - a) < Math.abs(o - c) ? a : c), i && (3 === h ? this.ctx.setLineDash([
                    0,
                    r + o
                ]) : this.ctx.setLineDash([
                    r,
                    o
                ])), 3 === h ? (this.ctx.lineCap = "round", this.ctx.lineWidth = g) : this.ctx.lineWidth = 2 * g + 1.1, this.ctx.strokeStyle = T(u), this.ctx.stroke(), this.ctx.setLineDash([]), 2 === h && (Uc(e[0]) && (B = e[3], l = e[0], this.ctx.beginPath(), this.formatPath([
                    new I(B.end.x, B.end.y),
                    new I(l.start.x, l.start.y)
                ]), this.ctx.stroke()), Uc(e[1])) && (B = e[1], l = e[2], this.ctx.beginPath(), this.formatPath([
                    new I(B.end.x, B.end.y),
                    new I(l.start.x, l.start.y)
                ]), this.ctx.stroke()), this.ctx.restore(), [
                    2
                ];
            });
        });
    }, L.prototype.render = function(r) {
        return l(this, void 0, void 0, function() {
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        return this.options.backgroundColor && (this.ctx.fillStyle = T(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), e = new Vc(r, null), t = new Tc(e), Oc(e, t, t, n = []), xc(e.container, n), [
                            4,
                            this.renderStack(t)
                        ];
                    case 1:
                        return A.sent(), this.applyEffects([]), [
                            2,
                            this.canvas
                        ];
                }
                var e, t, n;
            });
        });
    }, L), $c = function(A) {
        return A instanceof sa || A instanceof ia || A instanceof oa && "radio" !== A.type && "checkbox" !== A.type;
    }, AB = function(A, e) {
        switch(A){
            case 0:
                return Hc(e);
            case 2:
                return [
                    e.topLeftContentBox,
                    e.topRightContentBox,
                    e.bottomRightContentBox,
                    e.bottomLeftContentBox
                ];
            default:
                return vc(e);
        }
    }, eB = function(A) {
        switch(A){
            case 1:
                return "center";
            case 2:
                return "right";
            default:
                return "left";
        }
    }, tB = [
        "-apple-system",
        "system-ui"
    ], nB = function(A) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? A.filter(function(A) {
            return -1 === tB.indexOf(A);
        }) : A;
    }, rB = (cn(BB, Gc = kc), BB.prototype.render = function(t) {
        return l(this, void 0, void 0, function() {
            var e;
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        return e = ds(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, t), [
                            4,
                            oB(e)
                        ];
                    case 1:
                        return e = A.sent(), this.options.backgroundColor && (this.ctx.fillStyle = T(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(e, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [
                            2,
                            this.canvas
                        ];
                }
            });
        });
    }, BB), oB = function(n) {
        return new Promise(function(A, e) {
            var t = new Image;
            t.onload = function() {
                A(t);
            }, t.onerror = e, t.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent((new XMLSerializer).serializeToString(n));
        });
    }, iB = (cB.prototype.debug = function() {
        for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
        this.enabled && ("undefined" != typeof window && window.console && "function" == typeof console.debug ? console.debug.apply(console, ln([
            this.id,
            this.getTime() + "ms"
        ], A)) : this.info.apply(this, A));
    }, cB.prototype.getTime = function() {
        return Date.now() - this.start;
    }, cB.prototype.info = function() {
        for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
        this.enabled && "undefined" != typeof window && window.console && "function" == typeof console.info && console.info.apply(console, ln([
            this.id,
            this.getTime() + "ms"
        ], A));
    }, cB.prototype.warn = function() {
        for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
        this.enabled && ("undefined" != typeof window && window.console && "function" == typeof console.warn ? console.warn.apply(console, ln([
            this.id,
            this.getTime() + "ms"
        ], A)) : this.info.apply(this, A));
    }, cB.prototype.error = function() {
        for(var A = [], e = 0; e < arguments.length; e++)A[e] = arguments[e];
        this.enabled && ("undefined" != typeof window && window.console && "function" == typeof console.error ? console.error.apply(console, ln([
            this.id,
            this.getTime() + "ms"
        ], A)) : this.info.apply(this, A));
    }, cB.instances = {}, cB), sB = (aB.instanceCount = 1, aB);
    function aB(A, e) {
        this.windowBounds = e, this.instanceName = "#" + aB.instanceCount++, this.logger = new iB({
            id: this.instanceName,
            enabled: A.logging
        }), this.cache = null != (e = A.cache) ? e : new lc(this, A);
    }
    function cB(A) {
        var e = A.id, A = A.enabled;
        this.id = e, this.enabled = A, this.start = Date.now();
    }
    function BB(A, e) {
        A = Gc.call(this, A, e) || this;
        return A.canvas = e.canvas || document.createElement("canvas"), A.ctx = A.canvas.getContext("2d"), A.options = e, A.canvas.width = Math.floor(e.width * e.scale), A.canvas.height = Math.floor(e.height * e.scale), A.canvas.style.width = e.width + "px", A.canvas.style.height = e.height + "px", A.ctx.scale(A.options.scale, A.options.scale), A.ctx.translate(-e.x, -e.y), A.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + e.width + "x" + e.height + " at " + e.x + "," + e.y + ") with scale " + e.scale), A;
    }
    function L(A, e) {
        A = Nc.call(this, A, e) || this;
        return A._activeEffects = [], A.canvas = e.canvas || document.createElement("canvas"), A.ctx = A.canvas.getContext("2d"), e.canvas || (A.canvas.width = Math.floor(e.width * e.scale), A.canvas.height = Math.floor(e.height * e.scale), A.canvas.style.width = e.width + "px", A.canvas.style.height = e.height + "px"), A.fontMetrics = new jc(document), A.ctx.scale(A.options.scale, A.options.scale), A.ctx.translate(-e.x, -e.y), A.ctx.textBaseline = "bottom", A._activeEffects = [], A.context.logger.debug("Canvas renderer initialized (" + e.width + "x" + e.height + ") with scale " + e.scale), A;
    }
    function lB(A) {
        this._data = {}, this._document = A;
    }
    function uB(A, e) {
        var t;
        this.container = A, this.parent = e, this.effects = [], this.curves = new ja(this.container), this.container.styles.opacity < 1 && this.effects.push(new Lc(this.container.styles.opacity)), null !== this.container.styles.transform && (A = this.container.bounds.left + this.container.styles.transformOrigin[0].number, e = this.container.bounds.top + this.container.styles.transformOrigin[1].number, t = this.container.styles.transform, this.effects.push(new Ic(A, e, t))), 0 !== this.container.styles.overflowX && (A = Hc(this.curves), e = vc(this.curves), Sc(A, e) ? this.effects.push(new bc(A, 6)) : (this.effects.push(new bc(A, 2)), this.effects.push(new bc(e, 4))));
    }
    "undefined" != typeof window && Bc.setContext(window);
    var gB = function(f, Q) {
        return l(void 0, void 0, void 0, function() {
            var e, t, n, r, o, i, s, a, c, B, l, u, g, w, d, h;
            return S(this, function(A) {
                switch(A.label){
                    case 0:
                        if (!f || "object" != typeof f) return [
                            2,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        if (!(g = f.ownerDocument)) throw new Error("Element is not attached to a Document");
                        if (e = g.defaultView) return w = {
                            allowTaint: null != (w = Q.allowTaint) && w,
                            imageTimeout: null != (w = Q.imageTimeout) ? w : 15e3,
                            proxy: Q.proxy,
                            useCORS: null != (w = Q.useCORS) && w
                        }, B = Bn({
                            logging: null == (B = Q.logging) || B,
                            cache: Q.cache
                        }, w), w = {
                            windowWidth: null != (w = Q.windowWidth) ? w : e.innerWidth,
                            windowHeight: null != (w = Q.windowHeight) ? w : e.innerHeight,
                            scrollX: null != (w = Q.scrollX) ? w : e.pageXOffset,
                            scrollY: null != (w = Q.scrollY) ? w : e.pageYOffset
                        }, w = new un(w.scrollX, w.scrollY, w.windowWidth, w.windowHeight), B = new sB(B, w), l = null != (l = Q.foreignObjectRendering) && l, u = {
                            allowTaint: null != (u = Q.allowTaint) && u,
                            onclone: Q.onclone,
                            ignoreElements: Q.ignoreElements,
                            inlineImages: l,
                            copyStyles: l
                        }, B.logger.debug("Starting document clone with size " + w.width + "x" + w.height + " scrolled to " + -w.left + "," + -w.top), u = new Ra(B, f, u), (t = u.clonedReferenceElement) ? [
                            4,
                            u.toIFrame(g, w)
                        ] : [
                            2,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        throw new Error("Document is not attached to a Window");
                    case 1:
                        return n = A.sent(), u = ma(t) || "HTML" === t.tagName ? ((A)=>{
                            var e, t = A.body, A = A.documentElement;
                            if (t && A) return e = Math.max(Math.max(t.scrollWidth, A.scrollWidth), Math.max(t.offsetWidth, A.offsetWidth), Math.max(t.clientWidth, A.clientWidth)), t = Math.max(Math.max(t.scrollHeight, A.scrollHeight), Math.max(t.offsetHeight, A.offsetHeight), Math.max(t.clientHeight, A.clientHeight)), new un(0, 0, e, t);
                            throw new Error("Unable to get document size");
                        })(t.ownerDocument) : gn(B, t), r = u.width, o = u.height, i = u.left, s = u.top, a = wB(B, t, Q.backgroundColor), d = {
                            canvas: Q.canvas,
                            backgroundColor: a,
                            scale: null != (w = null != (g = Q.scale) ? g : e.devicePixelRatio) ? w : 1,
                            x: (null != (d = Q.x) ? d : 0) + i,
                            y: (null != (d = Q.y) ? d : 0) + s,
                            width: null != (d = Q.width) ? d : Math.ceil(r),
                            height: null != (d = Q.height) ? d : Math.ceil(o)
                        }, l ? (B.logger.debug("Document cloned, using foreign object rendering"), [
                            4,
                            new rB(B, d).render(t)
                        ]) : [
                            3,
                            3
                        ];
                    case 2:
                        return c = A.sent(), [
                            3,
                            5
                        ];
                    case 3:
                        return B.logger.debug("Document cloned, element located at " + i + "," + s + " with size " + r + "x" + o + " using computed rendering"), B.logger.debug("Starting DOM parsing"), h = ua(B, t), a === h.styles.backgroundColor && (h.styles.backgroundColor = Co.TRANSPARENT), B.logger.debug("Starting renderer for element at " + d.x + "," + d.y + " with size " + d.width + "x" + d.height), [
                            4,
                            new zc(B, d).render(h)
                        ];
                    case 4:
                        c = A.sent(), A.label = 5;
                    case 5:
                        return null != (h = Q.removeContainer) && !h || Ra.destroy(n) || B.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore"), B.logger.debug("Finished rendering"), [
                            2,
                            c
                        ];
                }
            });
        });
    }, wB = function(A, e, t) {
        var n = e.ownerDocument, r = n.documentElement ? po(A, getComputedStyle(n.documentElement).backgroundColor) : Co.TRANSPARENT, o = n.body ? po(A, getComputedStyle(n.body).backgroundColor) : Co.TRANSPARENT, A = "string" == typeof t ? po(A, t) : null === t ? Co.TRANSPARENT : 4294967295;
        return e === n.documentElement ? oo(r) ? oo(o) ? A : o : r : A;
    }, dB = {
        THRESHOLDS: {
            TINY: 1e5,
            SMALL: 3e5,
            MEDIUM: 8e5,
            LARGE: 15e5,
            LLARGE: 25e5
        },
        LEVELS: [
            {
                maxArea: 1e5,
                scale: 1,
                defaultQuality: .7
            },
            {
                maxArea: 3e5,
                scale: 1,
                defaultQuality: .6
            },
            {
                maxArea: 8e5,
                scale: .7,
                defaultQuality: .6
            },
            {
                maxArea: 15e5,
                scale: .5,
                defaultQuality: .65
            },
            {
                maxArea: 25e5,
                scale: .45,
                defaultQuality: .65
            },
            {
                maxArea: 1 / 0,
                scale: .45,
                defaultQuality: .65
            }
        ]
    };
    function hB(e) {
        return dB.LEVELS.find(function(A) {
            return e <= A.maxArea;
        });
    }
    function fB(A, e, t) {
        var n = (A = A.map(function(A) {
            return UB(A);
        }))[0];
        return n ? (e = e.some(function(A) {
            return n.includes(A);
        }), t = !t.some(function(A) {
            return n.includes(A);
        }), {
            isWhitePoint: e && t,
            selectorPointers: A
        }) : {
            isWhitePoint: !1,
            selectorPointers: A
        };
    }
    function QB(A) {
        try {
            var e = A.config.blankScreen;
            return !0 === e ? on : FB(on, e);
        } catch (A) {
            return on;
        }
    }
    function pB(t, n) {
        function r(A) {
            var e = A[0];
            return e && null !== e.shadowRoot && (e = (null == (e = null == e ? void 0 : e.shadowRoot) ? void 0 : e.elementsFromPoint(t, n)) || []).length > A.length ? r(e || []) : A;
        }
        var A = document.elementsFromPoint(t, n);
        return r(A);
    }
    function CB(s, a, c, B) {
        return void 0 === a && (a = "image/webp"), void 0 === c && (c = 1920), void 0 === B && (B = 1080), z(void 0, void 0, void 0, function() {
            var t, n, r, o, i;
            return $(this, function(A) {
                switch(A.label){
                    case 0:
                        return A.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]), i = window.innerWidth, r = hB((i = c < i ? c : i) * (t = B < (t = window.innerHeight) ? B : t)), n = r.scale, r = r.defaultQuality, r = null != s ? s : r, o = window.getComputedStyle(document.body), o = o.backgroundColor, o = o && "rgba(0, 0, 0, 0)" !== o && "transparent" !== o ? o : "#ffffff", [
                            4,
                            (e = document.body, gB(e, e = (e = {
                                width: i,
                                height: t,
                                windowWidth: i,
                                windowHeight: t,
                                scale: n,
                                useCORS: !0,
                                allowTaint: !0,
                                backgroundColor: o,
                                logging: !1,
                                imageTimeout: 500,
                                removeContainer: !0,
                                ignoreElements: function(A) {
                                    A = A.tagName.toLowerCase();
                                    return "iframe" === A || "video" === A || "canvas" === A;
                                },
                                onclone: function(A) {
                                    try {
                                        var r = [
                                            "color(",
                                            "oklch(",
                                            "oklab(",
                                            "lch(",
                                            "lab("
                                        ], t = /(oklch|oklab|lch|lab|color)\s*\([^)]*(?:\([^)]*\)[^)]*)*\)/gi, e = (A.querySelectorAll("style").forEach(function(e) {
                                            e.textContent && r.some(function(A) {
                                                return e.textContent.includes(A);
                                            }) && (e.textContent = e.textContent.replace(t, "#000"));
                                        }), A.querySelectorAll("*")), o = [
                                            "color",
                                            "backgroundColor",
                                            "background",
                                            "borderColor",
                                            "borderTopColor",
                                            "borderRightColor",
                                            "borderBottomColor",
                                            "borderLeftColor",
                                            "border",
                                            "outlineColor",
                                            "textDecorationColor",
                                            "caretColor",
                                            "columnRuleColor",
                                            "fill",
                                            "stroke"
                                        ];
                                        e.forEach(function(A) {
                                            var t = A, n = t.style, e = (o.forEach(function(A) {
                                                try {
                                                    var e = n.getPropertyValue(A);
                                                    e && r.some(function(A) {
                                                        return e.includes(A);
                                                    }) && n.setProperty(A, "", "important");
                                                } catch (A) {}
                                            }), t.getAttribute("style"));
                                            e && r.some(function(A) {
                                                return e.includes(A);
                                            }) && (A = e.split(";").filter(function(A) {
                                                var e = A.trim();
                                                return e && !r.some(function(A) {
                                                    return e.includes(A);
                                                });
                                            }), t.setAttribute("style", A.join(";"))), "svg" !== t.tagName.toLowerCase() && !t.closest("svg") || [
                                                "fill",
                                                "stroke"
                                            ].forEach(function(A) {
                                                var e = t.getAttribute(A);
                                                e && r.some(function(A) {
                                                    return e.includes(A);
                                                }) && t.setAttribute(A, "#000");
                                            });
                                        }), A.querySelectorAll("img").forEach(function(A) {
                                            var e = A.src;
                                            !e || e.startsWith(window.location.origin) || e.startsWith("data:") || A.remove();
                                        });
                                    } catch (A) {}
                                }
                            }, e)))
                        ];
                    case 1:
                        i = A.sent();
                        try {
                            return [
                                2,
                                i.toDataURL(a, r)
                            ];
                        } catch (A) {
                            try {
                                return [
                                    2,
                                    i.toDataURL("image/png", r)
                                ];
                            } catch (A) {
                                return [
                                    2,
                                    A
                                ];
                            }
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        return [
                            2,
                            A.sent()
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
                var e;
            });
        });
    }
    var UB = function(A) {
        var e = A.nodeName.toLowerCase();
        return A.id ? e + "#" + A.id : A.className && "string" == typeof A.className ? e + "." + A.className.split(" ").filter(function(A) {
            return !!A;
        }).join(".") : e;
    }, FB = function(A) {
        for(var e = [], t = 1; t < arguments.length; t++)e[t - 1] = arguments[t];
        if (!e.length) return A;
        var n, r = e.shift();
        for(n in r)"object" == typeof r[n] && null !== r[n] && A.hasOwnProperty(n) && "object" == typeof A[n] && null !== A[n] ? FB(A[n], r[n]) : A[n] = r[n];
        return FB.apply(void 0, M([
            A
        ], e));
    }, C = new t({
        name: "blankScreen",
        captureScreenshotWithStrategy: function() {
            return z(this, void 0, void 0, function() {
                var r, o, i, s, a, c;
                return $(this, function(A) {
                    switch(A.label){
                        case 0:
                            return A.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]), r = window.innerWidth, r = r * window.innerHeight, o = Date.now(), [
                                4,
                                CB()
                            ];
                        case 1:
                            return c = A.sent(), a = Date.now() - o, "object" == typeof c && null !== c ? [
                                2,
                                {
                                    error: "capture_failed",
                                    details: {
                                        firstCaptureTime: a,
                                        errorMessage: null == c ? void 0 : c.message
                                    }
                                }
                            ] : c ? !(s = (null == (i = c) ? void 0 : i.length) / 1024) || s <= 0 || !isFinite(s) ? [
                                2,
                                {
                                    error: "invalid_size",
                                    details: {
                                        reason: "screenshot_size_invalid",
                                        size: s
                                    }
                                }
                            ] : 90 < s ? [
                                2,
                                {
                                    error: "complex_page",
                                    details: {
                                        firstSize: Math.round(s),
                                        threshold: 90
                                    }
                                }
                            ] : s <= 30 ? [
                                2,
                                i
                            ] : (a = 26 / s) < .5 ? [
                                2,
                                {
                                    error: "over_compression",
                                    details: {
                                        firstSize: Math.round(s),
                                        requiredRatio: Math.round(100 * a),
                                        minRatio: Math.round(50)
                                    }
                                }
                            ] : (t = a, n = hB(e = r).defaultQuality, e = e <= dB.THRESHOLDS.SMALL ? .25 : .3, c = Math.max(e, n * t), [
                                4,
                                CB(c)
                            ]) : [
                                2,
                                {
                                    error: "capture_failed",
                                    details: {
                                        reason: "empty_result"
                                    }
                                }
                            ];
                        case 2:
                            return "object" == typeof (a = A.sent()) && null !== a ? [
                                2,
                                {
                                    error: "retry_capture_failed",
                                    details: {
                                        firstSize: Math.round(s),
                                        errorMessage: null == a ? void 0 : a.message
                                    }
                                }
                            ] : (i = a) ? i && (null == i ? void 0 : i.length) <= 30720 ? [
                                2,
                                i
                            ] : [
                                2,
                                {
                                    error: "retry_failed",
                                    details: {
                                        firstSize: Math.round(s),
                                        finalSize: i ? Math.round((null == i ? void 0 : i.length) / 1024) : 0,
                                        maxSize: 30
                                    }
                                }
                            ] : [
                                2,
                                {
                                    error: "retry_capture_failed",
                                    details: {
                                        reason: "empty_result"
                                    }
                                }
                            ];
                        case 3:
                            return [
                                2,
                                {
                                    error: "exception",
                                    details: {
                                        message: (c = A.sent()) instanceof Error ? c.message : String(c),
                                        stack: c instanceof Error ? c.stack : void 0
                                    }
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                    var e, t, n;
                });
            });
        },
        onNewAegis: function(S) {
            var T, O, A, x, e, D, R, M, t, P, k, G, N, V, X, J, W, n, _, Y, r, o, Z, i, s, a, c, B, l, u, Q, g, w, d, h, f = this;
            document.elementFromPoint && (A = QB(S), x = A.everySideSampleNumber, e = A.sameElementsPercent, D = A.containers, R = A.ignoreContainers, M = A.detectStartPosition, t = A.ignoreElesWhenDomChange, P = A.reDetectInterval, k = A.disableSameElementsCheck, G = A.samePointDepth, N = A.enableScreenshot, V = A.needScreenShotMeta, X = 4 * x - 3, J = Math.floor(X * A.emptyElementsPercent / 100), W = Math.floor(X * e / 100), n = rn.UNKNOWN, Y = null, r = _ = !1, o = function() {
                return z(f, void 0, void 0, function() {
                    var r, o, i, s, a, c, B, l, u, g, w, d, h, f, Q, p, C, U, F, m, y, E, H, v, I, b, L, K = this;
                    return $(this, function(A) {
                        switch(A.label){
                            case 0:
                                if (r = window.innerHeight, o = window.innerWidth, i = M.x, s = M.y, o <= i || r <= s) return [
                                    2
                                ];
                                for(a = i + (o - i) / 2, c = s + (r - s) / 2, B = [], l = x + 1, g = u = 0, w = 1; w < l; w++)f = s + (r - s) * w / l, p = pB(d = i + (o - i) * w / l, c), h = pB(a, f), Q = pB(d, f), d = pB(d, r - f), f = fB(p, D, R), f.isWhitePoint && (u += 1), B.push(f.selectorPointers), w !== l / 2 && (p = fB(h, D, R), f = p.isWhitePoint, h = p.selectorPointers, f && (u += 1), p = fB(Q, D, R), f = p.isWhitePoint, Q = p.selectorPointers, f && (u += 1), p = fB(d, D, R), p.isWhitePoint && (u += 1), B.push(h, Q, p.selectorPointers));
                                return E = J <= u, H = !1, C = {
                                    samePointerMap: {},
                                    maximumSamePointer: {}
                                }, k || (y = B.map(function(A) {
                                    return A.slice(0, G);
                                }), e = y.map(function(A) {
                                    return A.join(" < ");
                                }).reduce(function(A, e) {
                                    return A[e] = A[e] ? A[e] + 1 : 1, A;
                                }, {}), t = Object.keys(e).map(function(A) {
                                    return [
                                        A,
                                        e[A]
                                    ];
                                }).sort(function(A, e) {
                                    return e[1] - A[1];
                                })[0], n = t[0], y = {
                                    samePointerMap: e,
                                    maximumSamePointerClass: n,
                                    maximumSamePointerCounter: t[1]
                                }, C = {
                                    samePointerMap: y.samePointerMap,
                                    maximumSamePointer: ((L = {})[U = y.maximumSamePointerClass] = y = y.maximumSamePointerCounter, L)
                                }, g = y, L = sn.some(function(A) {
                                    return U.startsWith(A);
                                }), H = W <= y && !L), E || H ? [
                                    3,
                                    1
                                ] : (_ = !1, Y = null, [
                                    3,
                                    5
                                ]);
                            case 1:
                                return _ ? (m = F = null, N ? [
                                    4,
                                    this.captureScreenshotWithStrategy()
                                ] : [
                                    3,
                                    3
                                ]) : [
                                    3,
                                    4
                                ];
                            case 2:
                                m = "string" == typeof (y = A.sent()) ? (F = y, {
                                    success: !0
                                }) : (F = null, {
                                    success: !1,
                                    error: y.error,
                                    details: y.details
                                }), A.label = 3;
                            case 3:
                                return L = (null == Y ? void 0 : Y.whitePointCount) >= J, E = (null == Y ? void 0 : Y.samePointCount) >= W, H = L && E ? "both" : L ? "whitePoint" : "sameElement", v = window.innerWidth, I = window.innerHeight, b = Math.round((null == Y ? void 0 : Y.samePointCount) / X * 100), b = {
                                    msg: "decect blankscreen triggerReason: " + H + " triggerType: " + (T ? "error" : "domChange") + "\n\nwhitePointCount: " + (null == Y ? void 0 : Y.whitePointCount) + " whitePointerThreshold: " + J + (k ? "" : "\n\nsameElementsCount: " + (null == Y ? void 0 : Y.samePointCount) + " samePointerThreshold: " + W + " sameElementPercent: " + b + "%") + "\n\nviewport: " + v + "x" + I + " totalSamplePoints: " + X + (k ? "" : "\n\nmaxSameElement: " + hA(null == Y ? void 0 : Y.maximumSamePointer)) + (V && N ? "\n\nscreenShotMeta: " + JSON.stringify(m) : "") + (null != Y && Y.linkMsg ? "\n\nlinkError: " + Y.linkMsg : ""),
                                    level: j.BLANK_SCREEN,
                                    errorMsg: F || null,
                                    originFrom: S.getOriginFrom()
                                }, S.normalLogPipeline(b), _ = !1, Y = null, [
                                    3,
                                    5
                                ];
                            case 4:
                                Y = q(q({
                                    msg: "blank_screen",
                                    level: j.BLANK_SCREEN,
                                    whitePointCount: u,
                                    samePointCount: g
                                }, C), T ? {
                                    linkLogType: null == T ? void 0 : T.type,
                                    linkLogLevel: null == T ? void 0 : T.level,
                                    linkErrorMsg: null == T ? void 0 : T.errorMsg,
                                    linkMsg: null == T ? void 0 : T.msg
                                } : {}), _ = !0, O = setTimeout(function() {
                                    return z(K, void 0, void 0, function() {
                                        return $(this, function(A) {
                                            switch(A.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        Z()
                                                    ];
                                                case 1:
                                                    return A.sent(), [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                }, P), A.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                        var e, t, n;
                    });
                });
            }, Z = function() {
                return z(f, void 0, void 0, function() {
                    var t = this;
                    return $(this, function(A) {
                        switch(A.label){
                            case 0:
                                return "requestIdleCallback" in window ? (window.requestIdleCallback(function(e) {
                                    return z(t, void 0, void 0, function() {
                                        return $(this, function(A) {
                                            switch(A.label){
                                                case 0:
                                                    return 0 < e.timeRemaining() ? [
                                                        4,
                                                        o()
                                                    ] : [
                                                        3,
                                                        2
                                                    ];
                                                case 1:
                                                    A.sent(), A.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                }), [
                                    3,
                                    3
                                ]) : [
                                    3,
                                    1
                                ];
                            case 1:
                                return [
                                    4,
                                    o()
                                ];
                            case 2:
                                A.sent(), A.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }, i = function() {
                var A;
                _ || n === rn.ERROR && !T || (n = T ? rn.ERROR : rn.DOM_CHANGE, clearTimeout(O), A = QB(S).debounceDuration, O = setTimeout(function() {
                    return z(f, void 0, void 0, function() {
                        return $(this, function(A) {
                            switch(A.label){
                                case 0:
                                    return clearTimeout(O), [
                                        4,
                                        Z()
                                    ];
                                case 1:
                                    return A.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }, A));
            }, S.lifeCycle.on("errorOccurred", s = function(A) {
                A = A.filter(function(A) {
                    return A.level !== j.BLANK_SCREEN;
                });
                0 < A.length && (T = A[A.length - 1], i());
            }), a = null, window.MutationObserver && (g = w = null, c = window.cancelAnimationFrame || function(A) {
                clearTimeout(A);
            }, B = window.requestAnimationFrame || function(A) {
                return setTimeout(A, 1e3 / 60);
            }, l = function() {
                (a = new MutationObserver(function(A) {
                    var e = t.includes(UB(A[0].target));
                    1 === A.length && e || i();
                })).observe(document.body, {
                    childList: !0,
                    subtree: !0
                });
            }, u = function() {
                w && (clearTimeout(w), w = null), g && (c(g), g = null);
            }, document.body ? l() : (g = B(Q = function() {
                document.body ? (u(), l()) : g = B(Q);
            }), w = setTimeout(function() {
                u();
            }, 1e4))), d = function() {
                r && (r = !0, _) && (clearTimeout(O), o());
            }, h = function() {
                "visible" === document.visibilityState && (r = !1), "hidden" === document.visibilityState && d();
            }, window.addEventListener("pagehide", d), window.addEventListener("beforeunload", d), window.addEventListener("visibilitychange", h), this.destroyBlanckScreenDetect = function() {
                window.removeEventListener("pagehide", d), window.removeEventListener("beforeunload", d), window.removeEventListener("visibilitychange", h), S.lifeCycle.remove("errorOccurred", s), null != a && a.disconnect();
            });
        },
        destroy: function() {
            this.destroyBlanckScreenDetect();
        }
    }), mB = (new t({
        name: "lagMonitor"
    }), new t({
        name: "lagMonitor",
        observer: null,
        lagRecords: [],
        onNewAegis: function(A) {
            var e, t = this.$getConfig(A);
            t && t.enabled && "undefined" != typeof PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame") && (e = t.sampleRate || 1, Math.random() < e) && this.initLagMonitor(A, t);
        },
        initLagMonitor: function(t, A) {
            var n = this, r = A.threshold || 2e3, o = A.noResponseThreshold || 5e3;
            try {
                this.observer = new PerformanceObserver(function(A) {
                    A.getEntries().forEach(function(A) {
                        var e;
                        A.duration > r && (e = A.scripts && 0 < A.scripts.length ? A.scripts[0] : null, A = {
                            name: A.name,
                            timestamp: Date.now(),
                            entryType: A.entryType,
                            startTime: A.startTime,
                            duration: A.duration,
                            invoker: null == e ? void 0 : e.invoker,
                            sourceURL: null == e ? void 0 : e.sourceURL
                        }, n.lagRecords.push(A), 100 < n.lagRecords.length && n.lagRecords.shift(), n.publishLagLog(A, t, o <= A.duration));
                    });
                }), this.observer.observe({
                    type: "long-animation-frame",
                    buffered: !1
                }), "undefined" != typeof window && (window.__longTasks = this.lagRecords);
            } catch (t) {
                if ("undefined" != typeof console && console.warn && console.warn("Lag monitor initialization failed:", t), this.observer) {
                    try {
                        this.observer.disconnect();
                    } catch (t) {}
                    this.observer = null;
                }
            }
        },
        publishLagLog: function(t, n, r) {
            void 0 === r && (r = !1);
            try {
                this.$walk(function(A) {
                    if (A === n) {
                        var e = {
                            msg: JSON.stringify({
                                type: r ? "NORESPONSE_DETECTED" : "LAG_DETECTED",
                                duration: Math.round(100 * t.duration) / 100,
                                startTime: Math.round(100 * t.startTime) / 100,
                                entryType: t.entryType,
                                sourceURL: t.sourceURL || "unknown",
                                invoker: t.invoker || "unknown",
                                timestamp: t.timestamp
                            }),
                            level: r ? j.NORESPONSE_LOG : j.LAG_MONITOR,
                            time: t.timestamp,
                            originFrom: A.getOriginFrom()
                        };
                        try {
                            A.normalLogPipeline(e);
                        } catch (A) {
                            "undefined" != typeof console && console.warn && console.warn("Lag log pipeline failed:", A);
                        }
                    }
                });
            } catch (t) {
                "undefined" != typeof console && console.warn && console.warn("Lag log publish failed:", t);
            }
        },
        getLagRecords: function() {
            return M(this.lagRecords);
        },
        clearLagRecords: function() {
            this.lagRecords.length = 0, "undefined" != typeof window && (window.__longTasks = []);
        },
        destroy: function() {
            if (this.observer) {
                try {
                    this.observer.disconnect();
                } catch (A) {
                    "undefined" != typeof console && console.warn && console.warn("Observer disconnect failed:", A);
                }
                this.observer = null;
            }
            this.clearLagRecords();
        }
    }));
    function yB() {
        try {
            return "undefined" != typeof window && window.performance && window.performance.memory && "number" == typeof window.performance.memory.usedJSHeapSize;
        } catch (A) {}
    }
    function EB() {
        try {
            var A, e, t;
            return yB() ? (e = (A = window.performance.memory).usedJSHeapSize || 0, t = A.jsHeapSizeLimit || 0, {
                usedJSHeapSize: e,
                totalJSHeapSize: A.totalJSHeapSize || 0,
                jsHeapSizeLimit: t,
                usageRatio: 0 < t ? Math.round(e / t * 1e4) / 100 : 0,
                timestamp: Date.now()
            }) : null;
        } catch (A) {
            return null;
        }
    }
    function HB(A) {
        return Math.round(A / 1048576 * 100) / 100;
    }
    new t({
        name: "memoryMonitor"
    });
    i = new t({
        name: "memoryMonitor",
        memoryReportTimer: null,
        oomCheckTimer: null,
        lastOOMTime: 0,
        memoryRecords: [],
        onNewAegis: function(A) {
            var e, t, n = this.$getConfig(A);
            n && n.enabled && yB() && (e = n.sampleRate || 1, Math.random() < e) && (!(e = n.monitorPages) || 0 === e.length || (t = "undefined" != typeof window ? window.location.href : "", e.some(function(A) {
                return "string" == typeof A ? t.includes(A) : A instanceof RegExp && A.test(t);
            }))) && this.initMemoryMonitor(A, n);
        },
        initMemoryMonitor: function(A, e) {
            var t, n = this, r = !1 !== e.enableMemoryReport, o = !1 !== e.enableOOMReport, i = e.memoryReportInterval || 6e4, s = e.oomCheckInterval || 1e4, a = e.oomThreshold || (()=>{
                try {
                    var A, e;
                    return yB() ? 0 < (A = window.performance.memory.jsHeapSizeLimit || 0) ? (e = HB(A), Math.round(.9 * e)) : 100 : 100;
                } catch (A) {
                    return 100;
                }
            })();
            try {
                r && (this.memoryReportTimer = setInterval(function() {
                    n.reportCurrentMemory(A, "MEMORY_REPORT");
                }, i)), o && (this.oomCheckTimer = setInterval(function() {
                    n.checkOOMCondition(A, a);
                }, s)), "undefined" != typeof window && (window.addEventListener("beforeunload", t = function() {
                    n.cleanup();
                }), window.addEventListener("pagehide", t));
            } catch (A) {
                "undefined" != typeof console && console.warn && console.warn("Memory monitor initialization failed:", A), this.cleanup();
            }
        },
        reportCurrentMemory: function(A, e) {
            try {
                var t, n = EB();
                n && (t = {
                    type: e,
                    memoryInfo: n,
                    url: "undefined" != typeof window ? window.location.href : "",
                    userAgent: "undefined" != typeof navigator ? navigator.userAgent : "",
                    timestamp: Date.now()
                }, this.memoryRecords.push(t), 50 < this.memoryRecords.length && this.memoryRecords.shift(), this.publishMemoryLog(t, A));
            } catch (A) {
                "undefined" != typeof console && console.warn && console.warn("Memory report failed:", A);
            }
        },
        checkOOMCondition: function(A, e) {
            try {
                var t, n, r = EB();
                r && (t = HB(r.usedJSHeapSize), n = Date.now(), e < t) && 3e5 < n - this.lastOOMTime && (this.lastOOMTime = n, this.reportCurrentMemory(A, "MEMORY_OOM"));
            } catch (A) {
                "undefined" != typeof console && console.warn && console.warn("OOM check failed:", A);
            }
        },
        publishMemoryLog: function(A, e) {
            try {
                "MEMORY_REPORT" === A.type ? this.publishMemoryReport(A, e) : "MEMORY_OOM" === A.type && this.publishOOMLog(A, e);
            } catch (A) {
                "undefined" != typeof console && console.warn && console.warn("Memory log publish failed:", A);
            }
        },
        publishMemoryReport: function(A, e) {
            try {
                var t = {
                    memoryUsed: A.memoryInfo.usedJSHeapSize,
                    memoryAllocated: A.memoryInfo.totalJSHeapSize,
                    memoryUsage: A.memoryInfo.usageRatio
                };
                this.$walk(function(r) {
                    var A;
                    if (r === e) try {
                        null != (A = r.sendPipeline) && A.call(r, [
                            function(t, A) {
                                var e = r.config.memoryUrl || r.config.hostUrl + "/memory", n = new URLSearchParams;
                                Object.keys(t).forEach(function(A) {
                                    var e = t[A];
                                    null != e && "" !== e && n.append(A, String(e));
                                }), A({
                                    url: e + "?" + n.toString(),
                                    method: "post",
                                    type: d.MEMORY,
                                    log: t,
                                    success: function() {
                                        "undefined" != typeof console && console.debug && console.debug("Memory report success:", t.memory_used, "bytes");
                                    },
                                    fail: function(A) {
                                        "undefined" != typeof console && console.warn && console.warn("Memory report failed:", A);
                                    }
                                });
                            }
                        ], d.MEMORY)(t);
                    } catch (r) {
                        "undefined" != typeof console && console.warn && console.warn("Memory pipeline failed:", r);
                    }
                });
            } catch (A) {
                "undefined" != typeof console && console.warn && console.warn("Memory report publish failed:", A);
            }
        },
        publishOOMLog: function(A, t) {
            try {
                var e = A.memoryInfo, n = "Memory OOM detected: Used " + HB(e.usedJSHeapSize) + "MB / Total " + HB(e.totalJSHeapSize) + "MB / Limit " + HB(e.jsHeapSizeLimit) + "MB (" + e.usageRatio + "%)", r = {
                    msg: n,
                    level: j.MEMORY_OOM,
                    time: A.timestamp,
                    originFrom: t.getOriginFrom()
                };
                this.$walk(function(A) {
                    var e;
                    if (A === t) try {
                        null != (e = A.normalLogPipeline) && e.call(A, r), "undefined" != typeof console && console.warn && console.warn("OOM detected and reported:", n);
                    } catch (A) {
                        "undefined" != typeof console && console.warn && console.warn("OOM pipeline failed:", A);
                    }
                });
            } catch (A) {
                "undefined" != typeof console && console.warn && console.warn("OOM log publish failed:", A);
            }
        },
        getMemoryRecords: function() {
            return M(this.memoryRecords);
        },
        getCurrentMemoryStatus: EB,
        clearMemoryRecords: function() {
            this.memoryRecords.length = 0;
        },
        cleanup: function() {
            this.memoryReportTimer && (clearInterval(this.memoryReportTimer), this.memoryReportTimer = null), this.oomCheckTimer && (clearInterval(this.oomCheckTimer), this.oomCheckTimer = null);
        },
        destroy: function() {
            this.cleanup(), this.clearMemoryRecords(), this.lastOOMTime = 0;
        }
    });
    return A.use(ke), A.use(Se), A.use(ZA), A.use(zt), A.use(Zt), A.use(_A), A.use(n), A.use(An), A.use(nn), A.use(Je), A.use(_e), A.use(mB), A.use(i), A.use(Oe), A.use(C), A;
});

//# sourceMappingURL=index-1.b7fe6663.js.map
